/* tslint:disable */

// ====================================================
// START: Typescript template
// ====================================================

// ====================================================
// Scalars
// ====================================================

/** A type representing a formatted java.util.UUID */
export type Uuid = any;

/** A type representing a Locale such as en_US or fr_FR */
export type Locale = any;

/** A type representing a full protocol, host and path */
export type Url = any;

/** Built-in java.math.BigDecimal */
export type BigDecimal = any;

// ====================================================
// InputTypes
// ====================================================

/** The input BEX context used for identifying users, sites and other platform functions */
export interface ContextInput {
  /** Information regarding the application which triggered the query */
  clientInfo?: ClientInfoInput | null;
  /** Currency as Alphabetic ISO 4217 code e.g. 'USD'. Use if default currency for Locale needs to be overwritten. */
  currency?: string | null;
  /** Debugging context, such as Abacus overrides */
  debugContext?: DebugContextInput | null;
  /** Client/user Device information */
  device: DeviceInput;
  /** The Expedia Affiliate Partner ID */
  eapid?: number | null;
  /** DEPRECATED: Optional Client/user information. Used for input only. Please send the DUIAD header instead.We no longer rely on identity for user determination.User determination is now based upon passed headers. Soon this will be made nullable and later removed.Will be replaced by JWTs when available. */
  identity?: IdentityInput | null;
  /** The context locale, e.g. en_US */
  locale: Locale;
  /** User preference for tracking which is only required in POSs that require tracking opt in */
  privacyTrackingState?: PrivacyTrackingState | null;
  /** The context Site ID, e.g. (70201 for Orbitz) */
  siteId: number;
}
/** Describe which application is invoking bex api */
export interface ClientInfoInput {
  /** Name of the application */
  name: string;
  /** Version of the application eg:18.10 or 5fbc9958 */
  version?: string | null;
}
/** Context used for debugging purposes, such as overriding Abacus experiments */
export interface DebugContextInput {
  /** Abacus exposure overrides to be applied */
  abacusOverrides: ExposureInput[];
  /** ALTER mode */
  alterMode?: AlterMode | null;
}
/** An exposure to an abacus experiment */
export interface ExposureInput {
  /** The experiment bucket of the exposure */
  bucket: number;
  /** The numeric Abacus ID for an experiment */
  id: string;
}
/** Device information */
export interface DeviceInput {
  type: DeviceType;
}
/** Identity information for a specific user or device */
export interface IdentityInput {
  /** The Expedia user authenticated state */
  authState?: AuthenticationState | null;
  /** The device ID (DUAID) */
  duaid: Uuid;
  /** The Expedia User ID */
  expUserId?: string | null;
  /** The user TUID */
  tuid?: string | null;
}
/** "The `TripItemInput` contains a tripViewId and tripItemId known by the TripDomain, plus an optional filter known to the Trips Graph.The set of supported filters is the same as defined in `TripsFilterInput` andprovides context to the Trip Item Details view for functions such as back navigation. */
export interface TripItemInput {
  filter?: string | null;

  tripItemId: string;

  tripViewId: string;
}
/** Dimensions for a presention object i.e. image or icon */
export interface DimensionsInput {
  density: number;

  height: number;

  width: number;
}
/** The `TripOverviewInput` complex type contains a `tripViewId` known by the TripDomain and an optional `filter` known by the Trips Graph Service.The tripViewId identifier is opaque to the client, it may be an EG Trip Identifier or an identifier used for Trip Sharing.The server will determine how much of the trip and which actions to return basedon the sharing rules associated with the TripViewId.The set of supported filters is the same as defined in `TripsFilterInput` andprovides context to the Trip Overview view for functions such as back navigation. */
export interface TripOverviewInput {
  filter?: string | null;

  tripViewId: string;
}
/** The `TripsFilterInput` contains a filter identifier.The set of supported filter identifiers is defined by the Trips Graph Serviceand may represent a simple filter like Upcoming or Past or an arbitrarilycomplex filter defined by an ML algorithm.See the Trips Graph team for a list of reserved values. */
export interface TripsFilterInput {
  filter: string;
}

export interface GroundTransfersSearchCriteriaInput {
  primary: PrimaryGroundTransfersCriteriaInput;

  secondary?: ShoppingSearchCriteriaInput | null;
}
/** The core criteria needed for a ground transfers or air transportation search */
export interface PrimaryGroundTransfersCriteriaInput {
  dateRange: OptionalDateTimeRangeInput;

  direction: GroundTransfersDirection;

  locations: GroundTransfersLocationInput[];

  travelerDetails: GroundTransfersTravelerDetailsInput[];
}
/** A range of dates & times, without timezone support, from a starting date & time to an ending date & time */
export interface OptionalDateTimeRangeInput {
  /** Optional terminal date & time in this range */
  end?: DateTimeInput | null;
  /** Optional starting date & time in this range */
  start?: DateTimeInput | null;
}
/** A common date time, if you need to include timezone information, please use ZonedDateTime */
export interface DateTimeInput {
  /** The day of the month of the date */
  day: number;
  /** The hour of the datetime */
  hour: number;
  /** The minute of the hour */
  minute: number;
  /** The numeric month of the date */
  month: number;
  /** The second of the minute */
  second: number;
  /** The four-digit year of the date */
  year: number;
}
/** Provides the ground transfers location information for destination, airport and hotel */
export interface GroundTransfersLocationInput {
  coordinates?: CoordinatesInput | null;

  id?: string | null;

  name?: string | null;

  type: GeoType;
}

export interface CoordinatesInput {
  /** The latitude of the point in degrees */
  latitude: number;
  /** The longitude of the point in degrees */
  longitude: number;
}
/** Represents the traveler details */
export interface GroundTransfersTravelerDetailsInput {
  count: number;

  type: GroundTransfersTravelerDetailsType;
}
/** Key/Value elements that describes the search criteria often displayed to the customer as filters */
export interface ShoppingSearchCriteriaInput {
  booleans?: BooleanValueInput[] | null;

  counts?: NumberValueInput[] | null;

  dates?: DateValueInput[] | null;

  ranges?: RangeValueInput[] | null;

  selections?: SelectedValueInput[] | null;
}
/** Type used during a product search to specify a given boolean value like the factcustomer would prefer to search for direct flights only. */
export interface BooleanValueInput {
  id: string;

  value: boolean;
}
/** Type used during a product search to specify a given numeric value like the number of stars for a hotel. */
export interface NumberValueInput {
  id: string;

  value: number;
}
/** Type used during a product search to specify a given date. Usually this datewould not be a core search criteria like a departure day for a flight. */
export interface DateValueInput {
  id: string;

  value: DateInput;
}
/** A common date object */
export interface DateInput {
  /** The day of the month, e.g. `1` for the 1st */
  day: number;
  /** The numeric month, e.g. `1` for January */
  month: number;
  /** The four-digit year e.g. `1999` */
  year: number;
}
/** Type used during a product search to specify a given numeric range like theprice of a hotel should be between 100 and 200 (USD). */
export interface RangeValueInput {
  id: string;

  max: number;

  min: number;
}
/** Type used during a product search to specify a given selection like the airline the customer would like to fly with. */
export interface SelectedValueInput {
  id: string;

  value: string;
}

export interface InsuranceShoppingRequestInput {
  /** Country code of user's residency - to be passed if akamai headers not present */
  countryCode?: string | null;
  /** Region code of user's residency - to be passed if akamai headers not present */
  regionCode?: string | null;
  /** TripId */
  tripId: Uuid;
  /** In order to ignore the caching at client level and make an actual shoppingcall version hash is changed in subsequent requests */
  versionHash?: string | null;
}

export interface InsuranceDetailPrimingRequestInput {
  /** Car request for insurance priming */
  carRequest: InsuranceDetailPrimingForCarInput;
}

export interface InsuranceDetailPrimingForCarInput {
  /** Identifier token for car inventory */
  carOfferToken: string;
  /** Encoded string having certain offer information shown on search page. Eg. priceShown, avg category price */
  continuationContextualId?: string | null;
  /** Drop-off location for car */
  dropOffLocation?: InsuranceLocationInput | null;
  /** Pick-up location for car */
  pickUpLocation: InsuranceLocationInput;
  /** Reward point selection on  Car offer */
  rewardPointsSelection?: InsuranceRewardsPointSelectionEnum | null;
  /** List of accessories added with Car */
  selectedAccessories?: string[] | null;
}

export interface InsuranceLocationInput {
  /** Region id */
  regionId: string;
  /** Search term */
  searchTerm: string;
}

export interface ActivityDateRangeInput {
  endDate: DateInput;

  startDate: DateInput;
}
/** Activity search region information */
export interface ActivityDestinationInput {
  /** Coordinates of the region, used for region (city or multicity) resolution */
  coordinates?: CoordinatesInput | null;
  /** activity id proposed for pinning on LX-SRP */
  pinnedActivityId?: string | null;
  /** activity id passed as a reference for activity recommendations on LX-IS */
  referencedActivityId?: string | null;
  /** Gaia region ID of the search */
  regionId?: string | null;
  /** Name of the region, used for fuzzy resolution */
  regionName?: string | null;
  /** Gaia Region Type denoted by regionId, example HOTEL OR CITY */
  regionType?: string | null;
}
/** Activity marketing information to identify sem/seo traffic */
export interface ActivityMarketingInfoInput {
  /** Marketing channel type code. */
  mctc?: number | null;
  /** field which identifies sem channel */
  sem?: string | null;
  /** field which identifies semdtl value */
  semdtl?: string | null;
}

export interface ActivityOfferFilterInput {
  selections?: ActivitySelectedValueInput[] | null;

  tickets?: ActivityTicketInput[] | null;
}

export interface ActivitySelectedValueInput {
  id: string;

  value: string;
}

export interface ActivityTicketInput {
  code: string;

  count: number;
}
/** Separate a large list of results into multiple sublists */
export interface PaginationInput {
  /** Number of results to get past the starting index */
  size?: number | null;
  /** The inclusive 0-based starting index of the results. Defaults to 0 */
  startingIndex?: number | null;
}
/** Activity search filtering options */
export interface ActivitySearchFiltersInput {
  /** Filter results by user selected activity id from ESS activity Typeahead Suggestions. */
  activityId?: string | null;
  /** Filter results by activity category, supported with legacy categories */
  categories?: ActivityCategory[] | null;
  /** Filter results by activity category keys, supported with nested categories */
  categoryKeys?: string[] | null;
  /** Filter results by user provided free text search keyword */
  keyword?: string | null;
  /** Filter results by user regionId to support neighborhood filters */
  regionId?: string | null;
  /** Value selected by the userE.g.1. 'sort':'RECOMMENDED'2. 'slimSearchKeyword':'<KEYWORD ENTERED BY USER>'4. 'categories': 'ToursSightseeing' */
  selections?: ActivitySelectedValueInput[] | null;
}
/** Input argument for Request Context */
export interface ClientRequestInput {
  /** Headers of HTTP Request */
  headers: HttpHeaderInput[];
  /** Remote address of HTTP Request */
  remoteAddress: string;
  /** URL of HTTP Request */
  url: string;
}

export interface HttpHeaderInput {
  name: string;

  values: string[];
}
/** All criteria needed for a multi-item search */
export interface MultiItemSearchContextInput {
  cars?: CarSearchCriteriaInput[] | null;

  flights?: FlightSearchCriteriaInput[] | null;

  properties?: PropertySearchCriteriaInput[] | null;
}
/** Car criteria needed to perform a car search */
export interface CarSearchCriteriaInput {
  primary: PrimaryCarCriteriaInput;

  secondary?: ShoppingSearchCriteriaInput | null;
}
/** The core criteria needed for a car search */
export interface PrimaryCarCriteriaInput {
  dropOffDateTime: DateTimeInput;

  dropOffLocation?: CarRentalLocationInput | null;

  pickUpDateTime: DateTimeInput;

  pickUpLocation: CarRentalLocationInput;
}
/** Provides the car rental location information */
export interface CarRentalLocationInput {
  airportCode?: string | null;

  coordinates?: CoordinatesInput | null;

  regionId?: string | null;

  searchTerm?: string | null;
}
/** All criteria needed to perform a flight search */
export interface FlightSearchCriteriaInput {
  primary: PrimaryFlightCriteriaInput;

  secondary?: ShoppingSearchCriteriaInput | null;
}
/** Represents the core criteria needed for a flight search */
export interface PrimaryFlightCriteriaInput {
  journeyCriterias: FlightsJourneyCriteriaInput[];

  searchPreferences?: FlightsSearchPreferencesInput | null;

  travelers: TravelerDetailsInput[];

  tripType: FlightsTripType;
}
/** The input object for flights search */
export interface FlightsJourneyCriteriaInput {
  /** Arrival date of the flight */
  arrivalDate?: DateInput | null;
  /** Departure date of the flight */
  departureDate: DateInput;
  /** Three letter code of the destination airport */
  destination: string;
  /** # Deprecated: Please use cabinClass in FlightsSearchPreferences */
  flightsCabinClass?: FlightsCabinClass | null;
  /** Three letter code of the origin airport */
  origin: string;
}
/** Primary flights criteria part of the search wizard that have an impact on thefirst results set.It's different from the side filter part of the secondarysearch criteria that are filtering on top of it. The side filter should be usinga server driven approach. */
export interface FlightsSearchPreferencesInput {
  /** Advanced filters like non-stop, refundable */
  advancedFilters?: FlightsAdvancedFilterType[] | null;

  airline?: string | null;

  cabinClass: FlightsCabinClass;
}
/** Represents the traveler details */
export interface TravelerDetailsInput {
  age?: number | null;

  type: TravelerDetailsType;
}
/** Property criteria needed to perform a property search */
export interface PropertySearchCriteriaInput {
  primary: PrimaryPropertyCriteriaInput;

  secondary?: ShoppingSearchCriteriaInput | null;
}
/** The core criteria needed for a property search */
export interface PrimaryPropertyCriteriaInput {
  dateRange?: PropertyDateRangeInput | null;

  destination: DestinationInput;

  rooms: RoomInput[];
}

export interface PropertyDateRangeInput {
  checkInDate: DateInput;

  checkOutDate: DateInput;
}
/** Contains detailed geographic information like the Gaia region id as well as theproperty ids in the region for the property destination */
export interface DestinationInput {
  /** The Geo location of the region to search */
  coordinates?: CoordinatesInput | null;
  /** The property ID to use for region resolution (pinned search). */
  pinnedPropertyId?: string | null;
  /** List of property IDs to return search information for. */
  propertyIds?: string[] | null;
  /** The Gaia region ID of the search */
  regionId?: string | null;
  /** The name of the region ID, used for fuzzy resolution */
  regionName?: string | null;
}
/** A single hotel room configuration */
export interface RoomInput {
  /** The number of adult in the room */
  adults: number;
  /** The number of children in the room */
  children?: ChildInput[] | null;
}
/** A guest over the age of 2 */
export interface ChildInput {
  /** The child's age in years */
  age: number;
}
/** All natural keys for the products that the customer has already selected on the shopping path */
export interface MultiItemProductsInput {
  activities?: ActivityNaturalKeyInput[] | null;

  cars?: CarNaturalKeyInput[] | null;

  flights?: FlightNaturalKeyInput[] | null;

  properties?: PropertyNaturalKeyInput[] | null;
}
/** Minimum set of data used to retrieve details about an activity product */
export interface ActivityNaturalKeyInput {
  offerToken: string;

  productToken: string;
}
/** Minimum set of data used to retrieve details about a car product */
export interface CarNaturalKeyInput {
  offerToken: string;

  specialEquipments?: SpecialEquipment[] | null;
}
/** Minimum set of data used to retrieve details about a flight product */
export interface FlightNaturalKeyInput {
  offerToken: string;

  productTokens: string[];

  travelers: TravelerDetailsInput[];
}
/** Minimum set of data used to retrieve details about a property product */
export interface PropertyNaturalKeyInput {
  checkIn: DateInput;

  checkOut: DateInput;

  id: string;

  inventoryType: InventoryType;

  noCreditCard?: boolean | null;

  ratePlanId: string;

  ratePlanType?: string | null;

  roomTypeId: string;

  rooms: PropertyRoomInput[];

  shoppingPath?: ShoppingPathType | null;
}
/** Indicates how many rooms will be occupied and by whom */
export interface PropertyRoomInput {
  childAges: number[];

  numberOfAdults: number;
}
/** Represent the current location of the User so we can propose an origin for the flights */
export interface CrossSellUserLocationInput {
  /** The city of User's current location. ex: SANJOSE */
  city: string;
  /** The continent code of User's current location. ex: NA */
  continent: string;
  /** The country code of User's current location. ex: US */
  country: string;
  /** The region or state code of User's current location. ex: CA */
  region: string;
}
/** Represents the base product price */
export interface BrandedDealProductPriceInput {
  base: MoneyInput;

  taxesAndFees: MoneyInput;
}
/** Pricing information */
export interface MoneyInput {
  /** Numeric portion of the price */
  amount: number;
  /** The ISO 4217 3-letter code for this currency eg: USD EUR GBP ... */
  currency?: string | null;
}

export interface ShoppedProductInput {
  products: MultiItemProductsInput;

  shoppingPath: ShoppingPathType;
}
/** Contains necessary data for fetching property content */
export interface MishopDetailsUiPropertyContentPrimerInput {
  naturalKey: PropertyNaturalKeyInput;

  propertyChangeLink?: string | null;
}

export interface CarDetailContextInput {
  carOfferToken: string;
  /** Encoded string having certain offer information shown on search page. Eg. priceShown, avg category price */
  continuationContextualId?: string | null;

  rewardPointsSelection?: RewardsPointSelectionEnum | null;

  selectedAccessories?: string[] | null;
}
/** The shopping context used for all search paths, contains the search contexts for the different shopping paths */
export interface ShoppingContextInput {
  multiItem?: MultiItemContextInput | null;
}
/** The multi-item context used for package searches, contains information neededfor package searches and retrieving package sessions */
export interface MultiItemContextInput {
  /** The multi-item session id used to retrieve the customers package search criteria and selected products */
  id: string;
  /** The package type for this search */
  packageType: PackageType;
}

export interface CruiseRequestContextInput {
  /** Cruise features enum to be passed down to cruise supply services as a header value */
  cruiseFeatures?: CruiseFeature[] | null;
  /** Default current to be used. If not set, cruise api will fall back to USD */
  defaultCurrency?: string | null;
  /** Inventory is striped by an optional franchise model key. More info here: https://confluence.expedia.biz/display/EWECruise/Design%3A+Franchise+Model+Key+Management */
  franchiseModelKey?: string | null;
  /** Flag that is set when the user is shopping as an agent from Partner Central */
  isAgent?: boolean | null;
}
/** Property search filtering options */
export interface PropertySearchFiltersInput {
  /** Filter results by available accessibility amenities. Example: [ROLL_IN_SHOWER]will return properties with a roll in shower */
  accessibility?: PropertyFilterAccessibility[] | null;
  /** Filter results by TAAP Agency business model. */
  agencyBusinessModels?: AgencyBusinessModel[] | null;
  /** Filter results by available amenities. Example: [POOL,WIFI] will return properties with a pool and wifi */
  amenities?: PropertyFilterAmenity[] | null;
  /** Filter results by the bedroom count. Only includes Vacation Rentals */
  bedroomFilter?: number[] | null;
  /** Filter results by chain id. Input supports a valid chain id */
  chain?: string | null;
  /** Filter results by property cleanliness attribute */
  cleaningAndSafetyPractices?: CleaningAndSafetyPractice[] | null;
  /** Filter results by TAAP commission tier. */
  commissionTiers?: CommissionTier[] | null;
  /** Filter results by Deals */
  deals?: DealType[] | null;
  /** Filter results by available meal plan. Example: FULL_BOARD will return properties with a full board */
  mealPlan?: MealPlanFilterAmenity[] | null;
  /** Filter results by neighborhood. Input supports a valid GAIA ID */
  neighborhood?: string | null;
  /** Filter results by the payment type. */
  paymentType?: PaymentType[] | null;
  /** Filter results by popular location. Input supports a valid coordinates combination string */
  poi?: string | null;
  /** Filter results by price. Can provide a min only, a max only, or a range. */
  price?: PriceRangeInput | null;
  /** PWA ONLY: Support for legacy PWA price buckets in the url. Use 'price' instead */
  priceBuckets?: number[] | null;
  /** Filter results by user provided string */
  propertyName?: string | null;
  /** Property syle filters */
  propertyStyles?: PropertyStyle[] | null;
  /** Filter results by average guest rating. Can provide a min only, a max only, or a range. */
  reviewScore?: ReviewScoreRangeInput | null;
  /** Rewards Type filters */
  rewards?: string[] | null;
  /** Filter results by availability */
  showAvailableOnly?: boolean | null;
  /** Filter results by property star rating. Example: 30, 50 returns properties rated 3 to 3.9 and 5 to 5.9 */
  starList?: number[] | null;
  /** Filter results by property star rating. Example: THREE returns properties rated 3.0+ */
  stars?: StarRangeInput | null;
  /** Filter results by structure type. Example: HOTEL returns properties of structure type 'HOTEL' */
  structureTypes?: StructureType[] | null;
  /** An SEM theme that needs to be passed through to other services */
  theme?: string | null;
  /** Filter results by the type of traveler. */
  travelerType?: TravelerType[] | null;
  /** Filter results by VIP only properties */
  vipOnly?: boolean | null;
}
/** Represents a range of prices for filtering properties. Follows currency rules of the user's point of sale */
export interface PriceRangeInput {
  /** The maximum price, e.g. 500.00 */
  max?: number | null;
  /** The minimum price, e.g. 50.00 */
  min?: number | null;
}
/** Represents a range of review scores for filtering properties */
export interface ReviewScoreRangeInput {
  /** The maximum review score, e.g. 5.0 */
  max?: number | null;
  /** The minimum review score, e.g. 1.0 */
  min?: number | null;
}

export interface StarRangeInput {
  max?: number | null;

  min?: number | null;
}
/** Container of all the marketing data */
export interface PropertyMarketingInfoInput {
  /** Meta affcid channel code */
  affcid?: string | null;
  /** Meta afflid channel code */
  afflid?: string | null;
  /** Meta afmcid channel code */
  afmcid?: string | null;
  /** Meta brandcid channel code */
  brandcid?: string | null;
  /** Meta emlcid channel code */
  emlcid?: string | null;
  /** Meta emldtl channel code */
  emldtl?: string | null;
  /** Meta gclid channel code */
  gclid?: string | null;
  /** Meta icmcid channel code */
  icmcid?: string | null;
  /** Meta icmdtl channel code */
  icmdtl?: string | null;
  /** Meta k_user_id channel code */
  k_user_id?: string | null;
  /** Meta kword channel code */
  kword?: string | null;
  /** Meta lnkloc channel code */
  lnkloc?: string | null;
  /** A consolidated list of marketing channels in key/value pairs.Example: [{"key": "mctc", "value": "2"}, {"key": "icmdtl", "value": "some values"}] */
  marketingChannels?: PropertyMarketingTagInput[] | null;
  /** A consolidated list of marketing prices in key/value pairs.Example: [{"key": "exp_dp", "value": "100"}, {"key": "exp_tx", "value": "10"}] */
  marketingPrices?: PropertyMarketingTagInput[] | null;
  /** Marketing Channel Type Code: Indicates traffic type, i.e. 5 for Trivago */
  mctc?: number | null;
  /** Meta mdpcid channel code */
  mdpcid?: string | null;
  /** Meta mdpdtl channel code */
  mdpdtl?: string | null;
  /** Meta olacid channel code */
  olacid?: string | null;
  /** Meta oladtl channel code */
  oladtl?: string | null;
  /** Meta semcid channel code */
  semcid?: string | null;
  /** Meta semdtl channel code */
  semdtl?: string | null;
  /** Meta seocid channel code */
  seocid?: string | null;
}
/** An object with simple key/value combination for a marketing channel or price.Example: {"key": "mctc", "value": "3"} */
export interface PropertyMarketingTagInput {
  key: string;

  value: string;
}
/** The offer details from the search results page */
export interface SearchOfferInput {
  /** The price of the search results offer */
  offerPrice?: SearchOfferPriceInput | null;

  ratePlanId?: string | null;

  roomTypeId?: string | null;
}
/** The offer price from the search results page */
export interface SearchOfferPriceInput {
  /** The encoded multi-item price token */
  multiItemPriceToken?: string | null;
  /** The timestamp of when the SRP offer price was generated */
  offerTimestamp?: string | null;
  /** The total price of the search offer */
  price?: MoneyInput | null;
}
/** Data used for travelAd click tracking */
export interface PropertyTravelAdTrackingInfoInput {
  beaconIssued?: string | null;

  candidateHmGuid?: string | null;

  position?: string | null;

  rank?: string | null;

  slots?: string | null;

  testVersionOverride?: string | null;

  trackingData: string;
}
/** [Optional] Review results filters */
export interface PropertyReviewFiltersInput {
  /** Filter review results by category */
  category?: PropertyReviewCategory | null;
  /** Include or disclude reviews that only have ratings */
  includeRatingsOnlyReviews?: boolean | null;
  /** Get reviews immediately when true (without 90 days syndication) */
  includeRecentReviews?: boolean | null;
  /** Filter reviews by specified languages by receiving lang code e.g. 'en' */
  language?: string | null;
  /** Filter review results by reviewers' locale. Example: ko_KR returns reviews made by users on Korea POSa */
  locale?: Locale | null;
  /** Filter review results by a list of review ratings */
  ratings?: number[] | null;
  /** Filter review results by review type: POSITIVE or CRITICAL */
  reviewType?: PropertyReviewType | null;
  /** Filter review results by room type */
  roomTypeId?: number | null;
  /** Filter review results by user provided keyword */
  searchTerm?: string | null;
  /** Sort reviews by Recency, high-to-low rating and low-to-high rating */
  sortRating?: string[] | null;
  /** Filter review results by travel companions */
  travelCompanion?: string[] | null;
  /** Filter reviews by tripReason and travelerCompanion depending on this list */
  travelerType?: string[] | null;
  /** Filter review results by trip reasons */
  tripReason?: string[] | null;
}
/** PWA ONLY: Input that is sent directly from the URL value. These inputs can notbe parsed on a server render of the PWA and must be converted in the spinner */
export interface LegacyPropertySearchCriteriaInput {
  /** Maps to PropertyFilterAmenity */
  amenities?: string[] | null;
  /** Maps to ReviewScoreRange */
  guestRating?: string | null;
  /** Maps to PaymentType enum to account for legacy URL values */
  paymentType?: string[] | null;
  /** List of the price buckets to use. Starts from 0 index e.g. `[0,1,2]` */
  priceBuckets?: number[] | null;
  /** User preference for tracking which is only required in POSs that require tracking opt in */
  privacyTrackingState?: PrivacyTrackingState | null;
  /** Maps to PropertySort */
  sort?: string | null;
  /** Maps to starList */
  stars?: string | null;
  /** Maps to StructureType */
  structureTypes?: string[] | null;
}
/** Property shop options; If this field is not supplied, a server default will be chosen */
export interface PropertyShopOptionsInput {
  /** Ads related property search option */
  listings?: Listings | null;
  /** Paandi redirection to white label */
  paandiRedirection?: string | null;
  /** Points related property search option */
  points?: Points | null;
}
/** User Intent corresponding to this Search */
export interface SearchIntentInput {
  /** list of interests coming from Customer Spinner */
  interests?: InterestInput[] | null;
  /** SEM param, fetch from URL */
  semDtl?: string | null;
  /** SEM param, fetch from URL */
  semdtl?: string | null;
  /** TEMP Theme param, fetch from URL. Remove after SEM migration is complete */
  theme?: string | null;
  /** TEMP intent param, fetch from URL. Support BFF while migration to BEX API */
  userIntent?: string | null;
}
/** Provides the interest of a Customer for a particular search */
export interface InterestInput {
  /** SEM id of interest */
  desmetId?: string | null;
  /** Name of interest */
  name?: string | null;
}
/** Optional information to get a better contextual customer notification */
export interface CustomerNotificationOptionalContextInput {
  /** itinerary number */
  itineraryNumber?: string | null;
  /** list of journey criteria items */
  journeyCriterias?: CustomerNotificationOptionalContextJourneyCriteriaInput[] | null;
  /** the optional URL input field to retrieve extra url information, such as deeplinking url for the mobile app download notification */
  referer?: Url | null;
  /** regionId number */
  regionId?: string | null;
  /** list of GAIA regionIds */
  regionIds?: string[] | null;
  /** trip folder id */
  tripFolderId?: string | null;
}
/** Journey criteria such as location gaia id and travel date ranges */
export interface CustomerNotificationOptionalContextJourneyCriteriaInput {
  /** start date and end date of the trip */
  dateRange?: DateRangeInput | null;
  /** destination information */
  destination?: CustomerNotificationOptionalContextJourneyCriteriaLocationInput | null;
  /** origin information */
  origin?: CustomerNotificationOptionalContextJourneyCriteriaLocationInput | null;
}
/** A range of dates, from a starting date to an ending date */
export interface DateRangeInput {
  /** The terminal date in this range */
  end: DateInput;
  /** The starting date in this range */
  start: DateInput;
}
/** Journey criteria such as location gaia id and travel date ranges */
export interface CustomerNotificationOptionalContextJourneyCriteriaLocationInput {
  /** airport code */
  airportTLA?: string | null;
  /** property id */
  propertyId?: string | null;
  /** regionId number */
  regionId?: string | null;
}
/** Filter criteria details for the searchHistory query. */
export interface SearchHistoryFilterCriteriaInput {
  /** Search item end date in yyyy-MM-dd format. */
  endDate: string;
  /** Search item regionId. */
  regionId: string;
  /** Search item region type. */
  regionType?: string | null;
  /** Search item start date in yyyy-MM-dd format. */
  startDate: string;
}
/** Criteria based on search history groups are created. */
export interface SearchHistoryGroupingCriteriaInput {
  /** Search history grouping based on specified day range. */
  dayRange?: SearchHistoryDayRange | null;
  /** Search history grouping based on specified destination type. */
  destinationType?: SearchHistoryDestinationType | null;
}
/** Represents criteria for flights information page. */
export interface FlightsDetailComponentsCriteriaInput {
  /** Represents FlightsSearchContext of the selected flight */
  flightsSearchContext: FlightsSearchContextInput;
  /** Represents FlightsJourneyCriteria of the selected flight */
  journeyCriteria: FlightsJourneyCriteriaInput[];
  /** Represents Air Offer Token of the selected flight */
  journeyIdentifier: string;
  /** Represents Price of the selected flight */
  originalPrice?: MoneyInput | null;
  /** Represents QueryParams of the selected flight */
  queryParams?: GraphQlPairInput[] | null;
  /** Represents FlightsSearchPreferences of the selected flight */
  searchPreferences?: FlightsSearchPreferencesInput | null;
  /** Represents FlightsTravelerDetails of the selected flight */
  travelerDetails: FlightsTravelerDetailsInput[];
}
/** Context for flights search */
export interface FlightsSearchContextInput {
  /** Represent the continuation identifier for spinner to deduce which all journeyshave been selected. Null value represents the request is for first journey. */
  journeysContinuationId?: string | null;
  /** Represents the flights user selected for each segment when the user proceededto FIS.This node will be populated on the search response only if customer isreturning to FSR from FIS. */
  previousFlightSelections?: JourneyFlightSelectionInput[] | null;
  /** Trip type in search */
  tripType: FlightsTripType;
}
/** Represents a pair of segment order as index and the flight identifier as value */
export interface JourneyFlightSelectionInput {
  /** Represents the segment index. */
  journeyIndex: number;
  /** Represents the flight combination the customer previously selected for theindexed segment. This will be used to highlight the previously selected offerfor pinned listing. */
  offerIdentifier: string;
}
/** An object with simple key/value combination. This can be used to representgeneric input where you do not know all the values that can be provided.It should be avoided in favor of a strict type with set fields, but can be useful in specific situations. */
export interface GraphQlPairInput {
  key: string;

  value: string;
}
/** Traveler details for flights search */
export interface FlightsTravelerDetailsInput {
  /** Age for each traveler */
  ages?: number[] | null;
  /** Traveler count */
  count: number;
  /** Traveler type */
  travelerType: FlightsTravelerType;
}
/** Represents criteria for flights information page. */
export interface FlightsDetailCriteriaInput {
  /** Represent the continuation identifier for spinner to deduce all journeys selected by the user. */
  journeyContinuationId: string;
}
/** Represents flights component display values */
export interface FlightsDisplayComponentValuesInput {
  /** Represents counting values of flights display component */
  displayCountingValues?: FlightsDisplayComponentCountingValueInput[] | null;
}
/** Represents display count of a component within a session e.g How many time NFF shows consecutively */
export interface FlightsDisplayComponentCountingValueInput {
  /** Represents display count of a flights component */
  displayCount: number;

  flightsDisplayComponent: FlightsDisplayComponent;
}

export interface FlightsSearchComponentCriteriaInput {
  /** Represents Unresolved list of params for meta. Like MDPCID, etc. */
  queryParams?: GraphQlPairInput[] | null;
}
/** Represents an element of the list which the client needs to send back to theserver as part of the request. This will be part of each FilterItem so clientneed not apply any logic on filter selection but simply add this to the next request */
export interface FlightsSearchFilterValuesInput {
  /** Represents the value associated with arrival airport filter. */
  arrivalAirportCodeFilterValue?: FlightsAirportCodeFilterValueInput | null;
  /** Represents the FilterValue object corresponding to the Arrival Time filter. */
  arrivalTimeFilterValue?: FlightsTimeBasedFilterValueInput | null;
  /** Represents the value associated with departure airport filter. */
  departureAirportCodeFilterValue?: FlightsAirportCodeFilterValueInput | null;
  /** Represents the FilterValue object corresponding to the Departure Time filter. */
  departureTimeFilterValue?: FlightsTimeBasedFilterValueInput | null;
  /** Represents the FilterValue object corresponding to the Duration filter. */
  durationFilterValue?: FlightsDurationBasedFilterValueInput | null;
  /** Represents the value associated with flexible change policies filter. */
  flexibleChangePolicyBasedFilterValue?: FlightsFlexibleChangePolicyBasedFilterValueInput | null;
  /** Represents the FilterValue object corresponding to the Number of stops filter. */
  numOfStopFilterValue?: FlightsStopBasedFilterValueInput | null;
  /** Represents the FilterValue object corresponding to the Preferred Airline filter. */
  preferredAirlineFilterValue?: FlightsPreferredAirlineFilterValueInput | null;
}
/** Represents the value associated with airport filter */
export interface FlightsAirportCodeFilterValueInput {
  airportCode: string;
}
/** Represents the value associated with any time based filter, like DepartureTime or ArrivalTime based filter */
export interface FlightsTimeBasedFilterValueInput {
  timeOfDay: FlightsTimeOfDay;
}
/** Represents the value associated with duration based filter */
export interface FlightsDurationBasedFilterValueInput {
  maxDuration: number;
}
/** Represents the value associated with flexible change policies filter */
export interface FlightsFlexibleChangePolicyBasedFilterValueInput {
  policyName: FilterPolicyType;
}
/** Represents the value associated with number of stops based filter */
export interface FlightsStopBasedFilterValueInput {
  stopInfo: FlightsStopInfoInput;
}
/** Represents the stop related info for each number of stops based filter value.Combination of the number of stops and an operation.Ex. 2+ would be representedby {2,MORE_THAN} , 2 by {2,EQUAL} and <2 by {2,LESS_THAN} */
export interface FlightsStopInfoInput {
  numberOfStops: number;

  stopFilterOperation: FlightsStopFilterOperation;
}
/** Represents the value associated with preferred airline filter */
export interface FlightsPreferredAirlineFilterValueInput {
  carrierCode: string;
}
/** Represents the combination of SortType and SortOrder ex. Price Increasing */
export interface FlightsSortOptionTypeInput {
  sortOrder: FlightsSortOrder;

  sortType: FlightsSortType;
}

export interface PoiMapCoordinateInput {
  /** If present pins will be filtered out based on these categories */
  categories?: PoiMapItemCategory[] | null;
  /** Center coordinates to generate the map around it */
  centerCoordinates: CoordinatesInput;
  /** If present we will try to search POI based on end date */
  endDate?: DateInput | null;
  /** If present we will try to search POI based on start date */
  startDate?: DateInput | null;
  /** User pins with correct styling will be given back. Also the distance will be based on the first coordinate in the list */
  userCoordinates?: UserCoordinatesInput[] | null;
  /** If present this radius will be used to filter out pins */
  zoomRadius?: DistanceInput | null;
}

export interface UserCoordinatesInput {
  coordinates: CoordinatesInput;

  type: UserCoordinateType;
}
/** Measurable distance with units */
export interface DistanceInput {
  unit: DistanceUnit;

  value: number;
}
/** A location can be represented by a region id or an airport code. */
export interface InsightsLocationInput {
  /** Three letter IATA code associated with am airport near the location */
  airportCode?: string | null;
  /** Gaia region id of the location */
  regionId?: string | null;
}

export interface ShortlistDestinationFilterInput {
  /** Region type that will ultimately determined filtered results. Default is MULTI_CITY_VICINITY */
  destinationType: RegionType;
  /** Gaia region ID for which we want to filter shortlisted results. Does not haveto match region type, but will be used to find the relevant destination typebased on region type provided */
  regionId: string;
}

export interface CampaignParametersInput {
  campaignId: string;

  contentPagination?: ContentPaginationInput | null;

  propertyParameters?: CampaignPropertyParametersInput | null;
}

export interface ContentPaginationInput {
  pageNumber: number;

  pageSize?: number | null;
}

export interface CampaignPropertyParametersInput {
  guestRating?: number | null;

  propertyId: string;

  starRating?: number | null;

  type?: PropertyDetailsPropertyType | null;
}

export interface DestinationImageDimensionsInput {
  height: number;

  width: number;
}

export interface UserLocationInput {
  userCountryCode?: string | null;

  userLatitude?: BigDecimal | null;

  userLongitude?: BigDecimal | null;

  userSelectedOrigin?: string | null;
}
/** Question And Answer Search filters */
export interface ProductQuestionFiltersInput {
  /** Filter Questions and Answers on the basis of this keyword */
  searchTerm?: string | null;
}

export interface AbandonBookingInput {
  /** Order number of the booking for abandoning */
  orderNumber: string;
  /** Unique identifier of the collection of products / trip */
  tripId: Uuid;
}
/** Describes a coupon. Please provide a value to just one of the optional arguments. */
export interface CheckoutCouponInput {
  /** A coupon value entered by the user */
  code?: string | null;
  /** A coupon id value that the user selected from the list of available coupons */
  id?: string | null;
}

export interface BookingInput {
  cars?: BookingCarInput[] | null;
  /** Email required for booking information to be sent to */
  email: string;
  /** List of ways to pay for the booking. */
  paymentMethods: PaymentMethodInput[];

  properties?: BookingPropertyInput[] | null;
  /** Total price of the booking */
  totalPrice?: MoneyInput | null;
  /** Unique identifier of the collection of products / trip */
  tripId: Uuid;
  /** Encoded string representing the most up to date state of the trip. The valueto use can be found in the response of the checkout query. */
  tripState: string;
  /** Trust payload to send for fraud checking */
  trustPayload?: string | null;
}
/** Booking information regarding a car rental product */
export interface BookingCarInput {
  contactName: PersonNameInput;

  phoneNumber: PhoneNumberInput;
  /** The unique identifier of the product sometimes referred to as componentId /entityId. Used to identify a product in the TripService. */
  reference: string;
}
/** Name of the main traveler */
export interface PersonNameInput {
  firstName: string;

  lastName: string;
}
/** Phone number with prefix number */
export interface PhoneNumberInput {
  number: string;
  /** The ISO country code (e.g. 'USA', 'GBR', etc) */
  phoneCountryId: string;
}
/** Requires at least 1 payment method to be provided. Currently only supports Credit Card and single payment. */
export interface PaymentMethodInput {
  /** Amount of money to charge for this payment method, not providing this assumes full amount */
  amountToCharge: MoneyInput;
  /** Points information which will be used to pay for the booking */
  paymentPoints?: PaymentPointsInput | null;
  /** Payment token information which will be used to pay for the booking */
  paymentToken?: PaymentTokenInput | null;
  /** Type of the payment element */
  paymentType: PaymentMethodType;
}

export interface PaymentPointsInput {
  /** Payment instrument id for pay with points */
  id: string;
  /** Payment sub method for pay with points */
  paymentSubmethod: string;
  /** Whether points is used or not */
  usePoints: boolean;
}

export interface PaymentTokenInput {
  /** Payment session id for only 3DS booking */
  paymentSessionId?: string | null;
  /** When provided, will store the payment method for future use */
  saveAs?: string | null;
  /** Edge Token used for the payment */
  token: string;
  /** Type of payment being processed by the edge token */
  type: PaymentTokenType;
}
/** Booking information regarding a property product */
export interface BookingPropertyInput {
  contactName: PersonNameInput;

  phoneNumber: PhoneNumberInput;

  preferences?: PropertyPreferencesInput | null;
  /** The unique identifier of the product sometimes referred to as componentId /entityId. Used to identify a product in the TripService. */
  reference: string;
  /** Indicates whether the user wants to receive a confirmation sms or not. Default type is false. */
  sendConfirmationText?: boolean | null;
}
/** Outlines the user's requests and preferences to the property */
export interface PropertyPreferencesInput {
  /** List of user's accessibility requests */
  accessibilityRequests?: string[] | null;
  /** The user's requested bed type */
  bedType?: string | null;
  /** Indicates whether the user would prefer a smoking or non smoking room */
  smoking?: boolean | null;
  /** Free text special request to be conveyed to the property */
  specialRequests?: string | null;
}

export interface PaymentSessionCriteriaInput {
  /** Booking info which controls what kind of payment sessions may be required for payment */
  bookingProductInfoDetails: BookingProductDetailsInput[];
  /** Currency of the payment session */
  currency?: CurrencyInput | null;
  /** Payment token that represents the payment details */
  edgeToken: string;
  /** Browser metadata to set up 3DS */
  encodedBrowserMetadata: string;
  /** Trip ID to associate with the payment session */
  tripId: Uuid;
  /** Version of the library to use for challenge */
  version: string;
}

export interface BookingProductDetailsInput {
  businessModel: BusinessModel;

  lineOfBusiness: LineOfBusiness;
}
/** Information about a specific currency */
export interface CurrencyInput {
  /** The ISO 4217 3-letter code for this currency */
  code: string;
  /** The display name of the currency */
  name: string;
  /** The currency symbol, e.g. '$' */
  symbol: string;
}

export interface ResumeBookingInput {
  /** Order number of the booking for resuming */
  orderNumber: string;
  /** List of payment options used for the booking */
  paymentOptionsUsed: PaymentOptionType[];
  /** Unique identifier of the collection of products / trip */
  tripId: Uuid;
}
/** Points Input needed to update points */
export interface PointsInput {
  /** Actions that points can undertake, e.g. Apply/Remove */
  action: PayWithPointsUpdateAction;
  /** Unique identifier for the Trip */
  tripId: Uuid;
}

export interface AddInsuranceRequestInput {
  /** CountryCode from residency selection of user */
  countryCode?: string | null;
  /** The user selection for the Insurance product(s) */
  insuranceProductIds: string[];
  /** RegionCode from residency selection of user */
  regionCode?: string | null;
  /** The source id of the persistence store.For example Trip for BEX or Record locator for other systems */
  sourceId: string;
  /** The identifier to get the decoded value of params received in shopping response */
  updateRequestId: string;
}

export interface AddInsuranceRequestOldInput {
  insuranceSearchId: string;

  offerTypeId: number;
}

export interface InsuranceTripMutationRequestInput {
  action: InsuranceMutationType;

  insuranceSearchId?: string | null;

  offerTypeId?: number | null;
}

export interface RemoveInsuranceRequestInput {
  /** The user selection for the Insurance product(s) */
  insuranceProductIds: string[];
  /** The source id of the persistence store.For example Trip for BEX or Record locator for other systems */
  sourceId: string;
  /** The identifier to get the decoded value of params received in shopping response */
  updateRequestId: string;
}

export interface RemoveInsuranceRequestOldInput {
  insuranceSearchId: string;

  offerTypeId?: number | null;
}
/** Minimum set of data used to retrieve details about a property product */
export interface PropertyOfferInput {
  /** Sometimes, 1 room's offer needs to be represented by more than 1 Property Natural Key, e.g: Mixed Rate Plan */
  naturalKeys: PropertyNaturalKeyInput[];
  /** The index of the room user is adding */
  offerIndex: number;
}

export interface CartPropertySearchContextInput {
  /** The checking date for the property rental */
  checkIn: DateInput;
  /** The checkOut date for the property rental */
  checkOut: DateInput;
  /** The id of the region where the hotel is located - from lodging domain */
  regionId: string;
  /** The list of rooms that user searched for */
  rooms: PropertyRoomInput[];
}
/** Options for the session cart being created */
export interface CartOptionsInput {
  ttl: CartTtl;
}
/** Checkout option and its value to apply on the checkoutUrl */
export interface CheckoutOptionInput {
  type: CheckoutOptionType;

  value: string;
}
/** Represents the the user input for customer notification mutation */
export interface CustomerNotificationUserInput {
  /** Represents list of customer notification user input */
  inputs: CustomerNotificationUserInputElementInput[];
}
/** Represents customer notification user input */
export interface CustomerNotificationUserInputElementInput {
  /** Represents the type of customer notification user input */
  type: string;
  /** Represents the value of customer notification user input */
  value: string;
}
/** Represents the attributes on a notification that could be changed after an interaction */
export interface CustomerNotificationModifiableAttributesInput {
  /** Set to true when notification is dismissed */
  dismiss: boolean;
  /** Set to true when notification is read */
  read: boolean;
  /** Set to true when notification is seen */
  seen: boolean;
}
/** Key/Value pairs of data required by the client for playback. (Optional) */
export interface ShortlistMetadataInput {
  key: string;

  value: string;
}

// ====================================================
// Enums
// ====================================================

/** Specifies the behavior of ALTER, which is used to run Abacus experiments on localization messages. */
export enum AlterMode {
  DEBUG = 'DEBUG',
  NONE = 'NONE',
  PREVIEW = 'PREVIEW',
  RELEASED = 'RELEASED',
}
/** Valid device types */
export enum DeviceType {
  APP_PHONE = 'APP_PHONE',
  APP_TABLET = 'APP_TABLET',
  CHAT_APP = 'CHAT_APP',
  DESKTOP = 'DESKTOP',
  MOBILE_PHONE = 'MOBILE_PHONE',
  MOBILE_TABLET = 'MOBILE_TABLET',
  VOICE_APP = 'VOICE_APP',
}

export enum AuthenticationState {
  ANONYMOUS = 'ANONYMOUS',
  AUTHENTICATED = 'AUTHENTICATED',
  IDENTIFIED = 'IDENTIFIED',
}
/** Privacy tracking user preference. We can retrieve info on if the site allowstracking from Site Info and null can also be used to represent a selection or not */
export enum PrivacyTrackingState {
  CAN_NOT_TRACK = 'CAN_NOT_TRACK',
  CAN_TRACK = 'CAN_TRACK',
}

export enum BookingStatus {
  ABANDONED = 'ABANDONED',
  ANY = 'ANY',
  BOOKED = 'BOOKED',
  CANCELLED = 'CANCELLED',
  DELETED = 'DELETED',
  EXPIRED = 'EXPIRED',
  FAILED = 'FAILED',
  INVALID = 'INVALID',
  NO_LONGER_AVAILABLE = 'NO_LONGER_AVAILABLE',
  PARTIALLY_FAILED = 'PARTIALLY_FAILED',
  PENDING = 'PENDING',
  PLANNING = 'PLANNING',
  SAVED = 'SAVED',
  UNKNOWN = 'UNKNOWN',
}
/** supported sizes of icons */
export enum IconSize {
  EXTRA_SMALL = 'EXTRA_SMALL',
  LARGE = 'LARGE',
  MEDIUM = 'MEDIUM',
  MEDIUM_LARGE = 'MEDIUM_LARGE',
  SMALL = 'SMALL',
}
/** Supported themes of icons. See the prop definitions here: http://uitk-react.tools.expedia.com/expedia/en_US/components/icons */
export enum IconTheme {
  default = 'default',
  emphasis = 'emphasis',
  negative = 'negative',
  positive = 'positive',
}

export enum ChronoUnit {
  CENTURIES = 'CENTURIES',
  DAYS = 'DAYS',
  DECADES = 'DECADES',
  ERAS = 'ERAS',
  FOREVER = 'FOREVER',
  HALFDAYS = 'HALFDAYS',
  HOURS = 'HOURS',
  MICROS = 'MICROS',
  MILLENNIA = 'MILLENNIA',
  MILLIS = 'MILLIS',
  MINUTES = 'MINUTES',
  MONTHS = 'MONTHS',
  NANOS = 'NANOS',
  SECONDS = 'SECONDS',
  WEEKS = 'WEEKS',
  YEARS = 'YEARS',
}

export enum BooleanEnum {
  FALSE = 'FALSE',
  TRUE = 'TRUE',
}

export enum EventType {
  ItinActiveCar = 'ItinActiveCar',
  ItinActiveCruise = 'ItinActiveCruise',
  ItinActiveFlight = 'ItinActiveFlight',
  ItinActiveGT = 'ItinActiveGT',
  ItinActiveHotel = 'ItinActiveHotel',
  ItinActiveLX = 'ItinActiveLX',
  ItinActivePackageFH = 'ItinActivePackageFH',
  ItinActiveRail = 'ItinActiveRail',
  ItinCancellation = 'ItinCancellation',
  TripsHeroModuleCurrentTrip = 'TripsHeroModuleCurrentTrip',
  TripsHeroModulePotentialTrip = 'TripsHeroModulePotentialTrip',
  TripsHeroModuleUpcomingTrip = 'TripsHeroModuleUpcomingTrip',
  TripsItemDetailViewed = 'TripsItemDetailViewed',
  TripsListViewed = 'TripsListViewed',
  TripsModuleDestinationGuide = 'TripsModuleDestinationGuide',
  TripsOverviewViewed = 'TripsOverviewViewed',
  Unknown = 'Unknown',
}
/** Used to highlight or convey information. For example, positive messaging like free cancellation may be green. */
export enum TextTheme {
  NEGATIVE = 'NEGATIVE',
  POSITIVE = 'POSITIVE',
  PRIMARY = 'PRIMARY',
  SECONDARY = 'SECONDARY',
}
/** Used to highlight or convey information. For example, Payable amount in the price summary module of the checkout page. */
export enum TextWeight {
  BOLD = 'BOLD',
  MEDIUM = 'MEDIUM',
  REGULAR = 'REGULAR',
}

export enum TripsButtonWidth {
  MATCH_PARENT_CONTAINER = 'MATCH_PARENT_CONTAINER',
  WRAP_CONTENT = 'WRAP_CONTENT',
}
/** UI Theme to be applied to a `UISectionContainer` or a `TripsSectionContainer`. */
export enum ContainerTheme {
  DEFAULT = 'DEFAULT',
  IMPORTANT = 'IMPORTANT',
}
/** The type of map marker */
export enum TripsMarkerType {
  ActivityEventMarker = 'ActivityEventMarker',
  ActivityGuestPickupMarker = 'ActivityGuestPickupMarker',
  ActivityLocationMarker = 'ActivityLocationMarker',
  ActivityRedemptionMarker = 'ActivityRedemptionMarker',
  AirportMarker = 'AirportMarker',
  CarMarker = 'CarMarker',
  CruiseMarker = 'CruiseMarker',
  HotelMarker = 'HotelMarker',
  PlaceMarker = 'PlaceMarker',
}

export enum CheckoutUiActionType {
  INSURANCE = 'INSURANCE',
  PAGE_LOAD = 'PAGE_LOAD',
  SIGN_IN = 'SIGN_IN',
}
/** Represents the size of a Text element */
export enum CheckoutTextSize {
  LARGE = 'LARGE',
  REGULAR = 'REGULAR',
  SMALL = 'SMALL',
}

export enum PaymentOptionType {
  CREDIT_CARD = 'CREDIT_CARD',
  PAYPAL = 'PAYPAL',
  POINTS = 'POINTS',
  STORED_CARD = 'STORED_CARD',
}
/** Enum representing the size options for the UITK PaymentType element */
export enum PaymentTypeLogoSize {
  LARGE = 'LARGE',
  SMALL = 'SMALL',
}
/** Business model for a product */
export enum BusinessModel {
  CLASSIC_AGENCY = 'CLASSIC_AGENCY',
  DIRECT_AGENCY = 'DIRECT_AGENCY',
  MERCHANT = 'MERCHANT',
}

export enum LineOfBusiness {
  HOTEL = 'HOTEL',
  INSURANCE = 'INSURANCE',
}

export enum ThreeDSv2InventoryType {
  LOCAL_INVENTORY = 'LOCAL_INVENTORY',
}

export enum PenaltyCollectionType {
  ONLINE_PENALTY_COLLECTION = 'ONLINE_PENALTY_COLLECTION',
}
/** Possible direction types for ground transfers */
export enum GroundTransfersDirection {
  FROM_AIRPORT = 'FROM_AIRPORT',
  ROUNDTRIP = 'ROUNDTRIP',
  TO_AIRPORT = 'TO_AIRPORT',
}
/** Possible direction types for ground transfers */
export enum GeoType {
  AIRPORT = 'AIRPORT',
  DESTINATION = 'DESTINATION',
  PROPERTY = 'PROPERTY',
}
/** Possible traveler details types */
export enum GroundTransfersTravelerDetailsType {
  ADULT = 'ADULT',
  CHILD = 'CHILD',
  INFANT = 'INFANT',
}
/** Text style to apply to text */
export enum GroundTransfersStyle {
  EMPHASISED = 'EMPHASISED',
  POSITIVE = 'POSITIVE',
  STANDARD = 'STANDARD',
}

export enum GroundTransfersSectionStyle {
  BULLETED = 'BULLETED',
  STANDARD = 'STANDARD',
}

export enum GroundTransfersMapTransitOption {
  BUS = 'BUS',
  NONE = 'NONE',
  TRAIN = 'TRAIN',
}

export enum GroundTransfersMapTravelMode {
  DRIVING = 'DRIVING',
  TRANSIT = 'TRANSIT',
}

export enum GroundTransfersBadgeTheme {
  DEAL_BUNDLED = 'DEAL_BUNDLED',
  DEAL_GENERIC = 'DEAL_GENERIC',
  DEAL_MEMBER = 'DEAL_MEMBER',
}

export enum GroundTransfersGroupViewType {
  CARDS_LIST = 'CARDS_LIST',
}

export enum InsuranceMessageType {
  ERROR = 'ERROR',
  INFO = 'INFO',
  WARNING = 'WARNING',
}

export enum InsuranceListLayout {
  SINGLE_COLUMN = 'SINGLE_COLUMN',
}

export enum InsuranceListType {
  ORDERED = 'ORDERED',
  UNORDERED = 'UNORDERED',
}

export enum InsuranceRewardsPointSelectionEnum {
  APPLY_REWARD_POINTS = 'APPLY_REWARD_POINTS',
  DO_NOT_APPLY_REWARD_POINTS = 'DO_NOT_APPLY_REWARD_POINTS',
}

export enum InsurancePhrasePartStyle {
  COLOR_GREEN = 'COLOR_GREEN',
  COLOR_RED = 'COLOR_RED',
  EMPHASIS = 'EMPHASIS',
  IMPORTANT = 'IMPORTANT',
  STANDARD = 'STANDARD',
}

export enum InsuranceListTypeOld {
  ICON = 'ICON',
  NUMBERED = 'NUMBERED',
}
/** Details view options that are not filters */
export enum ActivityDetailViewOptions {
  NON_CONSOLIDATED_OFFERS = 'NON_CONSOLIDATED_OFFERS',
  SHOP_WITH_POINTS = 'SHOP_WITH_POINTS',
}
/** Search options that are not filters */
export enum ActivitySearchOptions {
  CATEGORY = 'CATEGORY',
  FILTER_NESTED_CATEGORIES = 'FILTER_NESTED_CATEGORIES',
  GAIA_RETURN_ADDITIONAL_DISTANCE_PARAMETER = 'GAIA_RETURN_ADDITIONAL_DISTANCE_PARAMETER',
  GIFTING_ACTIVITIES = 'GIFTING_ACTIVITIES',
  GUEST_PROMO = 'GUEST_PROMO',
  NON_CONSOLIDATED_OFFERS = 'NON_CONSOLIDATED_OFFERS',
  SHOP_WITH_POINTS = 'SHOP_WITH_POINTS',
  SHOW_GT_BANNER = 'SHOW_GT_BANNER',
}

export enum ActivityBadgeType {
  CAMPAIGN_DEAL = 'CAMPAIGN_DEAL',
  DEAL_ADD_ON = 'DEAL_ADD_ON',
  DEAL_GENERIC = 'DEAL_GENERIC',
  DEAL_MEMBER = 'DEAL_MEMBER',
}

export enum ActivityCategory {
  ADULTS_ONLY_SHOWS = 'ADULTS_ONLY_SHOWS',
  ADVENTURES = 'ADVENTURES',
  ADVENTURE_OUTDOOR = 'ADVENTURE_OUTDOOR',
  AIRBOAT_TOURS = 'AIRBOAT_TOURS',
  AIRPLANE_RIDES = 'AIRPLANE_RIDES',
  AIRPLANE_TOURS = 'AIRPLANE_TOURS',
  AIRPORT_GROUND_TRANSPORTATION = 'AIRPORT_GROUND_TRANSPORTATION',
  AIRPORT_LOUNGES = 'AIRPORT_LOUNGES',
  AIRPORT_TO_AIRPORT_TRANSFERS = 'AIRPORT_TO_AIRPORT_TRANSFERS',
  AIR_BALLOON_HELICOPTER_TOURS = 'AIR_BALLOON_HELICOPTER_TOURS',
  AIR_HELICOPTER_BALLOON_TOURS = 'AIR_HELICOPTER_BALLOON_TOURS',
  AMUSEMENT_THEME_PARKS = 'AMUSEMENT_THEME_PARKS',
  ARCHITECTURE_TOURS = 'ARCHITECTURE_TOURS',
  ART_CLASSES = 'ART_CLASSES',
  ART_CULTURE_HISTORY_TOURS = 'ART_CULTURE_HISTORY_TOURS',
  ART_MUSIC_LITERARYTOURS = 'ART_MUSIC_LITERARYTOURS',
  ATTRACTIONS = 'ATTRACTIONS',
  ATTRACTION_TICKETS = 'ATTRACTION_TICKETS',
  BALLOON_RIDES = 'BALLOON_RIDES',
  BALLOON_TOURS = 'BALLOON_TOURS',
  BAR_PUB_TOURS = 'BAR_PUB_TOURS',
  BEER_BREWERY_TOURS = 'BEER_BREWERY_TOURS',
  BEYOND_THE_CITY = 'BEYOND_THE_CITY',
  BIKE_MOUNTAIN_BIKE_TOURS = 'BIKE_MOUNTAIN_BIKE_TOURS',
  BIKE_RENTALS = 'BIKE_RENTALS',
  BOAT_RENTAL = 'BOAT_RENTAL',
  BOAT_TOURS = 'BOAT_TOURS',
  BOAT_TOURS_CRUISES = 'BOAT_TOURS_CRUISES',
  BRUNCHC_RUISES = 'BRUNCHC_RUISES',
  BUNGEE_JUMPING_SKYDIVING = 'BUNGEE_JUMPING_SKYDIVING',
  BUS_MINIVAN_TOURS = 'BUS_MINIVAN_TOURS',
  CABARET = 'CABARET',
  CAMPAIGN_DEALS = 'CAMPAIGN_DEALS',
  CASTLE_PALACE_TOURS = 'CASTLE_PALACE_TOURS',
  CHAUFFER_SERVICES = 'CHAUFFER_SERVICES',
  CHRISTMAS = 'CHRISTMAS',
  CIRQUE = 'CIRQUE',
  CIRQUE_DU_SOLEIL = 'CIRQUE_DU_SOLEIL',
  CIRQUE_DU_SOLEILSHOWS = 'CIRQUE_DU_SOLEILSHOWS',
  CITY_AND_ATTRACTION_TRANSFERS = 'CITY_AND_ATTRACTION_TRANSFERS',
  CITY_ATTRACTION_TRANSFERS = 'CITY_ATTRACTION_TRANSFERS',
  CITY_TOURS = 'CITY_TOURS',
  CITY_TOURS_PACKAGES = 'CITY_TOURS_PACKAGES',
  CLASSES_WORKSHOPS = 'CLASSES_WORKSHOPS',
  CLUB_AND_PARTY_BUS_TOURS = 'CLUB_AND_PARTY_BUS_TOURS',
  CLUB_PARTY_BUS_TOURS = 'CLUB_PARTY_BUS_TOURS',
  COFFEE_TEA_TOURS = 'COFFEE_TEA_TOURS',
  COMEDY_SHOWS = 'COMEDY_SHOWS',
  CONCERTS_SPECIAL_EVENTS = 'CONCERTS_SPECIAL_EVENTS',
  COOKING_CLASSES = 'COOKING_CLASSES',
  CRUISES_BOAT_TOURS = 'CRUISES_BOAT_TOURS',
  CRUISES_WATER_TOURS = 'CRUISES_WATER_TOURS',
  CULTURAL_HERITAGE_EXPERIENCES = 'CULTURAL_HERITAGE_EXPERIENCES',
  CUSTOM_PRIVATE_TOURS = 'CUSTOM_PRIVATE_TOURS',
  DANCE_CLASSES = 'DANCE_CLASSES',
  DAY_OF_THE_DEAD = 'DAY_OF_THE_DEAD',
  DAY_SPAS = 'DAY_SPAS',
  DAY_TRIPS = 'DAY_TRIPS',
  DAY_TRIPS_EXCURSIONS = 'DAY_TRIPS_EXCURSIONS',
  DINING_EXPERIENCES = 'DINING_EXPERIENCES',
  DINNER_CRUISES = 'DINNER_CRUISES',
  DINNER_THEATER = 'DINNER_THEATER',
  DISNEY = 'DISNEY',
  DISNEY_PARKS = 'DISNEY_PARKS',
  DOLPHIN_WHALE_WATCHING = 'DOLPHIN_WHALE_WATCHING',
  DOSE_OF_CULTURE = 'DOSE_OF_CULTURE',
  DUCK_TOURS = 'DUCK_TOURS',
  EASTER = 'EASTER',
  FAMILY_FRIENDLY = 'FAMILY_FRIENDLY',
  FASHION_SHOWS_TOURS = 'FASHION_SHOWS_TOURS',
  FISHING_CHARTERS_TOURS = 'FISHING_CHARTERS_TOURS',
  FISHING_TOURS_AND_CHARTERS = 'FISHING_TOURS_AND_CHARTERS',
  FOOD_DRINK = 'FOOD_DRINK',
  FOOD_DRINK_NIGHTLIFE = 'FOOD_DRINK_NIGHTLIFE',
  FOOD_TOURS = 'FOOD_TOURS',
  FUN_FOR_FOODIES = 'FUN_FOR_FOODIES',
  FUN_ON_THE_WATER = 'FUN_ON_THE_WATER',
  GALLERIES_MUSEUMS = 'GALLERIES_MUSEUMS',
  GAMES_SHOWS_SPECIAL_EVENTS = 'GAMES_SHOWS_SPECIAL_EVENTS',
  GETTING_AROUND = 'GETTING_AROUND',
  GOLF_TEE_TIMES = 'GOLF_TEE_TIMES',
  GOLF_TOURS_TEE_TIMES = 'GOLF_TOURS_TEE_TIMES',
  HALLOWEEN = 'HALLOWEEN',
  HAMMAMS_TURKISH_BATHS = 'HAMMAMS_TURKISH_BATHS',
  HELICOPTER_RIDES = 'HELICOPTER_RIDES',
  HELICOPTER_TOURS = 'HELICOPTER_TOURS',
  HIGH_SPEED_DRIVING = 'HIGH_SPEED_DRIVING',
  HIGH_SPEED_RIDES = 'HIGH_SPEED_RIDES',
  HIKING_CAMPING = 'HIKING_CAMPING',
  HISTORICAL_TOURS = 'HISTORICAL_TOURS',
  HISTORY_CULTURE = 'HISTORY_CULTURE',
  HOLIDAY_SEASONAL_TOURS = 'HOLIDAY_SEASONAL_TOURS',
  HONEYMOON_PACKAGE = 'HONEYMOON_PACKAGE',
  HONEYMOON_PACKAGES = 'HONEYMOON_PACKAGES',
  HOP_ON_HOP_OFF = 'HOP_ON_HOP_OFF',
  HOP_ON_HOP_OFF_TOURS = 'HOP_ON_HOP_OFF_TOURS',
  HORSE_CARRIAGE_RIDES = 'HORSE_CARRIAGE_RIDES',
  HOT_SPRINGS_THERMAL_SPAS = 'HOT_SPRINGS_THERMAL_SPAS',
  INTERESTS = 'INTERESTS',
  KAYAKING_CANOEING = 'KAYAKING_CANOEING',
  LATEST_GREATEST = 'LATEST_GREATEST',
  LIFT_TICKETS = 'LIFT_TICKETS',
  LIKELY_TO_SELL_OUT = 'LIKELY_TO_SELL_OUT',
  LITERARY_ART_MUSIC_TOURS = 'LITERARY_ART_MUSIC_TOURS',
  LOCAL_EXPERT_PICKS = 'LOCAL_EXPERT_PICKS',
  LUNCH_CRUISES = 'LUNCH_CRUISES',
  MOTORCYCLE_SCOOTER_TOURS = 'MOTORCYCLE_SCOOTER_TOURS',
  MOVIE_TV_TOURS = 'MOVIE_TV_TOURS',
  MULTIDAY_CRUISES = 'MULTIDAY_CRUISES',
  MULTI_DAY_EXTENDED_TOURS = 'MULTI_DAY_EXTENDED_TOURS',
  MUSEUM_TICKETS = 'MUSEUM_TICKETS',
  MUSEUM_TICKETS_PASSES = 'MUSEUM_TICKETS_PASSES',
  MUST_SEE_SIGHTS = 'MUST_SEE_SIGHTS',
  NA = 'NA',
  NATIONAL_HOLIDAYS = 'NATIONAL_HOLIDAYS',
  NEW = 'NEW',
  NEWY_EARS = 'NEWY_EARS',
  NIGHTLIFE = 'NIGHTLIFE',
  NIGHTLIFE_PASSES = 'NIGHTLIFE_PASSES',
  NIGHT_CRUISES = 'NIGHT_CRUISES',
  NIGHT_TOURS = 'NIGHT_TOURS',
  ONSENS = 'ONSENS',
  OTHER_ANIMALS_ACTIVITIES = 'OTHER_ANIMALS_ACTIVITIES',
  OTHER_ANIMAL_ACTIVITIES = 'OTHER_ANIMAL_ACTIVITIES',
  OTHER_CLASSES = 'OTHER_CLASSES',
  OTHER_OUTDOOR_ACTIVITIES = 'OTHER_OUTDOOR_ACTIVITIES',
  OTHER_SEASONAL_EVENTS = 'OTHER_SEASONAL_EVENTS',
  OTHER_TOURS = 'OTHER_TOURS',
  OTHER_TRANSFERS = 'OTHER_TRANSFERS',
  OTHER_TRANSPORTATION = 'OTHER_TRANSPORTATION',
  OTHER_WATER_ACTIVITIES = 'OTHER_WATER_ACTIVITIES',
  PHOTOGRAPHY_TOURS = 'PHOTOGRAPHY_TOURS',
  PORT_TRANSFERS = 'PORT_TRANSFERS',
  PRIVATE_CUSTOM_TOURS = 'PRIVATE_CUSTOM_TOURS',
  PRIVATE_DAY_TRIPS = 'PRIVATE_DAY_TRIPS',
  PRIVATE_TOURS = 'PRIVATE_TOURS',
  PRIVATE_TRANSFERS = 'PRIVATE_TRANSFERS',
  PURE_ROMANCE = 'PURE_ROMANCE',
  RELIGIOUS_SPIRITUAL_TOURS = 'RELIGIOUS_SPIRITUAL_TOURS',
  RIVER_HARBOUR_CRUISES = 'RIVER_HARBOUR_CRUISES',
  ROMAN_STAYCATION = 'ROMAN_STAYCATION',
  SAFARIS = 'SAFARIS',
  SAILING_TRIPS = 'SAILING_TRIPS',
  SCOOTER_RENTALS = 'SCOOTER_RENTALS',
  SEGWAY_TOURS = 'SEGWAY_TOURS',
  SHARED_TRANSFERS = 'SHARED_TRANSFERS',
  SHARK_DIVING = 'SHARK_DIVING',
  SHOPPING_FASHION = 'SHOPPING_FASHION',
  SHOPPING_PASSES_OFFERS = 'SHOPPING_PASSES_OFFERS',
  SHOPPING_TOURS = 'SHOPPING_TOURS',
  SHORE_EXCURIONS = 'SHORE_EXCURIONS',
  SHOWS_CONCERTS = 'SHOWS_CONCERTS',
  SHOW_SPORT_TICKETS = 'SHOW_SPORT_TICKETS',
  SIGHTSEEING_ATTRACTION_PASSES = 'SIGHTSEEING_ATTRACTION_PASSES',
  SIGHTSEEING_CITY_PASSES = 'SIGHTSEEING_CITY_PASSES',
  SIGHTSEEING_PASSES = 'SIGHTSEEING_PASSES',
  SKIING_RENTALS = 'SKIING_RENTALS',
  SKIP_THE_LINE_TOURS = 'SKIP_THE_LINE_TOURS',
  SNORKELING_SCUBA_DIVING = 'SNORKELING_SCUBA_DIVING',
  SNOWBOARDING_RENTALS = 'SNOWBOARDING_RENTALS',
  SNOWMOBILE_TOURS = 'SNOWMOBILE_TOURS',
  SNOWSHOEING = 'SNOWSHOEING',
  SPA = 'SPA',
  SPA_WELLNESS = 'SPA_WELLNESS',
  SPEED_BOATS_JET_SKIS = 'SPEED_BOATS_JET_SKIS',
  SPORTING_EVENTS_PACKAGES = 'SPORTING_EVENTS_PACKAGES',
  SPORTS_PACKAGES = 'SPORTS_PACKAGES',
  STAY_ACTIVE = 'STAY_ACTIVE',
  SUBMARINE_TOURS = 'SUBMARINE_TOURS',
  SUNSET_CRUISES = 'SUNSET_CRUISES',
  SUPERNATURAL_TOURS = 'SUPERNATURAL_TOURS',
  SUSTAINABLE_TOURS = 'SUSTAINABLE_TOURS',
  SWIM_WITH_DOLPHINS = 'SWIM_WITH_DOLPHINS',
  THEATER_SHOWS_MUSICALS = 'THEATER_SHOWS_MUSICALS',
  THEME_PARKS = 'THEME_PARKS',
  THEME_PARK_TICKETS_TOURS = 'THEME_PARK_TICKETS_TOURS',
  THE_GREAT_OUTDOORS = 'THE_GREAT_OUTDOORS',
  THRILL_SEEKER = 'THRILL_SEEKER',
  TICKETS = 'TICKETS',
  TOURS_ACTIVITIES = 'TOURS_ACTIVITIES',
  TOURS_SIGHTSEEING = 'TOURS_SIGHTSEEING',
  TRANSPORTATION_SERVICES = 'TRANSPORTATION_SERVICES',
  TREAT_YOURSELF = 'TREAT_YOURSELF',
  TUBING = 'TUBING',
  UNIVERSAL_THEME_PARKS = 'UNIVERSAL_THEME_PARKS',
  VALENTINES_DAY = 'VALENTINES_DAY',
  WALKING_BIKE_TOURS = 'WALKING_BIKE_TOURS',
  WALKING_TOURS = 'WALKING_TOURS',
  WATERSKIING_WAKEBOARDING = 'WATERSKIING_WAKEBOARDING',
  WATER_ACTIVITIES = 'WATER_ACTIVITIES',
  WATER_PARKS = 'WATER_PARKS',
  WEDDING_CEREMONIES = 'WEDDING_CEREMONIES',
  WEDDING_HONEYMOON = 'WEDDING_HONEYMOON',
  WEDDING_PACKAGES = 'WEDDING_PACKAGES',
  WEDDING_SHONEYMOONS = 'WEDDING_SHONEYMOONS',
  WHAT_TO_DO_WITH_GROUPS = 'WHAT_TO_DO_WITH_GROUPS',
  WHAT_TO_DO_WITH_KIDS = 'WHAT_TO_DO_WITH_KIDS',
  WHITE_WATER_RAFTING = 'WHITE_WATER_RAFTING',
  WILDLIFE_NATURE = 'WILDLIFE_NATURE',
  WINE_TASTING_WINERY_TOURS = 'WINE_TASTING_WINERY_TOURS',
  WINTER_ACTIVITIES = 'WINTER_ACTIVITIES',
  YOGA_CLASS = 'YOGA_CLASS',
  YOGA_CLASSES = 'YOGA_CLASSES',
  ZOO_TICKETS = 'ZOO_TICKETS',
  ZOO_TICKETS_PASSES = 'ZOO_TICKETS_PASSES',
}

export enum ActivityCancellationType {
  FREE_CANCELLATION = 'FREE_CANCELLATION',
  NO_CANCELLATION = 'NO_CANCELLATION',
}

export enum ActivityDiscountType {
  AIR_ATTACH_MIP = 'AIR_ATTACH_MIP',
  AIR_HOTEL_ATTACH_MIP = 'AIR_HOTEL_ATTACH_MIP',
  CAMPAIGN_DEAL = 'CAMPAIGN_DEAL',
  FREE_ACTIVITY = 'FREE_ACTIVITY',
  GUEST = 'GUEST',
  HOTEL_ATTACH_MIP = 'HOTEL_ATTACH_MIP',
  MOD = 'MOD',
  STRIKE_OUT = 'STRIKE_OUT',
}

export enum ActivityRedemptionType {
  PRINT = 'PRINT',
  VOUCHER_LESS = 'VOUCHER_LESS',
}

export enum ActivityTextSize {
  LARGE = 'LARGE',
  MEDIUM = 'MEDIUM',
  SMALL = 'SMALL',
}
/** Activity Price types */
export enum ActivityPriceType {
  GROUP = 'GROUP',
  NORMAL = 'NORMAL',
  VOLUME_BASED = 'VOLUME_BASED',
}

export enum ActivityOfferUdsToken {
  SELECTED = 'SELECTED',
  UNSELECTED = 'UNSELECTED',
}
/** Activity banner type */
export enum ActivityBannerType {
  ALERT = 'ALERT',
  INFO = 'INFO',
  SHOP_WITH_POINTS = 'SHOP_WITH_POINTS',
}
/** Unique identifier for a message if one needs to identify the reason for the message creation */
export enum ActivityMessageType {
  ADDON = 'ADDON',
  EARN_2X_REWARD_POINTS = 'EARN_2X_REWARD_POINTS',
  GIFTING_LX_BANNER = 'GIFTING_LX_BANNER',
  LOGIN = 'LOGIN',
  SOURCED_CAMPAIGN = 'SOURCED_CAMPAIGN',
  SUMMER_CAMPAIGN_PRIMARY = 'SUMMER_CAMPAIGN_PRIMARY',
  SUMMER_CAMPAIGN_SECONDARY = 'SUMMER_CAMPAIGN_SECONDARY',
}

export enum ActivityReviewSort {
  HIGHEST_TO_LOWEST_RATED = 'HIGHEST_TO_LOWEST_RATED',
  LOWEST_TO_HIGHEST_RATED = 'LOWEST_TO_HIGHEST_RATED',
  NEWEST_TO_OLDEST = 'NEWEST_TO_OLDEST',
}

export enum ActivityGroupType {
  ACTIVITY_LIST = 'ACTIVITY_LIST',
  ACTIVITY_MESSAGE = 'ACTIVITY_MESSAGE',
  AVAILABLE_TODAY = 'AVAILABLE_TODAY',
  CATEGORY = 'CATEGORY',
  FILTERED_ACTIVITIES = 'FILTERED_ACTIVITIES',
  INTERESTS = 'INTERESTS',
  KEYWORD_SEARCH = 'KEYWORD_SEARCH',
  MORE_ACTIVITIES = 'MORE_ACTIVITIES',
  NEIGHBOURHOOD = 'NEIGHBOURHOOD',
  PINNED_ACTIVITY = 'PINNED_ACTIVITY',
  POI = 'POI',
  RECOMMENDATIONS = 'RECOMMENDATIONS',
  SLIM_CATEGORY = 'SLIM_CATEGORY',
  SUB_CATEGORIES = 'SUB_CATEGORIES',
  SUB_CATEGORY = 'SUB_CATEGORY',
  TOP_ACTIVITIES = 'TOP_ACTIVITIES',
  XSELL_RECOMMENDATIONS = 'XSELL_RECOMMENDATIONS',
}

export enum ActivityGroupViewType {
  ACTIVITY_LIST = 'ACTIVITY_LIST',
  ACTIVITY_SPANNED_TILE_LIST = 'ACTIVITY_SPANNED_TILE_LIST',
  ACTIVITY_TILES_CAROUSEL = 'ACTIVITY_TILES_CAROUSEL',
  CATEGORY_TILES_CAROUSEL = 'CATEGORY_TILES_CAROUSEL',
  KEYWORD_SEARCH = 'KEYWORD_SEARCH',
  MESSAGE = 'MESSAGE',
  SLIM_CATEGORY_TILES_CAROUSEL = 'SLIM_CATEGORY_TILES_CAROUSEL',
  TEXT = 'TEXT',
}
/** Search view options that are not filters */
export enum ActivitySearchViewOptions {
  DISTANCE_FROM_HOTEL_TO_ACTIVITY = 'DISTANCE_FROM_HOTEL_TO_ACTIVITY',
  FILTER_NESTED_CATEGORIES = 'FILTER_NESTED_CATEGORIES',
  NEARBY_ACTIVITIES = 'NEARBY_ACTIVITIES',
  SHOP_WITH_POINTS = 'SHOP_WITH_POINTS',
  SHOW_GT_BANNER = 'SHOW_GT_BANNER',
  TRAVEL_DISTANCE_FROM_HOTEL = 'TRAVEL_DISTANCE_FROM_HOTEL',
}
/** Activity sort types */
export enum ActivitySort {
  CAMPAIGN_DEALS = 'CAMPAIGN_DEALS',
  DISTANCE_FROM_HOTEL = 'DISTANCE_FROM_HOTEL',
  PRICE_HIGH_TO_LOW = 'PRICE_HIGH_TO_LOW',
  PRICE_LOW_TO_HIGH = 'PRICE_LOW_TO_HIGH',
  RECOMMENDED = 'RECOMMENDED',
}

export enum ActivityMapGroupType {
  POI = 'POI',
}

export enum ActivityCategoryType {
  ACTIVITIES = 'ACTIVITIES',
  CATEGORIES = 'CATEGORIES',
  DEALS_PROMOTIONS = 'DEALS_PROMOTIONS',
  NA = 'NA',
  RECOMMENDATIONS = 'RECOMMENDATIONS',
  TOURS = 'TOURS',
  TRANSPORTATION = 'TRANSPORTATION',
}

export enum ActivityUdsToken {
  MULTI_SELECT_LIST = 'MULTI_SELECT_LIST',
  MULTI_SELECT_RANGE = 'MULTI_SELECT_RANGE',
  SINGLE_SELECT = 'SINGLE_SELECT',
  TEXT = 'TEXT',
}
/** Activity Page Type - infosite */
export enum ActivityPageType {
  ACTIVITY_INFO = 'ACTIVITY_INFO',
}
/** Activity page Meta Tag types - NamedMetaTag, PropertyMetaTag and so on */
export enum ActivityPageMetaTagType {
  HTTP_EQUIV = 'HTTP_EQUIV',
  NAME = 'NAME',
  PROPERTY = 'PROPERTY',
}
/** The text direction of the locale e.g. ltr or rtl */
export enum TextDirection {
  LTR = 'LTR',
  RTL = 'RTL',
}
/** Cabin class chosen in flight */
export enum FlightsCabinClass {
  BUSINESS = 'BUSINESS',
  COACH = 'COACH',
  FIRST = 'FIRST',
  PREMIUM_ECONOMY = 'PREMIUM_ECONOMY',
}
/** Possible advanced filter types */
export enum FlightsAdvancedFilterType {
  NONSTOP = 'NONSTOP',
  REFUNDABLE = 'REFUNDABLE',
}
/** Possible traveler details types */
export enum TravelerDetailsType {
  ADULT = 'ADULT',
  CHILD = 'CHILD',
  INFANT_IN_LAP = 'INFANT_IN_LAP',
  INFANT_IN_SEAT = 'INFANT_IN_SEAT',
}
/** Trip type chosen in flight search */
export enum FlightsTripType {
  MULTI_DESTINATION = 'MULTI_DESTINATION',
  ONE_WAY = 'ONE_WAY',
  ROUND_TRIP = 'ROUND_TRIP',
}
/** Possible equipment requested by the customer */
export enum SpecialEquipment {
  ADDITIONAL_DRIVER = 'ADDITIONAL_DRIVER',
  BICYCLE_RACK = 'BICYCLE_RACK',
  BOOSTER_SEAT = 'BOOSTER_SEAT',
  INFANT_SEAT = 'INFANT_SEAT',
  LEFT_HAND_CONTROL = 'LEFT_HAND_CONTROL',
  LUGGAGE_RACK = 'LUGGAGE_RACK',
  NAV_SYSTEM = 'NAV_SYSTEM',
  RIGHT_HAND_CONTROL = 'RIGHT_HAND_CONTROL',
  ROAD_CONGESTION_PAYMENT_SCHEME = 'ROAD_CONGESTION_PAYMENT_SCHEME',
  SATELLITE_RADIO = 'SATELLITE_RADIO',
  SKI_RACK = 'SKI_RACK',
  SNOW_CHAINS = 'SNOW_CHAINS',
  SNOW_TIRES = 'SNOW_TIRES',
  TODDLER_SEAT = 'TODDLER_SEAT',
  TOLL_PAYMENT_TAG_PASS = 'TOLL_PAYMENT_TAG_PASS',
  TRAILER_HITCH = 'TRAILER_HITCH',
  WIFI_ACCESS = 'WIFI_ACCESS',
  WINTER_PACKAGE = 'WINTER_PACKAGE',
}
/** Indicate the inventory type of a given offer */
export enum InventoryType {
  AICTRAVELGROUP = 'AICTRAVELGROUP',
  AMOMA = 'AMOMA',
  ANA = 'ANA',
  BESTBUYHOTEL = 'BESTBUYHOTEL',
  BONOTEL = 'BONOTEL',
  CNTRAVEL = 'CNTRAVEL',
  CTRIP = 'CTRIP',
  DESPEGAR = 'DESPEGAR',
  DIDATRAVEL = 'DIDATRAVEL',
  DIRECT_AGENCY = 'DIRECT_AGENCY',
  EUROPLAYAS = 'EUROPLAYAS',
  EXCITEHOLIDAYS = 'EXCITEHOLIDAYS',
  EZZEGO_1 = 'EZZEGO_1',
  GETAROOM = 'GETAROOM',
  HOME_AWAY = 'HOME_AWAY',
  HOTELDOBESTDAYTRAVEL = 'HOTELDOBESTDAYTRAVEL',
  HOTEL_BEDS = 'HOTEL_BEDS',
  HRS = 'HRS',
  JAC_TRAVEL = 'JAC_TRAVEL',
  JAL = 'JAL',
  JALAN = 'JALAN',
  JTB = 'JTB',
  JUMBOTOURS = 'JUMBOTOURS',
  MAGICROOMS = 'MAGICROOMS',
  MERCHANT = 'MERCHANT',
  MGBEDBANK = 'MGBEDBANK',
  MIKI = 'MIKI',
  MTS = 'MTS',
  NTA = 'NTA',
  NUITEE = 'NUITEE',
  OPAQUE = 'OPAQUE',
  OSTROVOK = 'OSTROVOK',
  PEGASUS = 'PEGASUS',
  RAKUTEN = 'RAKUTEN',
  RESTEL = 'RESTEL',
  ROOMER = 'ROOMER',
  SMYROOMS = 'SMYROOMS',
  SUNHOTELS = 'SUNHOTELS',
  THOMASCOOK_EUR = 'THOMASCOOK_EUR',
  THOMASCOOK_UK = 'THOMASCOOK_UK',
  TOURICO = 'TOURICO',
  TRAVELLANDA = 'TRAVELLANDA',
  TRAVELREPUBLIC = 'TRAVELREPUBLIC',
  VENERE = 'VENERE',
  VRBO = 'VRBO',
  WELCOME_BEDS = 'WELCOME_BEDS',
  WOORI = 'WOORI',
  WORLDHOTELLINK = 'WORLDHOTELLINK',
  WORLDSPAN = 'WORLDSPAN',
  WOTIF = 'WOTIF',
  YOUTRAVEL = 'YOUTRAVEL',
  ZUMATA = 'ZUMATA',
}
/** Indicate the shopping path of a given offer */
export enum ShoppingPathType {
  ATTACH = 'ATTACH',
  PACKAGE = 'PACKAGE',
  STANDALONE = 'STANDALONE',
}

export enum CrossSellProductType {
  ACTIVITY = 'ACTIVITY',
  CAR = 'CAR',
  FLIGHT = 'FLIGHT',
  HOTEL = 'HOTEL',
}
/** Options that alter behavior of mutation - for backward compatibility */
export enum PrepareCheckoutResponseOption {
  ALTERNATIVE_ACTION_ON_FAILURE = 'ALTERNATIVE_ACTION_ON_FAILURE',
}

export enum RewardsPointSelectionEnum {
  APPLY_REWARD_POINTS = 'APPLY_REWARD_POINTS',
  DO_NOT_APPLY_REWARD_POINTS = 'DO_NOT_APPLY_REWARD_POINTS',
}

export enum CarActionType {
  APPLY_LOYALTY_POINTS = 'APPLY_LOYALTY_POINTS',
  CAR_MAP_MARKER = 'CAR_MAP_MARKER',
  DISMISS = 'DISMISS',
  FORM_SUBMISSION = 'FORM_SUBMISSION',
  GO_BACK_TO_SEARCH = 'GO_BACK_TO_SEARCH',
  GO_TO_CANCELLATION_POLICY = 'GO_TO_CANCELLATION_POLICY',
  GO_TO_CHECKOUT = 'GO_TO_CHECKOUT',
  GO_TO_CLEANLINESS_DIALOG = 'GO_TO_CLEANLINESS_DIALOG',
  GO_TO_DETAILS = 'GO_TO_DETAILS',
  GO_TO_PACKAGES = 'GO_TO_PACKAGES',
  GO_TO_RECOMMENDED_SORT_FAQ = 'GO_TO_RECOMMENDED_SORT_FAQ',
  GO_TO_SIGNIN = 'GO_TO_SIGNIN',
  GO_TO_SIGNUP = 'GO_TO_SIGNUP',
  LOAD_MORE = 'LOAD_MORE',
  OPEN_DIALOG = 'OPEN_DIALOG',
  OPEN_INLINE_WIZARD = 'OPEN_INLINE_WIZARD',
  OPEN_NEW_TAB = 'OPEN_NEW_TAB',
  OPEN_ON_CURRENT_TAB = 'OPEN_ON_CURRENT_TAB',
  OPEN_TEL = 'OPEN_TEL',
  REFRESH = 'REFRESH',
  REMOVE_LOYALTY_POINTS = 'REMOVE_LOYALTY_POINTS',
  SEE_CARS_AT_MAP_MARKER = 'SEE_CARS_AT_MAP_MARKER',
  SHARE_FEEDBACK = 'SHARE_FEEDBACK',
  SHOW_AARP_EXCLUSIVE_OFFERS = 'SHOW_AARP_EXCLUSIVE_OFFERS',
  SHOW_FREE_CANCELLATION_OFFERS = 'SHOW_FREE_CANCELLATION_OFFERS',
  UNLOCK_CAR_SALES = 'UNLOCK_CAR_SALES',
}

export enum CarsDialogType {
  LIMITED_RESULTS = 'LIMITED_RESULTS',
}

export enum CarsRichTextStyle {
  BOLD = 'BOLD',
  BULLET = 'BULLET',
  ITALICIZE = 'ITALICIZE',
}

export enum CarAccessorySelectionState {
  NOT_SELECTED = 'NOT_SELECTED',
  SELECTED = 'SELECTED',
}

export enum CarMapMarkerType {
  CarMarker = 'CarMarker',
  PlaceMarker = 'PlaceMarker',
}

export enum PackageType {
  FLIGHT_CAR = 'FLIGHT_CAR',
  FLIGHT_HOTEL = 'FLIGHT_HOTEL',
  FLIGHT_HOTEL_CAR = 'FLIGHT_HOTEL_CAR',
  HOTEL_CAR = 'HOTEL_CAR',
}

export enum CarRouteType {
  ONEWAY = 'ONEWAY',
  ROUNDTRIP = 'ROUNDTRIP',
}

export enum CarLabelTheme {
  CLICKABLE = 'CLICKABLE',
}

export enum CruiseFeature {
  MEMBER_DEALS = 'MEMBER_DEALS',
}

export enum PropertyFilterAccessibility {
  ACCESSIBLE_BATHROOM = 'ACCESSIBLE_BATHROOM',
  IN_ROOM_ACCESSIBLE = 'IN_ROOM_ACCESSIBLE',
  ROLL_IN_SHOWER = 'ROLL_IN_SHOWER',
}

export enum AgencyBusinessModel {
  EXPEDIA_COLLECT = 'EXPEDIA_COLLECT',
  HOTEL_COLLECT = 'HOTEL_COLLECT',
}

export enum PropertyFilterAmenity {
  AIR_CONDITIONING = 'AIR_CONDITIONING',
  ALL_INCLUSIVE = 'ALL_INCLUSIVE',
  BEACH = 'BEACH',
  CASINO = 'CASINO',
  FREE_AIRPORT_TRANSPORTATION = 'FREE_AIRPORT_TRANSPORTATION',
  FREE_BREAKFAST = 'FREE_BREAKFAST',
  FREE_PARKING = 'FREE_PARKING',
  GOLF = 'GOLF',
  HOT_SPRING = 'HOT_SPRING',
  HOT_TUB = 'HOT_TUB',
  KITCHEN_KITCHEN = 'KITCHEN_KITCHEN',
  KITCHEN_KITCHENETTE = 'KITCHEN_KITCHENETTE',
  OCEAN_VIEW = 'OCEAN_VIEW',
  PETS = 'PETS',
  POOL = 'POOL',
  SPA_ON_SITE = 'SPA_ON_SITE',
  WASHER_DRYER = 'WASHER_DRYER',
  WATER_PARK = 'WATER_PARK',
  WIFI = 'WIFI',
}

export enum CleaningAndSafetyPractice {
  ENHANCED_CLEANING = 'ENHANCED_CLEANING',
}

export enum CommissionTier {
  BASIC = 'BASIC',
  BASIC_PLUS = 'BASIC_PLUS',
  PREMIUM = 'PREMIUM',
  PREMIUM_PLUS = 'PREMIUM_PLUS',
}

export enum DealType {
  AARP = 'AARP',
  POINTS_PROMOTION = 'POINTS_PROMOTION',
}

export enum MealPlanFilterAmenity {
  ALL_INCLUSIVE = 'ALL_INCLUSIVE',
  FREE_BREAKFAST = 'FREE_BREAKFAST',
  FULL_BOARD = 'FULL_BOARD',
  HALF_BOARD = 'HALF_BOARD',
}

export enum PaymentType {
  COUPON_ELIGIBLE = 'COUPON_ELIGIBLE',
  FREE_CANCELLATION = 'FREE_CANCELLATION',
  PAY_LATER = 'PAY_LATER',
  PAY_LATER_WITH_DEPOSIT = 'PAY_LATER_WITH_DEPOSIT',
  PAY_WITHOUT_CREDITCARD = 'PAY_WITHOUT_CREDITCARD',
}

export enum PropertyStyle {
  BOUTIQUE = 'BOUTIQUE',
  HOMES = 'HOMES',
  HOTELS = 'HOTELS',
  LGBT = 'LGBT',
  LUXURY = 'LUXURY',
  OUTDOOR = 'OUTDOOR',
  UNIQUE = 'UNIQUE',
}

export enum StructureType {
  AGRITOURISM = 'AGRITOURISM',
  ALL_INCLUSIVE = 'ALL_INCLUSIVE',
  APARTMENT = 'APARTMENT',
  APART_HOTEL = 'APART_HOTEL',
  BED_AND_BREAKFAST = 'BED_AND_BREAKFAST',
  CABIN = 'CABIN',
  CAPSULE_HOTEL = 'CAPSULE_HOTEL',
  CARAVAN_PARK = 'CARAVAN_PARK',
  CASTLE = 'CASTLE',
  CHALET = 'CHALET',
  CONDO = 'CONDO',
  CONDO_RESORT = 'CONDO_RESORT',
  COTTAGE = 'COTTAGE',
  COUNTRY_HOUSE = 'COUNTRY_HOUSE',
  CRUISE = 'CRUISE',
  ECO_HOTEL = 'ECO_HOTEL',
  GUEST_HOUSE = 'GUEST_HOUSE',
  HOLIDAY_PARK = 'HOLIDAY_PARK',
  HOSTAL = 'HOSTAL',
  HOSTEL = 'HOSTEL',
  HOTEL = 'HOTEL',
  HOTEL_RESORT = 'HOTEL_RESORT',
  HOUSE_BOAT = 'HOUSE_BOAT',
  INN = 'INN',
  LODGE = 'LODGE',
  LONGHOUSE = 'LONGHOUSE',
  MOTEL = 'MOTEL',
  OVERWATER = 'OVERWATER',
  PALACE = 'PALACE',
  PENSION = 'PENSION',
  POUSADA_BRAZIL = 'POUSADA_BRAZIL',
  POUSADA_PORTUGAL = 'POUSADA_PORTUGAL',
  RANCH = 'RANCH',
  RESIDENCE = 'RESIDENCE',
  RIAD = 'RIAD',
  RYOKAN = 'RYOKAN',
  SAFARI = 'SAFARI',
  SERVICED_APARTMENT = 'SERVICED_APARTMENT',
  TOWNHOUSE = 'TOWNHOUSE',
  TRADITIONAL_BUILDING = 'TRADITIONAL_BUILDING',
  TREE_HOUSE = 'TREE_HOUSE',
  UNKNOWN = 'UNKNOWN',
  VACATION_HOME = 'VACATION_HOME',
  VILLA = 'VILLA',
  VIP = 'VIP',
}

export enum TravelerType {
  BUSINESS = 'BUSINESS',
  FAMILY = 'FAMILY',
  ROMANTIC = 'ROMANTIC',
}
/** Search options that are not filters. Previously these were a large set of boolean flags in ExpWeb called `searchOptions` */
export enum PropertySearchOptions {
  ADS_ONLY = 'ADS_ONLY',
  SHOP_WITH_POINTS = 'SHOP_WITH_POINTS',
}
/** Hotel sort types */
export enum PropertySort {
  AARP_MEMBER_DISCOUNT = 'AARP_MEMBER_DISCOUNT',
  BEST_DEAL = 'BEST_DEAL',
  DISTANCE = 'DISTANCE',
  MEMBER_PRICING = 'MEMBER_PRICING',
  PRICE_HIGH_TO_LOW = 'PRICE_HIGH_TO_LOW',
  PRICE_LOW_TO_HIGH = 'PRICE_LOW_TO_HIGH',
  PRICE_RELEVANT = 'PRICE_RELEVANT',
  PROPERTY_CLASS = 'PROPERTY_CLASS',
  PROPERTY_NAME = 'PROPERTY_NAME',
  RECOMMENDED = 'RECOMMENDED',
  REVIEW = 'REVIEW',
  VACATION_RENTAL = 'VACATION_RENTAL',
}
/** Options that are not filters. Refer @code { SearchOptions } */
export enum PropertyInfoOptions {
  SHOP_WITH_POINTS = 'SHOP_WITH_POINTS',
}
/** Used to indicate what type of markup a field contains */
export enum MarkupTextType {
  HTML = 'HTML',
}

export enum BadgeIcon {
  ACCESS_TIME = 'ACCESS_TIME',
  ADD = 'ADD',
  BUNDLED_SAVINGS_PLUS = 'BUNDLED_SAVINGS_PLUS',
  EXP29639_ORB = 'EXP29639_ORB',
  FAMILY_FRIENDLY = 'FAMILY_FRIENDLY',
  INFO_OUTLINE = 'INFO_OUTLINE',
  LOB_DEALS = 'LOB_DEALS',
  LOCAL_OFFER = 'LOCAL_OFFER',
  MOD = 'MOD',
  SMARTPHONE = 'SMARTPHONE',
}

export enum Theme {
  BRAND = 'BRAND',
  BRANDED_DEAL = 'BRANDED_DEAL',
  DEAL_ADD_ON = 'DEAL_ADD_ON',
  DEAL_BUNDLED = 'DEAL_BUNDLED',
  DEAL_GENERIC = 'DEAL_GENERIC',
  DEAL_MEMBER = 'DEAL_MEMBER',
  FAMILY_FRIENDLY = 'FAMILY_FRIENDLY',
  INFO = 'INFO',
  LINK = 'LINK',
  LOYALTY = 'LOYALTY',
  LOYALTY_HIGH_TIER = 'LOYALTY_HIGH_TIER',
  LOYALTY_LOW_TIER = 'LOYALTY_LOW_TIER',
  LOYALTY_MIDDLE_TIER = 'LOYALTY_MIDDLE_TIER',
  NOTIFICATION = 'NOTIFICATION',
  SAVED = 'SAVED',
  SPONSORED = 'SPONSORED',
  SUCCESS = 'SUCCESS',
  SUCCESS_MEDIUM = 'SUCCESS_MEDIUM',
  SUPPLIER_PROMO = 'SUPPLIER_PROMO',
  URGENT = 'URGENT',
  VIEWED = 'VIEWED',
  VIP = 'VIP',
  VIP_ACCESS = 'VIP_ACCESS',
}
/** Theme information for a message. */
export enum LodgingMessageTheme {
  AGGRESSIVE = 'AGGRESSIVE',
  HIGHLIGHT = 'HIGHLIGHT',
  STRONG = 'STRONG',
}
/** Describes what kind of action being described. Copy for example describes thecoupon code copy behavior. Authwindow shows the login/signup dialog. */
export enum ActionDetailsType {
  AUTHWINDOW = 'AUTHWINDOW',
  COPY = 'COPY',
  DATEPICKER = 'DATEPICKER',
  EXTERNAL_LINK = 'EXTERNAL_LINK',
  FREE_LX = 'FREE_LX',
  OPEN = 'OPEN',
  TERMS_AND_CONDITIONS = 'TERMS_AND_CONDITIONS',
}
/** Unique identifier for a message if one needs to identify the reason for the message creation */
export enum MessageType {
  ADDON = 'ADDON',
  COMPRESSION = 'COMPRESSION',
  COUPON = 'COUPON',
  DOUBLE_POINTS = 'DOUBLE_POINTS',
  FREE_CANCELLATION = 'FREE_CANCELLATION',
  FREE_LX = 'FREE_LX',
  HOTRATE = 'HOTRATE',
  LEGAL = 'LEGAL',
  LOGIN = 'LOGIN',
  LOYALTY = 'LOYALTY',
  NO_CC = 'NO_CC',
  OVERFILTERED = 'OVERFILTERED',
  PARTNER_LINKOFF = 'PARTNER_LINKOFF',
  VACATION_RENTALS = 'VACATION_RENTALS',
}

export enum AmenityCategory {
  ACCESSIBLE_ROLL_IN_SHOWER = 'ACCESSIBLE_ROLL_IN_SHOWER',
  AIR_CONDITIONING = 'AIR_CONDITIONING',
  ALL_INCLUSIVE = 'ALL_INCLUSIVE',
  ARCADE = 'ARCADE',
  BABYSITTING = 'BABYSITTING',
  BAR = 'BAR',
  BARBECUE = 'BARBECUE',
  BOWLING = 'BOWLING',
  BREAKFAST_AVAILABLE = 'BREAKFAST_AVAILABLE',
  BREAKFAST_INCLUDED = 'BREAKFAST_INCLUDED',
  BREAKFAST_NOT_AVAILABLE = 'BREAKFAST_NOT_AVAILABLE',
  BUSINESS_SERVICES = 'BUSINESS_SERVICES',
  CHILDREN_CLUB = 'CHILDREN_CLUB',
  DAILY_HOUSEKEEPING = 'DAILY_HOUSEKEEPING',
  EXTRA_BED = 'EXTRA_BED',
  FIRE_PLACE = 'FIRE_PLACE',
  FITNESS_EQUIPMENT = 'FITNESS_EQUIPMENT',
  FREE_AIRPORT_TRANSPORTATION = 'FREE_AIRPORT_TRANSPORTATION',
  FREE_BREAKFAST = 'FREE_BREAKFAST',
  FREE_CANCEL = 'FREE_CANCEL',
  FREE_PARKING = 'FREE_PARKING',
  FREE_WELCOME_DRINK = 'FREE_WELCOME_DRINK',
  FREE_WIRED_INTERNET = 'FREE_WIRED_INTERNET',
  FRONT_DESK_24_HOURS = 'FRONT_DESK_24_HOURS',
  GROCERY = 'GROCERY',
  HIGH_SPEED_INTERNET = 'HIGH_SPEED_INTERNET',
  HOT_TUB = 'HOT_TUB',
  INTERNET_NOT_AVAILABLE = 'INTERNET_NOT_AVAILABLE',
  IN_ROOM_INTERNET = 'IN_ROOM_INTERNET',
  KIDS_POOL = 'KIDS_POOL',
  KITCHEN = 'KITCHEN',
  LAUNDRY = 'LAUNDRY',
  LIVING_AREA = 'LIVING_AREA',
  MICROWAVE = 'MICROWAVE',
  MINI_GOLF = 'MINI_GOLF',
  NON_REFUNDABLE = 'NON_REFUNDABLE',
  ON_PRIVATE_BEACH = 'ON_PRIVATE_BEACH',
  ON_THE_BEACH = 'ON_THE_BEACH',
  OUTDOOR_SPACE = 'OUTDOOR_SPACE',
  PARKING = 'PARKING',
  PARTIAL_REFUND = 'PARTIAL_REFUND',
  PETS_ALLOWED = 'PETS_ALLOWED',
  PLAYGROUND = 'PLAYGROUND',
  POOL = 'POOL',
  RESERVE_NOW_PAY_DEPOSIT = 'RESERVE_NOW_PAY_DEPOSIT',
  RESERVE_NOW_PAY_LATER = 'RESERVE_NOW_PAY_LATER',
  RESTAURANT_IN_HOTEL = 'RESTAURANT_IN_HOTEL',
  ROOM_SERVICE = 'ROOM_SERVICE',
  SMOKE_FREE = 'SMOKE_FREE',
  SOUNDPROOF_ROOM = 'SOUNDPROOF_ROOM',
  SPA_SERVICES_ON_SITE = 'SPA_SERVICES_ON_SITE',
  SPECIAL_DEAL = 'SPECIAL_DEAL',
  TENNIS_COURT = 'TENNIS_COURT',
  TOYS = 'TOYS',
  WASHER = 'WASHER',
  WATERSLIDE = 'WATERSLIDE',
  WIFI_SURCHARGE = 'WIFI_SURCHARGE',
  WIRED_INTERNET_SURCHARGE = 'WIRED_INTERNET_SURCHARGE',
}
/** Indicate what are the payment options for a given offer */
export enum PropertyPaymentType {
  PAY_LATER = 'PAY_LATER',
  PAY_LATER_WITH_DEPOSIT = 'PAY_LATER_WITH_DEPOSIT',
  PAY_NOW = 'PAY_NOW',
}

export enum LodgingInputType {
  EMAIL = 'EMAIL',
  HIDDEN = 'HIDDEN',
  PASSWORD = 'PASSWORD',
  TEL = 'TEL',
  TEXT = 'TEXT',
  URL = 'URL',
}

export enum LodgingFormMethod {
  GET = 'GET',
  POST = 'POST',
}

export enum PropertyCancellationPolicyType {
  NON_REFUNDABLE = 'NON_REFUNDABLE',
  REFUNDABLE_WITH_NO_PENALTY = 'REFUNDABLE_WITH_NO_PENALTY',
  REFUNDABLE_WITH_PENALTY = 'REFUNDABLE_WITH_PENALTY',
}

export enum RateDiscountType {
  MEMBER_DEAL = 'MEMBER_DEAL',
  MOBILE_EXCLUSIVE = 'MOBILE_EXCLUSIVE',
  REGULAR = 'REGULAR',
  TONIGHT_ONLY = 'TONIGHT_ONLY',
}

export enum FeeType {
  CARD_ON_FILE_DAMAGE_LIABILITY = 'CARD_ON_FILE_DAMAGE_LIABILITY',
  DEFAULT = 'DEFAULT',
  DEFAULT_SUPPLIER_COLLECTED = 'DEFAULT_SUPPLIER_COLLECTED',
  GROUPED_MANDATORY_FEES = 'GROUPED_MANDATORY_FEES',
  L26_TAX_BREAKOUT = 'L26_TAX_BREAKOUT',
  NORMAL = 'NORMAL',
  OTHER = 'OTHER',
  PER_PERSON_PER_NIGHT = 'PER_PERSON_PER_NIGHT',
  PROPERTY = 'PROPERTY',
  REFUNDABLE_DAMAGE_DEPOSIT = 'REFUNDABLE_DAMAGE_DEPOSIT',
  RESORT = 'RESORT',
}

export enum PropertyPaymentModel {
  PAY_LATER = 'PAY_LATER',
  PAY_LATER_WITH_DEPOSIT = 'PAY_LATER_WITH_DEPOSIT',
  PAY_NOW = 'PAY_NOW',
}

export enum StrikeOutType {
  ATTACH = 'ATTACH',
  INVALID = 'INVALID',
  LOYALTY = 'LOYALTY',
  PACKAGE = 'PACKAGE',
  PRICE_SURVEY = 'PRICE_SURVEY',
  STANDALONE = 'STANDALONE',
}

export enum PricingSchemeType {
  DAILY_RATE = 'DAILY_RATE',
  TOTAL_RATE = 'TOTAL_RATE',
}

export enum SourceType {
  ESR = 'ESR',
  GDS = 'GDS',
}

export enum PropertySectionRef {
  RECOMMENDED_OFFER = 'RECOMMENDED_OFFER',
  ROOMS_AND_RATES = 'ROOMS_AND_RATES',
}

export enum DamageLiability {
  COF = 'COF',
  RDD = 'RDD',
}
/** Filters review results by category type */
export enum PropertyReviewCategory {
  BUSINESS_TRAVELERS = 'BUSINESS_TRAVELERS',
  COUPLES = 'COUPLES',
  EVERYONE = 'EVERYONE',
  FAMILIES = 'FAMILIES',
  GETAWAY_WITH_FRIENDS = 'GETAWAY_WITH_FRIENDS',
  GOLF = 'GOLF',
  OTHER = 'OTHER',
  OVERNIGHT_STAY = 'OVERNIGHT_STAY',
  PERSONAL_EVENT = 'PERSONAL_EVENT',
  SHOPPING = 'SHOPPING',
  SPA = 'SPA',
  STUDENTS = 'STUDENTS',
}
/** [Optional] Review filter type */
export enum PropertyReviewType {
  CRITICAL = 'CRITICAL',
  POSITIVE = 'POSITIVE',
  RECENT = 'RECENT',
}
/** [Optional] Hotel reviews sort types. Defaults to NEWEST_TO_OLDEST_BY_LANGUAGE */
export enum PropertyReviewSort {
  HIGHEST_TO_LOWEST_RATED = 'HIGHEST_TO_LOWEST_RATED',
  LOWEST_TO_HIGHEST_RATED = 'LOWEST_TO_HIGHEST_RATED',
  NEWEST_TO_OLDEST = 'NEWEST_TO_OLDEST',
  NEWEST_TO_OLDEST_BY_LANGUAGE = 'NEWEST_TO_OLDEST_BY_LANGUAGE',
  OLDEST_TO_NEWEST = 'OLDEST_TO_NEWEST',
  OLDEST_TO_NEWEST_BY_LANGUAGE = 'OLDEST_TO_NEWEST_BY_LANGUAGE',
}
/** Type that represents the amenity category icons for the property */
export enum PropertyAmenityCategoryType {
  ACCESSIBLE_ROLL_IN_SHOWER = 'ACCESSIBLE_ROLL_IN_SHOWER',
  AIR_CONDITIONING = 'AIR_CONDITIONING',
  ALL_INCLUSIVE = 'ALL_INCLUSIVE',
  ARCADE = 'ARCADE',
  BABYSITTING = 'BABYSITTING',
  BAR = 'BAR',
  BOWLING = 'BOWLING',
  BREAKFAST_AVAILABLE = 'BREAKFAST_AVAILABLE',
  BUSINESS_SERVICES = 'BUSINESS_SERVICES',
  CHILDREN_CLUB = 'CHILDREN_CLUB',
  DAILY_HOUSEKEEPING = 'DAILY_HOUSEKEEPING',
  EXTRA_BED = 'EXTRA_BED',
  FITNESS_EQUIPMENT = 'FITNESS_EQUIPMENT',
  FREE_AIRPORT_TRANSPORTATION = 'FREE_AIRPORT_TRANSPORTATION',
  FREE_BREAKFAST = 'FREE_BREAKFAST',
  FREE_PARKING = 'FREE_PARKING',
  FREE_WELCOME_DRINK = 'FREE_WELCOME_DRINK',
  FRONT_DESK_24_HOURS = 'FRONT_DESK_24_HOURS',
  GROCERY = 'GROCERY',
  HIGH_SPEED_INTERNET = 'HIGH_SPEED_INTERNET',
  HOT_TUB = 'HOT_TUB',
  IN_ROOM_INTERNET = 'IN_ROOM_INTERNET',
  KIDS_POOL = 'KIDS_POOL',
  KITCHEN = 'KITCHEN',
  LAUNDRY = 'LAUNDRY',
  LIVING_AREA = 'LIVING_AREA',
  MICROWAVE = 'MICROWAVE',
  MINI_GOLF = 'MINI_GOLF',
  PARKING = 'PARKING',
  PETS_ALLOWED = 'PETS_ALLOWED',
  PLAYGROUND = 'PLAYGROUND',
  POOL = 'POOL',
  RESTAURANT_IN_HOTEL = 'RESTAURANT_IN_HOTEL',
  ROOM_SERVICE = 'ROOM_SERVICE',
  SMOKE_FREE = 'SMOKE_FREE',
  SOUNDPROOF_ROOM = 'SOUNDPROOF_ROOM',
  SPA_SERVICES_ON_SITE = 'SPA_SERVICES_ON_SITE',
  SPECIAL_DEAL = 'SPECIAL_DEAL',
  TENNIS_COURT = 'TENNIS_COURT',
  TOYS = 'TOYS',
  WATERSLIDE = 'WATERSLIDE',
}

export enum PropertyAmenityType {
  ACCESSIBILITY = 'ACCESSIBILITY',
  BATHROOM = 'BATHROOM',
  BEDROOM = 'BEDROOM',
  BUSINESS_SERVICES = 'BUSINESS_SERVICES',
  CONVENIENCES = 'CONVENIENCES',
  ENTERTAINMENT = 'ENTERTAINMENT',
  FAMILY_FRIENDLY = 'FAMILY_FRIENDLY',
  FOOD_DRINK = 'FOOD_DRINK',
  GUEST_SERVICES = 'GUEST_SERVICES',
  INTERNET = 'INTERNET',
  MORE = 'MORE',
  OUTDOOR = 'OUTDOOR',
  OUTDOOR_SPACE = 'OUTDOOR_SPACE',
  PARKING = 'PARKING',
  PROPERTY = 'PROPERTY',
  ROOM = 'ROOM',
  SPA = 'SPA',
  THINGS_TO_DO = 'THINGS_TO_DO',
}
/** Enumerated Gaia geographic region types */
export enum RegionType {
  ADDRESS = 'ADDRESS',
  AIRPORT = 'AIRPORT',
  CITY = 'CITY',
  CONTINENT = 'CONTINENT',
  COUNTRY = 'COUNTRY',
  HIGH_LEVEL_REGION = 'HIGH_LEVEL_REGION',
  METRO_STATION = 'METRO_STATION',
  MULTI_CITY_VICINITY = 'MULTI_CITY_VICINITY',
  NEIGHBORHOOD = 'NEIGHBORHOOD',
  POINT_OF_INTEREST = 'POINT_OF_INTEREST',
  PROVINCE_STATE = 'PROVINCE_STATE',
  TRAIN_STATION = 'TRAIN_STATION',
  UNKNOWN = 'UNKNOWN',
}
/** The UDS icon used for the map marker */
export enum MapIconType {
  AIRPORT = 'AIRPORT',
  CIRCLE = 'CIRCLE',
  HOTEL = 'HOTEL',
  LANDMARK = 'LANDMARK',
  METRO = 'METRO',
  RESTAURANT = 'RESTAURANT',
  SOLD_OUT = 'SOLD_OUT',
  TRAIN = 'TRAIN',
}
/** The type of map marker */
export enum MarkerType {
  HOTEL = 'HOTEL',
  POI = 'POI',
}
/** ADs related property search options */
export enum Listings {
  ADS_ONLY = 'ADS_ONLY',
}
/** Points related property search options */
export enum Points {
  SHOP_WITHOUT_POINTS = 'SHOP_WITHOUT_POINTS',
  SHOP_WITH_POINTS = 'SHOP_WITH_POINTS',
}
/** Enum of the units of measure and their abbreviations */
export enum DistanceUnit {
  KILOMETER = 'KILOMETER',
  MILE = 'MILE',
}

export enum OfferAttributeType {
  FREE_BREAKFAST = 'FREE_BREAKFAST',
  FREE_CANCELLATION = 'FREE_CANCELLATION',
  NO_CC_REQUIRED = 'NO_CC_REQUIRED',
  PAYMENT_CHOICE = 'PAYMENT_CHOICE',
  VIP = 'VIP',
}

export enum PropertyPaymentFlags {
  ARTIFICIALLY_FENCED_RATE = 'ARTIFICIALLY_FENCED_RATE',
  MIXED_RATE_PLAN = 'MIXED_RATE_PLAN',
  NO_CREDIT_CARD = 'NO_CREDIT_CARD',
}
/** Describes the type of product (line of business) that is being sold */
export enum LodgingCrossSellProductType {
  CAR = 'CAR',
}
/** A rough measure of the percentage of properties that are sold out in thedestination region as calculated by the Urgency Service. */
export enum CompressionLevel {
  CAP = 'CAP',
  HIGH = 'HIGH',
  LOW = 'LOW',
  MEDIUM = 'MEDIUM',
  NA = 'NA',
}
/** Supported capabilities of chatbot VAC. */
export enum ChatbotCapabilities {
  CLICKSTREAM = 'CLICKSTREAM',
  GLASSBOX = 'GLASSBOX',
}
/** Supported versions of chatbot. */
export enum ChatbotVersionId {
  V1 = 'V1',
  V2 = 'V2',
}
/** Indicates the coupon's active state */
export enum ActiveState {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  UNKNOWN = 'UNKNOWN',
  USED = 'USED',
}

export enum TripIntentPersonType {
  ADULT = 'ADULT',
  CHILD = 'CHILD',
}
/** The text style to apply to strings */
export enum CustomerNotificationPhrasePartStyle {
  EMPHASIS = 'EMPHASIS',
  IMPORTANT = 'IMPORTANT',
  STANDARD = 'STANDARD',
}
/** Represents the target of the link */
export enum CustomerNotificationLinkTarget {
  NEW_TAB = 'NEW_TAB',
  SAME_TAB = 'SAME_TAB',
}
/** The display type of the Customer notification message */
export enum CustomerNotificationMessageDisplayType {
  FORM = 'FORM',
  PAGE = 'PAGE',
}
/** The level type of the Customer notification message */
export enum CustomerNotificationMessageLevel {
  ERROR = 'ERROR',
  SUCCESS = 'SUCCESS',
  WARNING = 'WARNING',
}
/** The style to apply to phrase links */
export enum CustomerNotificationPhraseLinkStyle {
  FLOATING_ACTION_BUTTON = 'FLOATING_ACTION_BUTTON',
  PRIMARY_BUTTON = 'PRIMARY_BUTTON',
  SECONDARY_BUTTON = 'SECONDARY_BUTTON',
  TERTIARY_BUTTON = 'TERTIARY_BUTTON',
}
/** Represents the link type */
export enum CustomerNotificationLinkType {
  ANCHOR = 'ANCHOR',
  APP_DOWNLOAD_LINK = 'APP_DOWNLOAD_LINK',
  BUTTON = 'BUTTON',
  FLOATING_ACTION_BUTTON = 'FLOATING_ACTION_BUTTON',
  PRIMARY_BUTTON = 'PRIMARY_BUTTON',
  SECONDARY_BUTTON = 'SECONDARY_BUTTON',
  TERTIARY_BUTTON = 'TERTIARY_BUTTON',
}

export enum CustomerNotificationType {
  APP_DOWNLOAD = 'APP_DOWNLOAD',
  APP_HERO = 'APP_HERO',
  CITI_COBRAND = 'CITI_COBRAND',
  GDPR = 'GDPR',
  MAD_MARQUEE = 'MAD_MARQUEE',
  NONE = 'NONE',
  TRAVEL_ADVISORY = 'TRAVEL_ADVISORY',
}

export enum HistoryType {
  ACTIVITY_DETAIL = 'ACTIVITY_DETAIL',
  ACTIVITY_SEARCH = 'ACTIVITY_SEARCH',
  CAR_DETAIL = 'CAR_DETAIL',
  CAR_SEARCH = 'CAR_SEARCH',
  CRUISE_SEARCH = 'CRUISE_SEARCH',
  FLIGHT_DETAIL = 'FLIGHT_DETAIL',
  FLIGHT_SEARCH = 'FLIGHT_SEARCH',
  PACKAGE_SEARCH = 'PACKAGE_SEARCH',
  PROPERTY_DETAIL = 'PROPERTY_DETAIL',
  PROPERTY_SEARCH = 'PROPERTY_SEARCH',
}

export enum FunnelLocation {
  CHECKOUT = 'CHECKOUT',
  CHECKOUT_ERROR = 'CHECKOUT_ERROR',
  CONFIRMATION = 'CONFIRMATION',
  DETAILS = 'DETAILS',
  ENTRY = 'ENTRY',
  FEATURES = 'FEATURES',
  PAYMENT_ERROR = 'PAYMENT_ERROR',
  POST_BOOKING = 'POST_BOOKING',
  SEARCH_RESULTS = 'SEARCH_RESULTS',
  SYSTEM = 'SYSTEM',
  USER = 'USER',
}

export enum ExpLineOfBusiness {
  ACTIVITIES = 'ACTIVITIES',
  CAR = 'CAR',
  CRUISES = 'CRUISES',
  FLIGHT = 'FLIGHT',
  GROUNDTRANSFERS = 'GROUNDTRANSFERS',
  HOTEL = 'HOTEL',
  PACKAGES = 'PACKAGES',
  RAILS = 'RAILS',
  UNCLASSIFIED = 'UNCLASSIFIED',
}

export enum NotificationLocation {
  AFTER_HEADER = 'AFTER_HEADER',
  FOOTER = 'FOOTER',
  IN_PAGE = 'IN_PAGE',
  IN_PAGE_AD = 'IN_PAGE_AD',
  POPUP = 'POPUP',
  PRE_HEADER = 'PRE_HEADER',
}
/** Search history grouping day range. */
export enum SearchHistoryDayRange {
  SEVEN_DAYS = 'SEVEN_DAYS',
  THREE_DAYS = 'THREE_DAYS',
}
/** Search history grouping destination type. */
export enum SearchHistoryDestinationType {
  METRO_CITY = 'METRO_CITY',
}
/** Gender of the customer */
export enum CustomerGender {
  FEMALE = 'FEMALE',
  MALE = 'MALE',
  UNKNOWN = 'UNKNOWN',
}
/** Represent all the possible traveler types */
export enum FlightsTravelerType {
  ADULT = 'ADULT',
  CHILD = 'CHILD',
  INFANT_IN_LAP = 'INFANT_IN_LAP',
  INFANT_IN_SEAT = 'INFANT_IN_SEAT',
}
/** Represents the state the client wants to query */
export enum FlightsQueryState {
  LOADED = 'LOADED',
  LOADING = 'LOADING',
}
/** Describes the type of actionable button. Types reference UDS tokens for buttons. */
export enum FlightsActionDisplayType {
  PRIMARY = 'PRIMARY',
  SECONDARY = 'SECONDARY',
  TERTIARY = 'TERTIARY',
}
/** Available action types an actionable element */
export enum FlightsActionType {
  APPLY_FARE = 'APPLY_FARE',
  CHOOSE_FARE = 'CHOOSE_FARE',
  DISMISS = 'DISMISS',
  ENABLE_SUGGESTED_FILTER = 'ENABLE_SUGGESTED_FILTER',
  FETCH_SEARCH_LISTINGS = 'FETCH_SEARCH_LISTINGS',
  GO_TO_CHECKOUT = 'GO_TO_CHECKOUT',
  GO_TO_DETAILS = 'GO_TO_DETAILS',
  GO_TO_NEXT_JOURNEY = 'GO_TO_NEXT_JOURNEY',
  GO_TO_PACKAGES = 'GO_TO_PACKAGES',
  GO_TO_SEARCH = 'GO_TO_SEARCH',
  GO_TO_STOREFRONT = 'GO_TO_STOREFRONT',
  LOAD_CROSS_SELL_DIALOG = 'LOAD_CROSS_SELL_DIALOG',
  LOAD_STANDARD_OFFER_FARE_RULE_MODULE = 'LOAD_STANDARD_OFFER_FARE_RULE_MODULE',
  LOAD_TAX_BREAKDOWN_DIALOG = 'LOAD_TAX_BREAKDOWN_DIALOG',
  OPEN_BOOK_DIRECTLY_WITH_AIRLINES_DIALOG = 'OPEN_BOOK_DIRECTLY_WITH_AIRLINES_DIALOG',
  OPEN_PRICE_SUMMARY = 'OPEN_PRICE_SUMMARY',
  REDIRECT_TO_AIRLINES_FOR_BOOKING = 'REDIRECT_TO_AIRLINES_FOR_BOOKING',
  REFRESH = 'REFRESH',
  SEARCH_FORM_ADD_JOURNEY = 'SEARCH_FORM_ADD_JOURNEY',
  SEARCH_FORM_CLOSE_BUTTON = 'SEARCH_FORM_CLOSE_BUTTON',
  SEARCH_FORM_REMOVE_JOURNEY = 'SEARCH_FORM_REMOVE_JOURNEY',
  SHARE_FEEDBACK = 'SHARE_FEEDBACK',
}
/** Represents an object to be used to differentiate the type of Placards(Ex :Placards to be shown immediately vs those which are shown during server error */
export enum FlightsPlacardDisplayType {
  IMMEDIATE = 'IMMEDIATE',
  SORT_FILTERS_SERVER_ERROR = 'SORT_FILTERS_SERVER_ERROR',
}
/** The text style to apply to strings */
export enum FlightsPhrasePartStyle {
  EMPHASIS = 'EMPHASIS',
  IMPORTANT = 'IMPORTANT',
  STANDARD = 'STANDARD',
}
/** Metrics names */
export enum FlightsMetricName {
  LISTINGS_SUPPLY_RESPONSE_TIME = 'LISTINGS_SUPPLY_RESPONSE_TIME',
}
/** Tags Associated with the response */
export enum ResponseTagType {
  LISTINGS_PAGINATED = 'LISTINGS_PAGINATED',
  LISTINGS_PAGINATED_SLICED = 'LISTINGS_PAGINATED_SLICED',
  LISTING_CACHE_SOURCE = 'LISTING_CACHE_SOURCE',
  LISTING_DOWNLEVEL_SOURCE = 'LISTING_DOWNLEVEL_SOURCE',
  RESPONSE_SUMMARY_CACHED_CONFIG = 'RESPONSE_SUMMARY_CACHED_CONFIG',
  RESPONSE_SUMMARY_CACHED_ML = 'RESPONSE_SUMMARY_CACHED_ML',
  RESPONSE_SUMMARY_HYBRID = 'RESPONSE_SUMMARY_HYBRID',
  RESPONSE_SUMMARY_LIVE = 'RESPONSE_SUMMARY_LIVE',
  SIDESHEET_ORIGINAL = 'SIDESHEET_ORIGINAL',
  SIDESHEET_STRINGIFIED = 'SIDESHEET_STRINGIFIED',
  UNRECOGNIZED = 'UNRECOGNIZED',
}
/** Represents the type of animation the dialog will use when displayed */
export enum FlightsDialogAnimation {
  FADE = 'FADE',
  NONE = 'NONE',
}
/** Represents the theme values for a Badge */
export enum FlightsBadgeTheme {
  DEAL_BUNDLED = 'DEAL_BUNDLED',
  DEAL_GENERIC = 'DEAL_GENERIC',
  DEAL_MEMBER = 'DEAL_MEMBER',
  FAMILY_FRIENDLY = 'FAMILY_FRIENDLY',
  NOTIFICATION = 'NOTIFICATION',
  SAVED = 'SAVED',
  SPONSORED = 'SPONSORED',
  SUPPLIER_PROMO = 'SUPPLIER_PROMO',
  VIEWED = 'VIEWED',
  VIP = 'VIP',
}
/** Css class names for datepicker cell content. */
export enum FlightsFareCalendarPriceTheme {
  NEGATIVE = 'NEGATIVE',
  POSITIVE = 'POSITIVE',
  UNDEFINED = 'UNDEFINED',
}
/** Represent the fares needs to be present in listing results */
export enum FlightsFaresSeparationType {
  BASE_AND_UPSELL = 'BASE_AND_UPSELL',
  ONLY_BASE = 'ONLY_BASE',
  ONLY_UPSELL = 'ONLY_UPSELL',
}
/** Represents flights component */
export enum FlightsDisplayComponent {
  SMART_NFF_ALTERNATE_SUGGESTION = 'SMART_NFF_ALTERNATE_SUGGESTION',
}
/** Enum representing the various time slots in a day */
export enum FlightsTimeOfDay {
  AFTERNOON = 'AFTERNOON',
  EARLY_MORNING = 'EARLY_MORNING',
  EVENING = 'EVENING',
  MORNING = 'MORNING',
}
/** Enum class to represent the type of flexible change policies */
export enum FilterPolicyType {
  NO_CHANGE_FEE = 'NO_CHANGE_FEE',
}
/** Enum class to represent the operation associated with num of stops */
export enum FlightsStopFilterOperation {
  EQUAL = 'EQUAL',
  GREATER_THAN_EQUAL = 'GREATER_THAN_EQUAL',
  LESS_THAN_EQUAL = 'LESS_THAN_EQUAL',
}
/** Enum which lists the sort orders */
export enum FlightsSortOrder {
  DECREASING = 'DECREASING',
  INCREASING = 'INCREASING',
}
/** Enum class which lists all the supported sorting criteria */
export enum FlightsSortType {
  ARRIVAL = 'ARRIVAL',
  DEPARTURE = 'DEPARTURE',
  DURATION = 'DURATION',
  PRICE = 'PRICE',
  RECOMMENDED = 'RECOMMENDED',
}

export enum FlightsFlexibleGridType {
  FLEX_SEARCH = 'FLEX_SEARCH',
  FLEX_SEARCH_GRID = 'FLEX_SEARCH_GRID',
  FLEX_SEARCH_NOT_APPLICABLE = 'FLEX_SEARCH_NOT_APPLICABLE',
}
/** Represents cross sell product types that will be displayed */
export enum FlightCrossSellProductType {
  CAR = 'CAR',
  HOTEL = 'HOTEL',
}
/** Represents all the common information in the journey review block on FIS */
export enum FreeCancellationApplicability {
  ALL_JOURNEYS = 'ALL_JOURNEYS',
  CURRENT_JOUNRNEY = 'CURRENT_JOUNRNEY',
  NOT_APPLICABLE = 'NOT_APPLICABLE',
}

export enum FlightsFilterType {
  ARRIVAL_AIRPORT = 'ARRIVAL_AIRPORT',
  ARRIVAL_TIME = 'ARRIVAL_TIME',
  DEPARTURE_AIRPORT = 'DEPARTURE_AIRPORT',
  DEPARTURE_TIME = 'DEPARTURE_TIME',
  DURATION = 'DURATION',
  FLEXIBLE_CHANGE_POLICIES = 'FLEXIBLE_CHANGE_POLICIES',
  NUM_OF_STOPS = 'NUM_OF_STOPS',
  PREFERRED_AIRLINE = 'PREFERRED_AIRLINE',
}
/** Represents the display of progress bar when the results are loading */
export enum FlightsProgressBarDisplay {
  DISABLED = 'DISABLED',
  ENABLED = 'ENABLED',
}

export enum FlightsSearchFormErrorType {
  CHILD_AGE_MISSING = 'CHILD_AGE_MISSING',
  DATE_BEFORE_PREVIOUS_DATE = 'DATE_BEFORE_PREVIOUS_DATE',
  DATE_NOT_IN_VALID_RANGE = 'DATE_NOT_IN_VALID_RANGE',
  DATE_NOT_IN_VALID_RANGE_TO_DEFAULT_DATE = 'DATE_NOT_IN_VALID_RANGE_TO_DEFAULT_DATE',
  INFANT_AGE_MISSING = 'INFANT_AGE_MISSING',
  INVALID_DATE_FORMAT = 'INVALID_DATE_FORMAT',
  INVALID_TRAVELER_COUNT = 'INVALID_TRAVELER_COUNT',
  LESS_THAN_MINIMUM_ADULT = 'LESS_THAN_MINIMUM_ADULT',
  LOCATION_EMPTY = 'LOCATION_EMPTY',
  LOCATION_SAME = 'LOCATION_SAME',
  MAX_STAY_DURATION_ERROR = 'MAX_STAY_DURATION_ERROR',
  SAME_CITY = 'SAME_CITY',
  SPECIAL_CHARACTER_NOT_ALLOWED = 'SPECIAL_CHARACTER_NOT_ALLOWED',
  TOO_SHORT_AIRPORT_STRING = 'TOO_SHORT_AIRPORT_STRING',
  UNATTENDED_INFANT_IN_LAP = 'UNATTENDED_INFANT_IN_LAP',
  UNATTENDED_INFANT_IN_SEAT = 'UNATTENDED_INFANT_IN_SEAT',
}

export enum PoiMapItemCategory {
  ACTIVITY = 'ACTIVITY',
  RESTAURANT = 'RESTAURANT',
}

export enum UserCoordinateType {
  AIRPORT = 'AIRPORT',
  PROPERTY = 'PROPERTY',
}

export enum PoiMapItemCardType {
  POI_MAP_ITEM_SUMMARY_CARD = 'POI_MAP_ITEM_SUMMARY_CARD',
}

export enum PoiMapPinType {
  AIRPORT = 'AIRPORT',
  POI = 'POI',
  PROPERTY = 'PROPERTY',
}
/** ID used to identify a month for queries that bucket data by month */
export enum MonthId {
  APRIL = 'APRIL',
  AUGUST = 'AUGUST',
  DECEMBER = 'DECEMBER',
  FEBRUARY = 'FEBRUARY',
  JANUARY = 'JANUARY',
  JULY = 'JULY',
  JUNE = 'JUNE',
  MARCH = 'MARCH',
  MAY = 'MAY',
  NOVEMBER = 'NOVEMBER',
  OCTOBER = 'OCTOBER',
  SEPTEMBER = 'SEPTEMBER',
}

export enum ProductType {
  ARTICLE = 'ARTICLE',
  CAR_DETAILS = 'CAR_DETAILS',
  DESTINATION = 'DESTINATION',
  DESTINATION_EXPERIENCE = 'DESTINATION_EXPERIENCE',
  EXPERIENCE = 'EXPERIENCE',
  EXPERT_TIP = 'EXPERT_TIP',
  FLIGHT_SEARCH = 'FLIGHT_SEARCH',
  LX_DETAILS = 'LX_DETAILS',
  NEIGHBORHOOD = 'NEIGHBORHOOD',
  POI_GAIA = 'POI_GAIA',
  PROPERTY_DETAILS = 'PROPERTY_DETAILS',
}

export enum FooterButtonType {
  PRIMARY = 'PRIMARY',
  SECONDARY = 'SECONDARY',
  TERTIARY = 'TERTIARY',
}

export enum FooterSeparatorType {
  HORIZONTAL_RULE = 'HORIZONTAL_RULE',
}
/** Line of business that is querying the global navigation elements. */
export enum GlobalNavigationLineOfBusiness {
  ACTIVITY = 'ACTIVITY',
  CAR = 'CAR',
  CRUISE = 'CRUISE',
  FLIGHT = 'FLIGHT',
  HOTEL = 'HOTEL',
  PACKAGE = 'PACKAGE',
  UNKNOWN = 'UNKNOWN',
}
/** Different viewport sizes to display the header. */
export enum HeaderViewSize {
  EXTRA_LARGE = 'EXTRA_LARGE',
  LARGE = 'LARGE',
  MEDIUM = 'MEDIUM',
  SMALL = 'SMALL',
}
/** Header section alignment of elements to either the start or end of the section container. */
export enum HeaderAlignment {
  END = 'END',
  START = 'START',
}
/** Determines the type of button to display.  Primary or tertiary. */
export enum HeaderButtonType {
  PRIMARY = 'PRIMARY',
  TERTIARY = 'TERTIARY',
}
/** Used to position the header menu dropdown as well as icons in links and buttons.  Options are LEFT or RIGHT. */
export enum HeaderItemPosition {
  LEFT = 'LEFT',
  RIGHT = 'RIGHT',
}
/** Inserts a separator in header menus. */
export enum HeaderSeparatorType {
  HORIZONTAL_RULE = 'HORIZONTAL_RULE',
}
/** Type of text.  Heading or subheading. */
export enum HeaderTextType {
  HEADING = 'HEADING',
  SUBHEADING = 'SUBHEADING',
}

export enum PickerTriggerPlacementType {
  MENU_ITEM = 'MENU_ITEM',
  NAV_LINK = 'NAV_LINK',
}

export enum PickerTriggerDisplayType {
  GLOBAL_NAV_BUTTON = 'GLOBAL_NAV_BUTTON',
  GLOBAL_NAV_LINK = 'GLOBAL_NAV_LINK',
}

export enum MemberWalletBadgeTheme {
  LOYALTY_HIGH_TIER = 'LOYALTY_HIGH_TIER',
  LOYALTY_LOW_TIER = 'LOYALTY_LOW_TIER',
  LOYALTY_MIDDLE_TIER = 'LOYALTY_MIDDLE_TIER',
}

export enum PropertyDetailsPropertyType {
  HOTEL = 'HOTEL',
  VACATION_RENTAL = 'VACATION_RENTAL',
}

export enum CampaignProductType {
  ACTIVITY = 'ACTIVITY',
  FLIGHT = 'FLIGHT',
  HOTEL = 'HOTEL',
  PACKAGE = 'PACKAGE',
}

export enum RecommendedType {
  BESPOKE = 'BESPOKE',
  DESTINATIONS = 'DESTINATIONS',
  OFFERS = 'OFFERS',
}

export enum CampaignOfferBadgeType {
  DEFAULT = 'DEFAULT',
  DISCOUNT = 'DISCOUNT',
}

export enum ProductQuestionTopic {
  HOTEL = 'HOTEL',
}

export enum QuestionSortType {
  NEWEST_TO_OLDEST = 'NEWEST_TO_OLDEST',
  OLDEST_TO_NEWEST = 'OLDEST_TO_NEWEST',
}

export enum KeyPhrasesClientType {
  DEFAULT = 'DEFAULT',
  FILTER = 'FILTER',
  SNIPPET = 'SNIPPET',
}

export enum CheckoutServiceResult {
  FAILURE = 'FAILURE',
  SUCCESS = 'SUCCESS',
}

export enum PaymentTokenType {
  CREDIT_CARD = 'CREDIT_CARD',
  STORED_CARD = 'STORED_CARD',
}

export enum PaymentMethodType {
  CREDIT_CARD = 'CREDIT_CARD',
  PAYPAL = 'PAYPAL',
  POINTS = 'POINTS',
}

export enum ButtonType {
  PRIMARY = 'PRIMARY',
  SECONDARY = 'SECONDARY',
}

export enum PayWithPointsUpdateAction {
  APPLY = 'APPLY',
  REMOVE = 'REMOVE',
}

export enum InsuranceMutationStatus {
  FAILED = 'FAILED',
  SUCCESS = 'SUCCESS',
}

export enum InsuranceMutationType {
  ADD_INSURANCE = 'ADD_INSURANCE',
  REMOVE_INSURANCE = 'REMOVE_INSURANCE',
}

export enum CartTtl {
  FIVE_MINUTES = 'FIVE_MINUTES',
  SEVEN_DAYS = 'SEVEN_DAYS',
  TWELVE_HOURS = 'TWELVE_HOURS',
}
/** Supported Features on prepareCheckout */
export enum CheckoutOptionType {
  FENCING_ATTRIBUTES = 'FENCING_ATTRIBUTES',
  SHOP_WITH_POINTS = 'SHOP_WITH_POINTS',
}

export enum CustomerNotificationMessageType {
  INVALID_INPUT = 'INVALID_INPUT',
  SERVICE_ERROR = 'SERVICE_ERROR',
  SUCCESS = 'SUCCESS',
}

export enum Result {
  ERROR = 'ERROR',
  SUCCESS = 'SUCCESS',
}
/** Display theme for TripsContentUnorderedList */
export enum TripsContentUnorderedListTheme {
  BULLETS = 'BULLETS',
  NO_BULLETS = 'NO_BULLETS',
}

export enum TripsLinkTarget {
  EXTERNAL = 'EXTERNAL',
  INTERNAL = 'INTERNAL',
}

export enum Severity {
  ERROR = 'ERROR',
  WARNING = 'WARNING',
}

export enum FeedbackPlacement {
  FIELD = 'FIELD',
  MODULE = 'MODULE',
  PAGE = 'PAGE',
}

export enum CheckoutModule {
  INSURANCE = 'INSURANCE',
  NONE = 'NONE',
  PAYMENTS = 'PAYMENTS',
}

export enum BadgeTheme {
  DEAL_GENERIC = 'DEAL_GENERIC',
}
/** Ids of inputs that can currently exist as input in special requests */
export enum CheckoutSpecialRequestInputIds {
  ACCESSIBILITY_INPUT = 'ACCESSIBILITY_INPUT',
  BEDDING_INPUT = 'BEDDING_INPUT',
  SMOKING_INPUT = 'SMOKING_INPUT',
  SPECIAL_REQUEST_TEXT = 'SPECIAL_REQUEST_TEXT',
}
/** Types of html element inputs for special requests elements */
export enum CheckoutSpecialRequestInputElementType {
  CHECKBOX = 'CHECKBOX',
  SELECT = 'SELECT',
  TEXTAREA = 'TEXTAREA',
}
/** Types of html elements for special requests */
export enum CheckoutSpecialRequestElementType {
  EXPANDO_LINK = 'EXPANDO_LINK',
  HEADING = 'HEADING',
}
/** Valid actions on Sort and Filter Modal */
export enum ShoppingSortAndFilterActionType {
  CLEAR_DATA = 'CLEAR_DATA',
  CLOSE_AND_APPLY = 'CLOSE_AND_APPLY',
  CLOSE_AND_DO_NOT_APPLY = 'CLOSE_AND_DO_NOT_APPLY',
  OPEN_MODAL = 'OPEN_MODAL',
}

export enum PropertyCalendarPriceTrend {
  NEGATIVE = 'NEGATIVE',
  POSITIVE = 'POSITIVE',
}
/** Indicates the type of intent. */
export enum ChatBotIntentType {
  CANCEL = 'CANCEL',
  CHANGE = 'CHANGE',
  VIEW_BOOKING = 'VIEW_BOOKING',
}
/** Indicates the type of product. */
export enum ChatBotProductType {
  FLIGHT = 'FLIGHT',
}
/** Indicates the waiver redemption state. */
export enum ChatBotWaiverRedemptionState {
  CREDIT_REDEMPTION = 'CREDIT_REDEMPTION',
}
/** The button type of the Customer notification submit button */
export enum CustomerNotificationFormButtonType {
  FLOATING_ACTION_BUTTON = 'FLOATING_ACTION_BUTTON',
  PRIMARY_BUTTON = 'PRIMARY_BUTTON',
  SECONDARY_BUTTON = 'SECONDARY_BUTTON',
  TERTIARY_BUTTON = 'TERTIARY_BUTTON',
}

export enum FlightCabinClassInfo {
  BUSINESS = 'BUSINESS',
  COACH = 'COACH',
  FIRST = 'FIRST',
  PREMIUM_ECONOMY = 'PREMIUM_ECONOMY',
}

export enum FlightsFlexibleSearchHeaderCellTheme {
  DEFAULT = 'DEFAULT',
  SEARCHED_DATE_HEADER = 'SEARCHED_DATE_HEADER',
}

export enum FlightsFlexibleSearchLegendCellTheme {
  DEFAULT = 'DEFAULT',
}

export enum FlightsFlexibleSearchResultCellTheme {
  DEFAULT_PRICE = 'DEFAULT_PRICE',
  HIGHEST_PRICE = 'HIGHEST_PRICE',
  LOWEST_PRICE = 'LOWEST_PRICE',
  NO_PRICE = 'NO_PRICE',
  SEARCHED_DATE = 'SEARCHED_DATE',
  SEARCHED_DATE_LOWEST_PRICE = 'SEARCHED_DATE_LOWEST_PRICE',
  SEARCHED_DATE_NO_PRICE = 'SEARCHED_DATE_NO_PRICE',
  SEARCHED_DATE_UNAVAILABLE_FLIGHTS = 'SEARCHED_DATE_UNAVAILABLE_FLIGHTS',
  UNAVAILABLE_FLIGHTS = 'UNAVAILABLE_FLIGHTS',
}

export enum RouteType {
  MULTI_DESTINATION = 'MULTI_DESTINATION',
  ONE_WAY = 'ONE_WAY',
  ROUND_TRIP = 'ROUND_TRIP',
}

// ====================================================
// END: Typescript template
// ====================================================

// ====================================================
// Documents
// ====================================================

export namespace AddPropertyToCart {
  export type Variables = {
    id: Uuid;
    context: ContextInput;
    propertyOffer: PropertyOfferInput;
    cartPropertySearchContextInput: CartPropertySearchContextInput;
  };

  export type Mutation = {
    __typename?: 'Mutation';

    cartItems: CartItems;
  };

  export type CartItems = {
    __typename?: 'CartMutations';

    addProperty: AddProperty;
  };

  export type AddProperty = {
    __typename?: 'CartSummary';

    id: Uuid;

    itemCount: number;
  };
}

export namespace CreateQuestion {
  export type Variables = {
    context: ContextInput;
    question: string;
    email: string;
    productId: string;
    questioner: string;
    productQuestionTopic: ProductQuestionTopic;
  };

  export type Mutation = {
    __typename?: 'Mutation';

    askProductQuestion?: string | null;
  };
}

export namespace CreateMultiItemSession {
  export type Variables = {
    context: ContextInput;
    multiItemSearchContext: MultiItemSearchContextInput;
  };

  export type Mutation = {
    __typename?: 'Mutation';

    createMultiItemSession: CreateMultiItemSession;
  };

  export type CreateMultiItemSession = MultiItemSearchContextCreatedResponseInlineFragment;

  export type MultiItemSearchContextCreatedResponseInlineFragment = {
    __typename?: 'MultiItemSearchContextCreatedResponse';

    shoppingContext: ShoppingContext;
  };

  export type ShoppingContext = {
    __typename?: 'ShoppingContext';

    multiItem?: MultiItem | null;
  };

  export type MultiItem = {
    __typename?: 'MultiItemContext';

    id: string;

    packageType: PackageType;
  };
}

export namespace CreateSessionCart {
  export type Variables = {
    context: ContextInput;
    cartOptions: CartOptionsInput;
  };

  export type Mutation = {
    __typename?: 'Mutation';

    createSessionCart: CreateSessionCart;
  };

  export type CreateSessionCart = {
    __typename?: 'Cart';

    id: Uuid;
  };
}

export namespace EmptyCart {
  export type Variables = {
    context: ContextInput;
    id: Uuid;
  };

  export type Mutation = {
    __typename?: 'Mutation';

    cartItems: CartItems;
  };

  export type CartItems = {
    __typename?: 'CartMutations';

    emptyCart: EmptyCart;
  };

  export type EmptyCart = {
    __typename?: 'CartSummary';

    id: Uuid;

    itemCount: number;
  };
}

export namespace FederatedCart {
  export type Variables = {
    context: ContextInput;
    id?: Uuid | null;
  };

  export type Query = {
    __typename?: 'Query';

    cart: Cart;
  };

  export type Cart = {
    __typename?: 'Cart';

    itemCount: number;

    items: Items[];
  };

  export type Items = {
    __typename?: PropertyCartItemInlineFragment['__typename'];

    id: Uuid;
  } & PropertyCartItemInlineFragment;

  export type PropertyCartItemInlineFragment = {
    __typename?: 'PropertyCartItem';

    offers: Offers[];
  };

  export type Offers = {
    __typename?: 'PropertyOffer';

    offerIndex: number;

    naturalKeys: NaturalKeys[];
  };

  export type NaturalKeys = {
    __typename?: 'PropertyNaturalKey';

    id: string;

    roomTypeId: string;

    ratePlanId: string;

    checkIn: CheckIn;

    checkOut: CheckOut;

    inventoryType: InventoryType;

    rooms: Rooms[];
  };

  export type CheckIn = {
    __typename?: 'Date';

    isoFormat: string;
  };

  export type CheckOut = {
    __typename?: 'Date';

    isoFormat: string;
  };

  export type Rooms = {
    __typename?: 'PropertyRoom';

    numberOfAdults: number;

    childAges: number[];
  };
}

export namespace Cart {
  export type Variables = {
    context: ContextInput;
    id?: Uuid | null;
  };

  export type Query = {
    __typename?: 'Query';

    cart: Cart;
  };

  export type Cart = {
    __typename?: 'Cart';

    itemCount: number;

    items: Items[];
  };

  export type Items = {
    __typename?: PropertyCartItemInlineFragment['__typename'];

    id: Uuid;
  } & PropertyCartItemInlineFragment;

  export type PropertyCartItemInlineFragment = {
    __typename?: 'PropertyCartItem';

    offers: Offers[];

    summary?: Summary | null;

    gallery?: Gallery | null;
  };

  export type Offers = {
    __typename?: 'PropertyOffer';

    offerIndex: number;

    naturalKeys: NaturalKeys[];

    offer?: Offer | null;
  };

  export type NaturalKeys = {
    __typename?: 'PropertyNaturalKey';

    id: string;

    roomTypeId: string;

    ratePlanId: string;

    ratePlanType?: string | null;

    checkIn: CheckIn;

    checkOut: CheckOut;

    inventoryType: InventoryType;

    rooms: Rooms[];
  };

  export type CheckIn = {
    __typename?: 'Date';

    isoFormat: string;
  };

  export type CheckOut = {
    __typename?: 'Date';

    isoFormat: string;
  };

  export type Rooms = {
    __typename?: 'PropertyRoom';

    numberOfAdults: number;

    childAges: number[];
  };

  export type Offer = {
    __typename?: 'OfferDetails';

    marketingChannelId?: number | null;

    units: Units[];
  };

  export type Units = {
    __typename?: 'PropertyUnit';

    name?: string | null;

    photos: Photos[];

    ratePlans: RatePlans[];
  };

  export type Photos = {
    __typename?: 'Image';

    description: string;

    url: Url;
  };

  export type RatePlans = {
    __typename?: 'RatePlan';

    priceDetails: PriceDetails[];
  };

  export type PriceDetails = {
    __typename?: 'Offer';

    availability?: Availability | null;

    offerBookButton?: OfferBookButton | null;

    price?: Price | null;

    priceAfterLoyaltyPointsApplied?: PriceAfterLoyaltyPointsApplied | null;

    fees: Fees[];
  };

  export type Availability = {
    __typename?: 'PropertyAvailability';

    available: boolean;

    minRoomsLeft?: number | null;
  };

  export type OfferBookButton = {
    __typename?: 'LodgingForm';

    inputs?: Inputs[] | null;
  };

  export type Inputs = LodgingTextInputInlineFragment;

  export type LodgingTextInputInlineFragment = {
    __typename?: 'LodgingTextInput';

    name?: string | null;

    value?: string | null;
  };

  export type Price = {
    __typename?: 'PropertyPrice';

    total?: Total | null;

    lead?: Lead | null;
  };

  export type Total = {
    __typename?: 'Money';

    currency: Currency;

    formatted: string;

    raw: number;
  };

  export type Currency = {
    __typename?: 'Currency';

    code: string;

    name: string;

    symbol: string;
  };

  export type Lead = {
    __typename?: 'Money';

    currency: _Currency;

    formatted: string;

    raw: number;
  };

  export type _Currency = {
    __typename?: 'Currency';

    code: string;

    name: string;

    symbol: string;
  };

  export type PriceAfterLoyaltyPointsApplied = {
    __typename?: 'PropertyPrice';

    total?: _Total | null;

    lead?: _Lead | null;
  };

  export type _Total = {
    __typename?: 'Money';

    currency: __Currency;

    formatted: string;

    raw: number;
  };

  export type __Currency = {
    __typename?: 'Currency';

    code: string;

    name: string;

    symbol: string;
  };

  export type _Lead = {
    __typename?: 'Money';

    currency: ___Currency;

    formatted: string;

    raw: number;
  };

  export type ___Currency = {
    __typename?: 'Currency';

    code: string;

    name: string;

    symbol: string;
  };

  export type Fees = {
    __typename?: 'Fees';

    description?: string | null;
  };

  export type Summary = {
    __typename?: 'PropertySummary';

    name: string;

    location?: Location | null;
  };

  export type Location = {
    __typename?: 'PropertyLocation';

    address?: Address | null;
  };

  export type Address = {
    __typename?: 'PropertyAddress';

    city?: string | null;
  };

  export type Gallery = {
    __typename?: 'PropertyGallery';

    featured?: Featured | null;
  };

  export type Featured = {
    __typename?: 'Image';

    url: Url;
  };
}

export namespace InitiateMultiItemSession {
  export type Variables = {
    context: ContextInput;
    searchContext: MultiItemSearchContextInput;
  };

  export type Mutation = {
    __typename?: 'Mutation';

    multiItemShopping: MultiItemShopping;
  };

  export type MultiItemShopping = {
    __typename?: 'MultiItemSessionMutations';

    initiate: Initiate;
  };

  export type Initiate = MultiItemSearchContextCreatedResponseInlineFragment | MultiItemSearchContextErrorResponseInlineFragment;

  export type MultiItemSearchContextCreatedResponseInlineFragment = {
    __typename?: 'MultiItemSearchContextCreatedResponse';

    shoppingContext: ShoppingContext;

    redirectUrl?: Url | null;
  };

  export type ShoppingContext = {
    __typename?: 'ShoppingContext';

    multiItem?: MultiItem | null;
  };

  export type MultiItem = {
    __typename?: 'MultiItemContext';

    id: string;

    packageType: PackageType;
  };

  export type MultiItemSearchContextErrorResponseInlineFragment = {
    __typename?: 'MultiItemSearchContextErrorResponse';

    message?: string | null;
  };
}

export namespace PropertyLocationScoreInfo {
  export type Variables = {
    propertyIds: string[];
    context: ContextInput;
  };

  export type Query = {
    __typename?: 'Query';

    propertyReviewAggregates: PropertyReviewAggregates;
  };

  export type PropertyReviewAggregates = {
    __typename?: 'PropertyReviewAggregates';

    propertySummaries?: PropertySummaries[] | null;
  };

  export type PropertySummaries = {
    __typename?: 'LodgingReviewSummary';

    propertyId: string;

    locationScore?: LocationScore | null;
  };

  export type LocationScore = {
    __typename?: 'SummaryUnit';

    score?: string | null;

    tags: Tags[];
  };

  export type Tags = {
    __typename?: 'Tag';

    label: string;
  };
}

export namespace LodgingPwaPropertySearch {
  export type Variables = {
    context: ContextInput;
    destination: DestinationInput;
    rooms?: RoomInput[] | null;
    dateRange?: PropertyDateRangeInput | null;
    sort?: PropertySort | null;
    filters?: PropertySearchFiltersInput | null;
    marketing?: PropertyMarketingInfoInput | null;
    legacyCriteria?: LegacyPropertySearchCriteriaInput | null;
    propertyShopOptions?: PropertyShopOptionsInput | null;
    searchPagination?: PaginationInput | null;
    searchIntent?: SearchIntentInput | null;
    shoppingContext?: ShoppingContextInput | null;
    criteria?: PropertySearchCriteriaInput | null;
    shouldFetchSortAndFilter?: boolean | null;
  };

  export type Query = {
    __typename?: 'Query';

    propertySearch: PropertySearch;
  };

  export type PropertySearch = {
    __typename?: 'PropertySearchResults';

    searchCriteria: SearchCriteria;

    sortAndFilter: SortAndFilter;

    propertySearchListings: PropertySearchListings[];

    summary: Summary;

    navigationTabs?: NavigationTabs | null;

    map?: Map | null;

    exitIntent?: ExitIntent | null;

    legalDisclaimer?: LegalDisclaimer | null;

    shoppingContext?: ShoppingContext | null;

    multiItemSearchContext?: MultiItemSearchContext | null;

    errorResponse?: ErrorResponse | null;
  };

  export type SearchCriteria = {
    __typename?: 'SearchCriteria';

    propertyShopOptions?: PropertyShopOptions | null;

    dateRange: DateRange;

    destination: Destination;

    searchIntent?: SearchIntent | null;

    sort?: PropertySort | null;

    filters?: Filters | null;
  };

  export type PropertyShopOptions = {
    __typename?: 'PropertyShopOptions';

    points?: Points | null;
  };

  export type DateRange = {
    __typename?: 'PropertyDateRange';

    checkInDate: CheckInDate;

    checkOutDate: CheckOutDate;
  };

  export type CheckInDate = CommonDateFields.Fragment;

  export type CheckOutDate = CommonDateFields.Fragment;

  export type Destination = {
    __typename?: 'Destination';

    regionId?: string | null;

    regionName?: string | null;
  };

  export type SearchIntent = {
    __typename?: 'SearchIntent';

    theme?: string | null;

    userIntent?: string | null;

    semdtl?: string | null;
  };

  export type Filters = {
    __typename?: 'PropertySearchFilters';

    accessibility?: PropertyFilterAccessibility[] | null;

    amenities?: PropertyFilterAmenity[] | null;

    bedroomFilter?: number[] | null;

    commissionTiers?: CommissionTier[] | null;

    agencyBusinessModels?: AgencyBusinessModel[] | null;

    deals?: DealType[] | null;

    paymentType?: PaymentType[] | null;

    poi?: string | null;

    priceBuckets?: number[] | null;

    propertyName?: string | null;

    propertyStyles?: PropertyStyle[] | null;

    reviewScore?: ReviewScore | null;

    starList?: number[] | null;

    structureTypes?: StructureType[] | null;

    travelerType?: TravelerType[] | null;

    mealPlan?: MealPlanFilterAmenity[] | null;

    cleaningAndSafetyPractices?: CleaningAndSafetyPractice[] | null;
  };

  export type ReviewScore = {
    __typename?: 'ReviewScoreRange';

    min?: number | null;

    max?: number | null;
  };

  export type SortAndFilter = {
    __typename?: 'SortAndFilter';

    defaults?: Defaults | null;

    selected?: Selected | null;

    options?: Options | null;
  };

  export type Defaults = {
    __typename?: 'SortAndFilterDefaults';

    sort: PropertySort;

    regionId?: string | null;
  };

  export type Selected = {
    __typename?: 'SortAndFilterSelected';

    priceFilterPills?: PriceFilterPills | null;

    star?: string | null;
  };

  export type PriceFilterPills = {
    __typename?: 'PriceFilterPills';

    aggregate?: Aggregate | null;

    buckets?: number[] | null;
  };

  export type Aggregate = {
    __typename?: 'PriceFilterPillsAggregate';

    label?: string | null;

    value?: string | null;
  };

  export type Options = {
    __typename?: 'SortAndFilterViewModel';

    appliedFilterCount: number;

    sortAndFilter: _SortAndFilter[];
  };

  export type _SortAndFilter = {
    __typename?: 'FilterViewModel';

    selected: boolean;

    isRange?: boolean | null;

    label?: string | null;

    max?: number | null;

    min?: number | null;

    placeholder?: string | null;

    step?: number | null;

    subLabel?: string | null;

    name: string;

    title: string;

    hiddenThreshold?: number | null;

    options: _Options[];
  };

  export type _Options = {
    __typename?: 'OptionViewModel';

    selectedLabel?: string | null;

    ariaLabel?: string | null;

    description?: string | null;

    icon?: string | null;

    isSelected: boolean;

    label?: string | null;

    value?: string | null;

    optionValue?: string | null;

    range?: Range | null;

    filterType?: string | null;
  };

  export type Range = {
    __typename?: 'FilterOptionRange';

    min?: number | null;

    max?: number | null;
  };

  export type PropertySearchListings =
    | PropertyInlineFragment
    | MessageResultInlineFragment
    | LodgingHeadingInlineFragment
    | StaticLodgingMultiItemCrossSellInlineFragment;

  export type PropertyInlineFragment = PropertyFields.Fragment;

  export type MessageResultInlineFragment = MessageFields.Fragment;

  export type LodgingHeadingInlineFragment = {
    __typename?: 'LodgingHeading';

    value: string;

    size: number;

    level: number;
  };

  export type StaticLodgingMultiItemCrossSellInlineFragment = {
    __typename?: 'StaticLodgingMultiItemCrossSell';

    crossSellProductType: LodgingCrossSellProductType;

    fallbackListing?: FallbackListing | null;
  };

  export type FallbackListing = _MessageResultInlineFragment;

  export type _MessageResultInlineFragment = MessageFields.Fragment;

  export type Summary = {
    __typename?: 'PropertyResultsSummary';

    resultsSummary?: ResultsSummary[] | null;

    pricedHotelSize: number;

    region?: Region | null;

    resultSectionHeadings?: ResultSectionHeadings[] | null;

    loyaltyEducation?: LoyaltyEducation | null;

    loyaltyInfo?: LoyaltyInfo | null;

    matchedPropertiesSize: number;

    resultsHeading?: string | null;
  };

  export type ResultsSummary = {
    __typename?: LodgingLinkMessageInlineFragment['__typename'] | LodgingDialogTriggerMessageInlineFragment['__typename'];

    value: string;
  } & (LodgingLinkMessageInlineFragment | LodgingDialogTriggerMessageInlineFragment);

  export type LodgingLinkMessageInlineFragment = SearchLinkMessage.Fragment;

  export type LodgingDialogTriggerMessageInlineFragment = SearchDialogMessage.Fragment;

  export type Region = {
    __typename?: 'Region';

    name: string;

    id: string;
  };

  export type ResultSectionHeadings = {
    __typename?: 'ResultSectionHeading';

    heading: string;

    index: number;
  };

  export type LoyaltyEducation = {
    __typename?: 'LoyaltyEducation';

    action?: Action | null;

    content: Content;

    title?: string | null;
  };

  export type Action = {
    __typename?: 'LoyaltyEducationAction';

    href?: string | null;

    rfrr?: string | null;

    text?: string | null;
  };

  export type Content = PointsEducationFragment.Fragment | ProgramEducationFragment.Fragment;

  export type LoyaltyInfo = {
    __typename?: 'PropertyLoyaltyDiscount';

    pointsAppliedMessage?: string | null;

    saveWithPointsMessage?: string | null;

    saveWithPointsActionMessage?: string | null;
  };

  export type NavigationTabs = {
    __typename?: 'NavigationTabs';

    tabs: Tabs[];
  };

  export type Tabs = {
    __typename?: 'PropertyNavigationBarTab';

    localizedName: string;

    sectionName: string;

    state?: string | null;

    tabLink?: TabLink | null;
  };

  export type TabLink = {
    __typename?: 'LodgingLinkMessage';

    link: Link;

    value: string;
  };

  export type Link = {
    __typename?: 'LodgingLink';

    url: Url;

    uri: Uri;

    target?: string | null;
  };

  export type Uri = {
    __typename?: 'HttpURI';

    value: string;
  };

  export type Map = {
    __typename?: 'PropertySearchMap';

    bounds: Bounds;

    center: Center;

    markers: Markers[];

    staticMapSrc?: string | null;

    title: string;

    subtitle?: string | null;

    zoom: number;

    messagingModel?: MessagingModel | null;
  };

  export type Bounds = {
    __typename?: 'Bounds';

    northeast: Northeast;

    southwest: Southwest;
  };

  export type Northeast = {
    __typename?: 'Coordinates';

    latitude: number;

    longitude: number;
  };

  export type Southwest = {
    __typename?: 'Coordinates';

    latitude: number;

    longitude: number;
  };

  export type Center = {
    __typename?: 'Coordinates';

    latitude: number;

    longitude: number;
  };

  export type Markers = {
    __typename?: _PropertyInlineFragment['__typename'] | PointOfInterestInlineFragment['__typename'];

    mapMarker?: MapMarker | null;
  } & (_PropertyInlineFragment | PointOfInterestInlineFragment);

  export type MapMarker = {
    __typename?: 'MapMarker';

    label: string;

    icon: MapIconType;

    type?: MarkerType | null;

    latLong: LatLong;
  };

  export type LatLong = {
    __typename?: 'Coordinates';

    latitude: number;

    longitude: number;
  };

  export type _PropertyInlineFragment = CommonPropertyCardFields.Fragment;

  export type PointOfInterestInlineFragment = {
    __typename?: 'PointOfInterest';

    name: string;
  };

  export type MessagingModel = {
    __typename?: 'MessageResult';

    title?: Title | null;

    subtitle?: Subtitle | null;

    type?: MessageType | null;
  };

  export type Title = {
    __typename?: 'MessagingResultTitle';

    text?: string | null;

    theme?: Theme | null;

    icon?: Icon | null;
  };

  export type Icon = {
    __typename?: 'Icon';

    description: string;

    id: string;
  };

  export type Subtitle = {
    __typename?: 'MessagingResultTitle';

    text?: string | null;

    theme?: Theme | null;

    icon?: _Icon | null;
  };

  export type _Icon = {
    __typename?: 'Icon';

    description: string;

    id: string;
  };

  export type ExitIntent = {
    __typename?: 'ExitIntent';

    logoUrl?: string | null;

    backgroundImageUrl?: string | null;

    clickHereLinkUrl?: string | null;

    message: Message;
  };

  export type Message = {
    __typename?: 'ExitIntentMessage';

    headingOne?: string | null;

    headingTwo?: string | null;

    headingThree?: string | null;

    couponCode?: string | null;

    percentOff?: string | null;

    termsAndConditionsOne?: string | null;

    termsAndConditionsTwo?: string | null;

    clickHere?: string | null;
  };

  export type LegalDisclaimer = {
    __typename?: 'DisclaimerContentMarkup';

    content: _Content[];
  };

  export type _Content = {
    __typename?: 'MarkupText';

    markupType: MarkupTextType;

    text: string;
  };

  export type ShoppingContext = {
    __typename?: 'ShoppingContext';

    multiItem?: MultiItem | null;
  };

  export type MultiItem = {
    __typename?: 'MultiItemContext';

    id: string;

    packageType: PackageType;
  };

  export type MultiItemSearchContext = {
    __typename?: 'MultiItemSearchContext';

    cars?: Cars[] | null;

    flights?: Flights[] | null;
  } & MultiItemPropertySearchContextFields.Fragment;

  export type Cars = {
    __typename?: 'CarSearchCriteria';

    primary: Primary;
  };

  export type Primary = {
    __typename?: 'PrimaryCarCriteria';

    pickUpDateTime: PickUpDateTime;

    dropOffDateTime: DropOffDateTime;

    pickUpLocation: PickUpLocation;

    dropOffLocation?: DropOffLocation | null;
  };

  export type PickUpDateTime = CommonDateTimeFields.Fragment;

  export type DropOffDateTime = CommonDateTimeFields.Fragment;

  export type PickUpLocation = {
    __typename?: 'CarRentalLocation';

    airportCode?: string | null;
  };

  export type DropOffLocation = {
    __typename?: 'CarRentalLocation';

    airportCode?: string | null;
  };

  export type Flights = {
    __typename?: 'FlightSearchCriteria';

    primary: _Primary;
  };

  export type _Primary = {
    __typename?: 'PrimaryFlightCriteria';

    travelers: Travelers[];

    tripType: FlightsTripType;

    journeyCriterias: JourneyCriterias[];

    searchPreferences?: SearchPreferences | null;
  };

  export type Travelers = {
    __typename?: 'TravelerDetails';

    type: TravelerDetailsType;

    age?: number | null;
  };

  export type JourneyCriterias = {
    __typename?: 'FlightsJourneyCriteria';

    destination: string;

    origin: string;

    departureDate: DepartureDate;
  };

  export type DepartureDate = {
    __typename?: 'Date';

    day: number;

    month: number;

    year: number;
  };

  export type SearchPreferences = {
    __typename?: 'FlightsSearchPreferences';

    airline?: string | null;

    advancedFilters?: FlightsAdvancedFilterType[] | null;

    cabinClass: FlightsCabinClass;
  };

  export type ErrorResponse = {
    __typename?: 'LodgingErrorResponse';

    header?: string | null;

    body?: string | null;

    icon?: __Icon | null;

    button: Button;
  };

  export type __Icon = {
    __typename?: 'Icon';

    description: string;

    id: string;
  };

  export type Button = {
    __typename?: 'UIPrimaryButton';

    primary?: string | null;

    action?: _Action | null;

    disabled: boolean;
  };

  export type _Action = UiLinkActionInlineFragment;

  export type UiLinkActionInlineFragment = {
    __typename?: 'UILinkAction';

    analytics: Analytics;

    resource: Resource;
  };

  export type Analytics = {
    __typename?: 'ClientSideAnalytics';

    referrerId: string;

    linkName: string;
  };

  export type Resource = HttpUriInlineFragment;

  export type HttpUriInlineFragment = {
    __typename?: 'HttpURI';

    relativePath: string;

    value: string;
  };
}

export namespace LodgingPwaPropertySearchSortAndFilter {
  export type Variables = {
    context: ContextInput;
    destination: DestinationInput;
    rooms?: RoomInput[] | null;
    dateRange?: PropertyDateRangeInput | null;
    sort?: PropertySort | null;
    filters?: PropertySearchFiltersInput | null;
    marketing?: PropertyMarketingInfoInput | null;
    legacyCriteria?: LegacyPropertySearchCriteriaInput | null;
    propertyShopOptions?: PropertyShopOptionsInput | null;
    searchPagination?: PaginationInput | null;
    searchIntent?: SearchIntentInput | null;
    shoppingContext?: ShoppingContextInput | null;
    criteria?: PropertySearchCriteriaInput | null;
  };

  export type Query = {
    __typename?: 'Query';

    propertySearch: PropertySearch;
  };

  export type PropertySearch = {
    __typename?: 'PropertySearchResults';

    sortAndFilter: SortAndFilter;
  };

  export type SortAndFilter = {
    __typename?: 'SortAndFilter';

    defaults?: Defaults | null;

    selected?: Selected | null;

    options?: Options | null;
  };

  export type Defaults = {
    __typename?: 'SortAndFilterDefaults';

    sort: PropertySort;

    regionId?: string | null;
  };

  export type Selected = {
    __typename?: 'SortAndFilterSelected';

    priceFilterPills?: PriceFilterPills | null;

    star?: string | null;
  };

  export type PriceFilterPills = {
    __typename?: 'PriceFilterPills';

    aggregate?: Aggregate | null;

    buckets?: number[] | null;
  };

  export type Aggregate = {
    __typename?: 'PriceFilterPillsAggregate';

    label?: string | null;

    value?: string | null;
  };

  export type Options = {
    __typename?: 'SortAndFilterViewModel';

    appliedFilterCount: number;

    sortAndFilter: _SortAndFilter[];
  };

  export type _SortAndFilter = {
    __typename?: 'FilterViewModel';

    selected: boolean;

    isRange?: boolean | null;

    label?: string | null;

    max?: number | null;

    min?: number | null;

    name: string;

    title: string;

    placeholder?: string | null;

    step?: number | null;

    subLabel?: string | null;

    hiddenThreshold?: number | null;

    options: _Options[];
  };

  export type _Options = {
    __typename?: 'OptionViewModel';

    selectedLabel?: string | null;

    ariaLabel?: string | null;

    description?: string | null;

    icon?: string | null;

    isSelected: boolean;

    label?: string | null;

    value?: string | null;

    optionValue?: string | null;

    range?: Range | null;

    filterType?: string | null;
  };

  export type Range = {
    __typename?: 'FilterOptionRange';

    min?: number | null;

    max?: number | null;
  };
}

export namespace PrepareCheckoutByCartId {
  export type Variables = {
    context: ContextInput;
    id: Uuid;
    totalPrice: MoneyInput;
    marketingChannelId?: number | null;
    checkoutOptions?: CheckoutOptionInput[] | null;
  };

  export type Mutation = {
    __typename?: 'Mutation';

    prepareCheckoutByCartId: PrepareCheckoutByCartId;
  };

  export type PrepareCheckoutByCartId = {
    __typename?: 'PrepareCheckoutResponse';

    tripId?: Uuid | null;

    checkoutUrl?: Url | null;

    failureReason?: FailureReason | null;
  };

  export type FailureReason = MaxRoomsFailureInlineFragment;

  export type MaxRoomsFailureInlineFragment = {
    __typename?: 'MaxRoomsFailure';

    groupLinkMessage?: string | null;

    message: string;
  };
}

export namespace PrepareCheckout {
  export type Variables = {
    context: ContextInput;
    properties?: PropertyNaturalKeyInput[] | null;
    cookies: string;
  };

  export type Mutation = {
    __typename?: 'Mutation';

    prepareCheckout: PrepareCheckout;
  };

  export type PrepareCheckout = {
    __typename?: 'PrepareCheckoutResponse';

    tripId?: Uuid | null;

    checkoutUrl?: Url | null;
  };
}

export namespace PropertyAvailabilityCheck {
  export type Variables = {
    context: ContextInput;
    propertyId: string;
    searchCriteria: PropertySearchCriteriaInput;
  };

  export type Query = {
    __typename?: 'Query';

    propertyInfo: PropertyInfo;
  };

  export type PropertyInfo = {
    __typename?: 'PropertyInfo';

    offers?: Offers | null;
  };

  export type Offers = {
    __typename?: 'OfferDetails';

    errorMessage?: ErrorMessage | null;

    listings?: Listings[] | null;
  };

  export type ErrorMessage = {
    __typename?: 'MessageResult';

    title?: Title | null;
  };

  export type Title = {
    __typename?: 'MessagingResultTitle';

    text?: string | null;
  };

  export type Listings = PropertyUnitInlineFragment;

  export type PropertyUnitInlineFragment = {
    __typename?: 'PropertyUnit';

    id: string;
  };
}

export namespace PropertyInfoDetails {
  export type Variables = {
    context: ContextInput;
    propertyId: string;
    shoppingContext?: ShoppingContextInput | null;
    searchCriteria?: PropertySearchCriteriaInput | null;
  };

  export type Query = {
    __typename?: 'Query';

    propertyInfo: PropertyInfo;
  };

  export type PropertyInfo = {
    __typename?: 'PropertyInfo';

    summary?: Summary | null;

    feedback: Feedback;

    shortList?: ShortList | null;

    propertyHighlightedDetails?: PropertyHighlightedDetails | null;
  };

  export type Summary = {
    __typename?: 'PropertySummary';

    name: string;

    location?: Location | null;

    overview?: Overview | null;

    amenities?: Amenities | null;

    featuredMessages?: FeaturedMessages[] | null;

    structure?: StructureType | null;
  };

  export type Location = {
    __typename?: 'PropertyLocation';

    parentRegion?: ParentRegion | null;

    coordinates?: Coordinates | null;
  };

  export type ParentRegion = {
    __typename?: 'Region';

    id: string;

    name: string;
  };

  export type Coordinates = {
    __typename?: 'Coordinates';

    latitude: number;

    longitude: number;
  };

  export type Overview = {
    __typename?: 'PropertyOverview';

    accessibilityLabel?: string | null;
  };

  export type Amenities = {
    __typename?: 'PropertyAmenities';

    amenities: _Amenities[];

    takeover?: Takeover | null;
  };

  export type _Amenities = {
    __typename?: 'PropertyInfoSection';

    title?: string | null;

    contents: Contents[];

    dataLabel?: string | null;
  };

  export type Contents = {
    __typename?: 'PropertyInfoContent';

    heading?: string | null;

    icon?: Icon | null;

    items: Items[];
  };

  export type Icon = {
    __typename?: 'Icon';

    id: string;
  };

  export type Items = {
    __typename?: 'PropertyInfoItem';

    text: string;
  };

  export type Takeover = {
    __typename?: 'PropertyTakeoverAmenities';

    highlight: Highlight[];
  };

  export type Highlight = {
    __typename?: 'PropertyInfoContent';

    heading?: string | null;

    items: _Items[];
  };

  export type _Items = {
    __typename?: 'PropertyInfoItem';

    text: string;

    icon?: _Icon | null;
  };

  export type _Icon = {
    __typename?: 'Icon';

    id: string;
  };

  export type FeaturedMessages = LodgingEnrichedMessage.Fragment;

  export type Feedback = {
    __typename?: 'Feedback';

    action?: Action | null;
  };

  export type Action = {
    __typename?: 'FeedbackAction';

    text?: string | null;
  };

  export type ShortList = {
    __typename?: 'ShortList';

    favorited: boolean;

    saveUrl: string;

    removeUrl: string;

    metaData: MetaData;
  };

  export type MetaData = {
    __typename?: 'ShortListMetaData';

    chkIn: string;

    chkOut: string;

    hotelId: string;

    roomConfiguration: string;
  };

  export type PropertyHighlightedDetails = {
    __typename?: 'PropertyInfoContent';

    header?: Header | null;

    items: __Items[];
  };

  export type Header = {
    __typename?: 'LodgingHeader';

    text?: string | null;
  };

  export type __Items = {
    __typename?: 'PropertyInfoItem';

    icon?: __Icon | null;

    text: string;
  };

  export type __Icon = {
    __typename?: 'Icon';

    description: string;

    id: string;

    size?: IconSize | null;
  };
}

export namespace PropertyInfoOffersBexFeatures {
  export type Variables = {
    context: ContextInput;
    propertyId: string;
    searchCriteria?: PropertySearchCriteriaInput | null;
    shoppingContext?: ShoppingContextInput | null;
    travelAdTrackingInfo?: PropertyTravelAdTrackingInfoInput | null;
    searchOffer?: SearchOfferInput | null;
    referrer?: string | null;
  };

  export type Query = {
    __typename?: 'Query';

    propertyInfo: PropertyInfo;
  };

  export type PropertyInfo = {
    __typename?: 'PropertyInfo';

    offers?: Offers | null;
  };

  export type Offers = {
    __typename?: 'OfferDetails';

    propertyHighlightSection?: PropertyHighlightSection | null;

    propertySearchLink?: PropertySearchLink | null;

    partnerPropertySearchLink?: PartnerPropertySearchLink | null;

    filterPills?: FilterPills[] | null;

    listingsHeader: ListingsHeader;

    searchCriteria?: SearchCriteria | null;

    tripSummary?: TripSummary | null;

    listings?: Listings[] | null;

    experimental?: Experimental | null;

    legalBanner?: LegalBanner | null;

    errorMessage?: ErrorMessage | null;

    paymentPolicy: PaymentPolicy[];

    serpMetadata?: SerpMetadata | null;

    soldOut: boolean;

    stickyBar?: StickyBar | null;

    toastMessage?: ToastMessage | null;

    loyaltyDiscount?: LoyaltyDiscount | null;

    legalDisclaimer?: LegalDisclaimer | null;

    propertyLevelOffersMessage?: PropertyLevelOffersMessage | null;

    offerLevelMessages?: OfferLevelMessages[] | null;

    alternateDates?: AlternateDates | null;

    shoppingContext?: ShoppingContext | null;

    singleUnitOffer?: SingleUnitOffer | null;

    singleUnitOfferDialog?: SingleUnitOfferDialog | null;

    spaceDetails?: SpaceDetails | null;
  };

  export type PropertyHighlightSection = {
    __typename?: 'PropertyHighlightSection';

    label?: string | null;

    header?: Header | null;

    subSections: SubSections[];

    footerLink?: FooterLink | null;
  };

  export type Header = {
    __typename?: 'LodgingHeader';

    badge?: Badge | null;

    mark?: Mark | null;
  };

  export type Badge = {
    __typename?: 'Badge';

    icon_temp?: IconTemp | null;

    theme_temp?: Theme | null;

    theme?: Theme | null;

    text?: string | null;
  };

  export type IconTemp = {
    __typename?: 'Icon';

    id: string;
  };

  export type Mark = {
    __typename?: 'Mark';

    id: string;

    description: string;
  };

  export type SubSections = {
    __typename?: 'PropertyHighlightSubSection';

    description?: string | null;

    contents: Contents[];
  };

  export type Contents = {
    __typename?: 'LodgingEnrichedMessage';

    icon?: Icon | null;

    value: string;
  };

  export type Icon = {
    __typename?: 'Icon';

    id: string;

    withBackground?: boolean | null;

    description: string;
  };

  export type FooterLink = {
    __typename?: 'LodgingLinkMessage';

    icon?: _Icon | null;

    link: Link;

    value: string;
  };

  export type _Icon = {
    __typename?: 'Icon';

    id: string;
  };

  export type Link = {
    __typename?: 'LodgingLink';

    referrerId?: string | null;

    uri: Uri;

    target?: string | null;
  };

  export type Uri = {
    __typename?: 'HttpURI';

    relativePath: string;

    value: string;
  };

  export type PropertySearchLink = {
    __typename?: 'LodgingLinkMessage';

    icon?: __Icon | null;

    link: _Link;

    value: string;
  };

  export type __Icon = {
    __typename?: 'Icon';

    id: string;
  };

  export type _Link = {
    __typename?: 'LodgingLink';

    clientSideAnalytics?: ClientSideAnalytics | null;

    uri: _Uri;

    referrerId?: string | null;
  };

  export type ClientSideAnalytics = {
    __typename?: 'ClientSideAnalytics';

    referrerId: string;

    linkName: string;
  };

  export type _Uri = {
    __typename?: 'HttpURI';

    relativePath: string;

    value: string;
  };

  export type PartnerPropertySearchLink = {
    __typename?: 'LodgingLinkMessage';

    icon?: ___Icon | null;

    link: __Link;

    value: string;
  };

  export type ___Icon = {
    __typename?: 'Icon';

    id: string;
  };

  export type __Link = {
    __typename?: 'LodgingLink';

    uri: __Uri;

    referrerId?: string | null;
  };

  export type __Uri = {
    __typename?: 'HttpURI';

    relativePath: string;

    value: string;
  };

  export type FilterPills = {
    __typename?: 'LodgingPill';

    pillLabel: string;

    type: string;

    value?: string | null;

    state?: string | null;

    query?: string | null;
  };

  export type ListingsHeader = {
    __typename?: 'LodgingHeader';

    text?: string | null;
  };

  export type SearchCriteria = {
    __typename?: 'PropertySearchCriteria';

    primary: Primary;

    secondary?: Secondary | null;
  };

  export type Primary = {
    __typename?: 'PrimaryPropertyCriteria';

    dateRange?: DateRange | null;

    destination: Destination;

    rooms: Rooms[];
  };

  export type DateRange = {
    __typename?: 'PropertyDateRange';

    checkInDate: CheckInDate;

    checkOutDate: CheckOutDate;
  };

  export type CheckInDate = DateFragment.Fragment;

  export type CheckOutDate = DateFragment.Fragment;

  export type Destination = {
    __typename?: 'Destination';

    regionId?: string | null;
  };

  export type Rooms = {
    __typename?: 'Room';

    adults: number;

    children?: Children[] | null;
  };

  export type Children = {
    __typename?: 'Child';

    age: number;
  };

  export type Secondary = {
    __typename?: 'ShoppingSearchCriteria';

    booleans?: Booleans[] | null;

    counts?: Counts[] | null;

    dates?: Dates[] | null;

    ranges?: Ranges[] | null;

    selections?: Selections[] | null;
  };

  export type Booleans = {
    __typename?: 'BooleanValue';

    id: string;

    value: boolean;
  };

  export type Counts = {
    __typename?: 'NumberValue';

    id: string;

    value: number;
  };

  export type Dates = {
    __typename?: 'DateValue';

    id: string;

    value: Value;
  };

  export type Value = {
    __typename?: 'Date';

    isoFormat: string;
  };

  export type Ranges = {
    __typename?: 'RangeValue';

    id: string;

    min: number;

    max: number;
  };

  export type Selections = {
    __typename?: 'SelectedValue';

    id: string;

    value: string;
  };

  export type TripSummary = TripSummaryFragment.Fragment;

  export type Listings = MessageFragment.Fragment | UnitFragment.Fragment;

  export type Experimental = {
    __typename?: 'PropertyOffersExperimentalSection';

    ratePlanCategorizationExperimentalFeature: RatePlanCategorizationExperimentalFeature;
  };

  export type RatePlanCategorizationExperimentalFeature = {
    __typename?: 'RatePlanCategorizationExperimentalFeature';

    verticalListings?: VerticalListings[] | null;
  };

  export type VerticalListings = MessageFragment.Fragment | UnitFragment.Fragment;

  export type LegalBanner = MessageFragment.Fragment;

  export type ErrorMessage = {
    __typename?: 'MessageResult';

    title?: Title | null;

    action?: Action | null;
  };

  export type Title = {
    __typename?: 'MessagingResultTitle';

    text?: string | null;
  };

  export type Action = {
    __typename?: 'MessagingResultAction';

    primary?: _Primary | null;
  };

  export type _Primary = {
    __typename?: 'MessagingAction';

    text?: string | null;

    linkUrl: string;
  };

  export type PaymentPolicy = PaymentPolicyFragment.Fragment;

  export type SerpMetadata = {
    __typename?: 'SerpMetadata';

    priceRange?: PriceRange | null;

    priceRating?: PriceRating | null;
  };

  export type PriceRange = {
    __typename?: 'LodgingPlainMessage';

    value: string;
  };

  export type PriceRating = {
    __typename?: 'LodgingPlainMessage';

    value: string;
  };

  export type StickyBar = {
    __typename?: 'PropertyDetailsStickyBar';

    displayPrice?: string | null;

    qualifier?: string | null;

    subText?: string | null;

    stickyButton?: StickyButton | null;

    price?: Price | null;
  };

  export type StickyButton = {
    __typename?: 'LodgingStickyButton';

    text?: string | null;

    targetRef?: PropertySectionRef | null;
  };

  export type Price = {
    __typename?: 'PropertyPriceOption';

    leadingCaption?: string | null;

    displayPrice?: DisplayPrice | null;

    disclaimer?: Disclaimer | null;
  };

  export type DisplayPrice = {
    __typename?: 'Money';

    formatted: string;
  };

  export type Disclaimer = {
    __typename?: 'LodgingPlainMessage';

    value: string;
  };

  export type ToastMessage = {
    __typename?: 'LodgingToastMessage';

    value: string;
  };

  export type LoyaltyDiscount = {
    __typename?: 'PropertyLoyaltyDiscount';

    saveWithPointsMessage?: string | null;

    saveWithPointsActionMessage?: string | null;
  };

  export type LegalDisclaimer = {
    __typename?: 'DisclaimerContentMarkup';

    content: Content[];
  };

  export type Content = {
    __typename?: 'MarkupText';

    markupType: MarkupTextType;

    text: string;
  };

  export type PropertyLevelOffersMessage = MessageFragment.Fragment;

  export type OfferLevelMessages = MessageFragment.Fragment;

  export type AlternateDates = AlternateDatesFragment.Fragment;

  export type ShoppingContext = {
    __typename?: 'ShoppingContext';

    multiItem?: MultiItem | null;
  };

  export type MultiItem = {
    __typename?: 'MultiItemContext';

    id: string;

    packageType: PackageType;
  };

  export type SingleUnitOffer = SingleOfferFragment.Fragment;

  export type SingleUnitOfferDialog = {
    __typename?: 'SingleUnitOfferDialog';

    content: _Content;

    toolbar: Toolbar;

    trigger: Trigger;
  };

  export type _Content = SingleOfferFragment.Fragment;

  export type Toolbar = LodgingDialogToolbarFragment.Fragment;

  export type Trigger = LodgingDialogTriggerMessageFragment.Fragment;

  export type SpaceDetails = {
    __typename?: 'SpaceDetails';

    header: _Header;

    floorPlan?: FloorPlan | null;

    spaces?: Spaces[] | null;

    summary?: string[] | null;
  };

  export type _Header = {
    __typename?: 'LodgingHeader';

    text?: string | null;

    subText?: string | null;
  };

  export type FloorPlan = {
    __typename?: 'FloorPlanDialog';

    images: Images[];

    toolbar?: _Toolbar | null;

    trigger: _Trigger;
  };

  export type Images = {
    __typename?: 'PropertyImage';

    alt?: string | null;

    image: Image;

    subjectId?: number | null;
  };

  export type Image = {
    __typename?: 'Image';

    description: string;

    url: Url;
  };

  export type _Toolbar = LodgingDialogToolbarFragment.Fragment;

  export type _Trigger = LodgingDialogTriggerMessageFragment.Fragment;

  export type Spaces = {
    __typename?: 'Spaces';

    name: string;

    description?: string[] | null;

    icons?: Icons[] | null;
  };

  export type Icons = IconFragment.Fragment;
}

export namespace PropertyInfoPageLayout {
  export type Variables = {
    context: ContextInput;
    propertyId: string;
    shoppingContext?: ShoppingContextInput | null;
  };

  export type Query = {
    __typename?: 'Query';

    propertyInfo: PropertyInfo;
  };

  export type PropertyInfo = {
    __typename?: 'PropertyInfo';

    experimental: Experimental;
  };

  export type Experimental = {
    __typename?: 'PropertyDetailsExperimentalSection';

    pageLayoutExperimentalFeature: PageLayoutExperimentalFeature;
  };

  export type PageLayoutExperimentalFeature = {
    __typename?: 'PageLayoutExperimentalFeature';

    templateName?: string | null;
  };
}

export namespace PropertyRoomScoreInfo {
  export type Variables = {
    propertyIds: string[];
    context: ContextInput;
  };

  export type Query = {
    __typename?: 'Query';

    propertyReviewAggregates: PropertyReviewAggregates;
  };

  export type PropertyReviewAggregates = {
    __typename?: 'PropertyReviewAggregates';

    propertySummaries?: PropertySummaries[] | null;
  };

  export type PropertySummaries = {
    __typename?: 'LodgingReviewSummary';

    propertyId: string;

    roomsScore?: RoomsScore[] | null;
  };

  export type RoomsScore = {
    __typename?: 'RoomSummary';

    roomRatingListTitle?: string | null;

    id: string;

    score?: string | null;

    scoreLabel?: string | null;

    tags: Tags[];
  };

  export type Tags = {
    __typename?: 'Tag';

    label: string;
  };
}

export namespace PropertyRateCalendar {
  export type Variables = {
    context: ContextInput;
    destination: DestinationInput;
    criteria?: PropertySearchCriteriaInput | null;
  };

  export type Query = {
    __typename?: 'Query';

    propertySearch: PropertySearch;
  };

  export type PropertySearch = {
    __typename?: 'PropertySearchResults';

    rateCalendar: RateCalendar;
  };

  export type RateCalendar = {
    __typename?: 'PropertyCalendar';

    disclaimer: Disclaimer;

    legend?: Legend[] | null;

    propertyCalendarRates: PropertyCalendarRates[];
  };

  export type Disclaimer = {
    __typename?: 'LodgingPlainMessage';

    value: string;
  };

  export type Legend = {
    __typename?: PropertyCalendarPriceTrendLegendInlineFragment['__typename'];

    label: string;
  } & PropertyCalendarPriceTrendLegendInlineFragment;

  export type PropertyCalendarPriceTrendLegendInlineFragment = {
    __typename?: 'PropertyCalendarPriceTrendLegend';

    trend: PropertyCalendarPriceTrend;

    symbol: string;
  };

  export type PropertyCalendarRates = {
    __typename?: 'PropertyCalendarRate';

    accessibilityLabel: string;

    date: Date;

    displayPrice: string;
  };

  export type Date = {
    __typename?: 'Date';

    isoFormat: string;
  };
}

export namespace PropertySearchTravelAds {
  export type Variables = {
    context: ContextInput;
    destination: DestinationInput;
    rooms?: RoomInput[] | null;
    dateRange?: PropertyDateRangeInput | null;
    sort?: PropertySort | null;
    filters?: PropertySearchFiltersInput | null;
    marketing?: PropertyMarketingInfoInput | null;
    legacyCriteria?: LegacyPropertySearchCriteriaInput | null;
    propertyShopOptions?: PropertyShopOptionsInput | null;
    searchPagination?: PaginationInput | null;
    searchIntent?: SearchIntentInput | null;
    shoppingContext?: ShoppingContextInput | null;
  };

  export type Query = {
    __typename?: 'Query';

    propertySearch: PropertySearch;
  };

  export type PropertySearch = {
    __typename?: 'PropertySearchResults';

    properties: Properties[];
  };

  export type Properties = {
    __typename?: 'Property';

    id: string;

    name: string;

    propertyImage?: PropertyImage | null;

    offerBadge?: OfferBadge | null;

    price?: Price | null;

    reviews: Reviews;

    destinationInfo: DestinationInfo;

    vipMessaging?: string | null;

    infositeURL: string;

    propertyDetailsLink?: PropertyDetailsLink | null;

    star?: number | null;

    starRatingIcon: string;

    availability: Availability;

    offerSummary: OfferSummary;

    legalDisclaimer?: LegalDisclaimer | null;

    neighborhood?: Neighborhood | null;

    recentlyViewed?: RecentlyViewed | null;

    supportingMessages?: string[] | null;

    shortList?: ShortList | null;

    sponsoredListing?: SponsoredListing | null;

    highlightedPropertyDetails: string[];

    dataAttributes?: DataAttributes | null;
  };

  export type PropertyImage = {
    __typename?: 'PropertyImage';

    image: Image;

    fallbackImage?: FallbackImage | null;

    imageId?: string | null;
  };

  export type Image = {
    __typename?: 'Image';

    description: string;

    url: Url;
  };

  export type FallbackImage = {
    __typename?: 'Image';

    description: string;

    url: Url;
  };

  export type OfferBadge = {
    __typename?: 'OfferBadge';

    primary?: Primary | null;

    secondary?: Secondary | null;
  };

  export type Primary = {
    __typename?: 'Badge';

    text?: string | null;

    theme_temp?: Theme | null;

    icon_temp?: IconTemp | null;

    mark?: Mark | null;
  };

  export type IconTemp = {
    __typename?: 'Icon';

    id: string;

    description: string;
  };

  export type Mark = {
    __typename?: 'Mark';

    id: string;

    description: string;
  };

  export type Secondary = {
    __typename?: 'Badge';

    text?: string | null;

    theme_temp?: Theme | null;

    icon_temp?: _IconTemp | null;
  };

  export type _IconTemp = {
    __typename?: 'Icon';

    id: string;

    description: string;
  };

  export type Price = {
    __typename?: 'PropertyPrice';

    lead?: Lead | null;

    strikeOutType?: StrikeOutType | null;

    strikeOut?: StrikeOut | null;

    disclaimer?: Disclaimer | null;

    roomNightMessage?: string | null;

    priceMessages?: PriceMessages[] | null;

    marketingFeeDetails?: MarketingFeeDetails | null;

    options?: Options[] | null;
  };

  export type Lead = {
    __typename?: 'Money';

    formatted: string;
  };

  export type StrikeOut = {
    __typename?: 'Money';

    formatted: string;
  };

  export type Disclaimer = {
    __typename?: 'LodgingPlainMessage';

    value: string;
  };

  export type PriceMessages = {
    __typename?: 'LodgingPlainMessage';

    value: string;
  };

  export type MarketingFeeDetails = {
    __typename?: 'MarketingFeeDetails';

    tierName: string;

    tierIcon: string;

    marketingFeeMessage: MarketingFeeMessage;
  };

  export type MarketingFeeMessage = {
    __typename?: 'LodgingPlainMessage';

    value: string;
  };

  export type Options = {
    __typename?: 'PropertyPriceOption';

    leadingCaption?: string | null;

    displayPrice?: DisplayPrice | null;

    strikeOut?: _StrikeOut | null;

    loyaltyPrice?: LoyaltyPrice | null;

    disclaimer?: _Disclaimer | null;
  };

  export type DisplayPrice = {
    __typename?: 'Money';

    formatted: string;
  };

  export type _StrikeOut = {
    __typename?: 'Money';

    formatted: string;
  };

  export type LoyaltyPrice = {
    __typename?: 'LoyaltyPrice';

    amount?: Amount | null;

    totalStrikeOutPoints?: TotalStrikeOutPoints | null;

    unit?: string | null;
  };

  export type Amount = {
    __typename?: 'FormattedNumber';

    formatted: string;
  };

  export type TotalStrikeOutPoints = {
    __typename?: 'FormattedNumber';

    formatted: string;
  };

  export type _Disclaimer = {
    __typename?: 'LodgingPlainMessage';

    value: string;
  };

  export type Reviews = {
    __typename?: 'PropertyReviewsSummary';

    score?: number | null;

    localizedScore?: string | null;

    total?: number | null;

    localizedTotal?: string | null;

    superlative?: string | null;

    localizedSubtitle?: string | null;

    localizedSubtitleA11y?: LocalizedSubtitleA11y | null;
  };

  export type LocalizedSubtitleA11y = {
    __typename?: 'LodgingEnrichedMessage';

    accessibilityLabel?: string | null;

    value: string;
  };

  export type DestinationInfo = {
    __typename?: 'PropertyDestinationInfo';

    distanceFromMessaging?: string | null;
  };

  export type PropertyDetailsLink = {
    __typename?: 'LodgingLink';

    uri: Uri;

    clientSideAnalytics?: ClientSideAnalytics | null;
  };

  export type Uri = {
    __typename?: 'HttpURI';

    relativePath: string;

    value: string;
  };

  export type ClientSideAnalytics = {
    __typename?: 'ClientSideAnalytics';

    referrerId: string;

    linkName: string;
  };

  export type Availability = {
    __typename?: 'PropertyAvailability';

    available: boolean;

    text?: string | null;

    theme?: Theme | null;
  };

  export type OfferSummary = {
    __typename?: 'OfferSummary';

    messages?: Messages[] | null;
  };

  export type Messages = {
    __typename?: 'OfferSummaryMessage';

    message?: string | null;

    theme?: Theme | null;

    type?: string | null;

    mark?: _Mark | null;
  };

  export type _Mark = {
    __typename?: 'Mark';

    id: string;
  };

  export type LegalDisclaimer = {
    __typename?: 'PropertyLegalDisclaimer';

    title?: string | null;

    disclaimerContents?: string[] | null;
  };

  export type Neighborhood = {
    __typename?: 'Region';

    name: string;
  };

  export type RecentlyViewed = {
    __typename?: 'Icon';

    id: string;

    description: string;
  };

  export type ShortList = {
    __typename?: 'ShortList';

    favorited: boolean;

    saveUrl: string;

    removeUrl: string;

    metaData: MetaData;
  };

  export type MetaData = {
    __typename?: 'ShortListMetaData';

    chkIn: string;

    chkOut: string;

    hotelId: string;

    roomConfiguration: string;
  };

  export type SponsoredListing = {
    __typename?: 'SponsoredListing';

    id?: string | null;

    clickRedirectTrackingUrl?: Url | null;

    clickTrackingUrl?: Url | null;

    details?: string | null;

    detailsHeadline?: string | null;

    hotelImage?: string | null;

    impressionTrackingUrl?: Url | null;

    trackingData?: string | null;

    brand?: string | null;

    clickRedirectLinkoffTrackingUrl?: Url | null;

    logo?: string | null;

    lotagline?: string | null;

    rating?: string | null;

    slots?: string | null;

    vanityUrl?: Url | null;

    rank?: string | null;

    position?: string | null;
  };

  export type DataAttributes = {
    __typename?: 'GraphQLPair';

    key: string;

    value: string;
  };
}

export namespace ShareInfo {
  export type Variables = {
    context: ContextInput;
    propertyId: string;
    shoppingContext?: ShoppingContextInput | null;
  };

  export type Query = {
    __typename?: 'Query';

    propertyInfo: PropertyInfo;
  };

  export type PropertyInfo = {
    __typename?: 'PropertyInfo';

    shareInfo?: ShareInfo | null;
  };

  export type ShareInfo = {
    __typename?: 'ShareInfo';

    menuName: string;

    linkCopiedMessage: string;

    sharedText: string;

    facebookAppId: string;

    linkList: LinkList[];
  };

  export type LinkList = {
    __typename?: 'LodgingLinkMessage';

    label?: string | null;

    value: string;

    link: Link;
  };

  export type Link = {
    __typename?: 'LodgingLink';

    uri: Uri;
  };

  export type Uri = {
    __typename?: 'HttpURI';

    value: string;
  };
}

export namespace RemoveItemFromCart {
  export type Variables = {
    cartId: Uuid;
    context: ContextInput;
    itemId: Uuid;
  };

  export type Mutation = {
    __typename?: 'Mutation';

    cartItems: CartItems;
  };

  export type CartItems = {
    __typename?: 'CartMutations';

    remove: Remove;
  };

  export type Remove = {
    __typename?: 'CartSummary';

    id: Uuid;

    itemCount: number;
  };
}

export namespace QuestionAnswers {
  export type Variables = {
    context: ContextInput;
    productId: string;
    filters: ProductQuestionFiltersInput;
    pagination: PaginationInput;
    productQuestionTopic: ProductQuestionTopic;
    questionDateFormat: string;
  };

  export type Query = {
    __typename?: 'Query';

    productQuestions?: ProductQuestions | null;
  };

  export type ProductQuestions = {
    __typename?: 'ProductQuestions';

    totalCount?: TotalCount | null;

    questions: Questions[];
  };

  export type TotalCount = {
    __typename?: 'FormattedNumber';

    raw: number;
  };

  export type Questions = {
    __typename?: 'UserQuestion';

    answers?: Answers[] | null;

    createDate?: CreateDate | null;

    id: string;

    question: string;

    questioner?: string | null;

    totalAnswers: TotalAnswers;
  };

  export type Answers = {
    __typename?: 'UserAnswer';

    answer: string;

    answerTime: AnswerTime;

    displayName?: string | null;

    id: string;

    upVotes: UpVotes;
  };

  export type AnswerTime = {
    __typename?: 'DateTime';

    formatted: string;

    raw: string;
  };

  export type UpVotes = {
    __typename?: 'FormattedNumber';

    raw: number;
  };

  export type CreateDate = {
    __typename?: 'DateTime';

    formatted: string;

    raw: string;
  };

  export type TotalAnswers = {
    __typename?: 'FormattedNumber';

    raw: number;
  };
}

export namespace SelectProducts {
  export type Variables = {
    context: ContextInput;
    sessionId: string;
    priceToken?: string | null;
    properties?: PropertyNaturalKeyInput[] | null;
    flights?: FlightNaturalKeyInput[] | null;
    cars?: CarNaturalKeyInput[] | null;
  };

  export type Mutation = {
    __typename?: 'Mutation';

    multiItemShopping: MultiItemShopping;
  };

  export type MultiItemShopping = {
    __typename?: 'MultiItemSessionMutations';

    selectProducts: SelectProducts;
  };

  export type SelectProducts = MultiItemSearchContextCreatedResponseInlineFragment | MultiItemSearchContextErrorResponseInlineFragment;

  export type MultiItemSearchContextCreatedResponseInlineFragment = {
    __typename?: 'MultiItemSearchContextCreatedResponse';

    shoppingContext: ShoppingContext;

    redirectUrl?: Url | null;
  };

  export type ShoppingContext = {
    __typename?: 'ShoppingContext';

    multiItem?: MultiItem | null;
  };

  export type MultiItem = {
    __typename?: 'MultiItemContext';

    id: string;

    packageType: PackageType;
  };

  export type MultiItemSearchContextErrorResponseInlineFragment = {
    __typename?: 'MultiItemSearchContextErrorResponse';

    message?: string | null;
  };
}

export namespace MultiItemPropertySearchContextFields {
  export type Fragment = {
    __typename?: 'MultiItemSearchContext';

    properties?: Properties[] | null;
  };

  export type Properties = {
    __typename?: 'PropertySearchCriteria';

    primary: Primary;
  };

  export type Primary = {
    __typename?: 'PrimaryPropertyCriteria';

    rooms: Rooms[];

    destination: Destination;

    dateRange?: DateRange | null;
  };

  export type Rooms = {
    __typename?: 'Room';

    adults: number;
  };

  export type Destination = {
    __typename?: 'Destination';

    regionId?: string | null;

    regionName?: string | null;
  };

  export type DateRange = {
    __typename?: 'PropertyDateRange';

    checkInDate: CheckInDate;

    checkOutDate: CheckOutDate;
  };

  export type CheckInDate = CommonDateFields.Fragment;

  export type CheckOutDate = CommonDateFields.Fragment;
}

export namespace MessageFields {
  export type Fragment = {
    __typename?: 'MessageResult';

    title?: Title | null;

    subtitle?: Subtitle | null;

    action?: Action | null;

    index?: number | null;

    type?: MessageType | null;
  };

  export type Title = MessageTitleFields.Fragment;

  export type Subtitle = MessageTitleFields.Fragment;

  export type Action = {
    __typename?: 'MessagingResultAction';

    primary?: Primary | null;

    secondary?: Secondary | null;
  };

  export type Primary = MessagingActionFields.Fragment;

  export type Secondary = MessagingActionFields.Fragment;
}

export namespace MessageTitleFields {
  export type Fragment = {
    __typename?: 'MessagingResultTitle';

    text?: string | null;

    icon?: Icon | null;

    mark?: Mark | null;

    illustration?: Illustration | null;

    theme?: Theme | null;
  };

  export type Icon = {
    __typename?: 'Icon';

    description: string;

    id: string;
  };

  export type Mark = {
    __typename?: 'LodgingMark';

    description: string;

    id: string;
  };

  export type Illustration = {
    __typename?: 'LodgingIllustration';

    assetUri?: AssetUri | null;

    description?: string | null;
  };

  export type AssetUri = {
    __typename?: 'HttpURI';

    value: string;
  };
}

export namespace MessagingActionFields {
  export type Fragment = {
    __typename?: 'MessagingAction';

    actionDetails?: ActionDetails | null;

    linkUrl: string;

    referrerId?: string | null;

    text?: string | null;
  };

  export type ActionDetails = {
    __typename?: 'ActionDetails';

    details?: string | null;

    name: ActionDetailsType;

    title?: string | null;

    accessibilityLabel?: string | null;
  };
}

export namespace PropertyFields {
  export type Fragment = {
    __typename?: 'Property';

    star?: number | null;

    starRatingIcon: string;

    availability: Availability;

    offerSummary: OfferSummary;

    legalDisclaimer?: LegalDisclaimer | null;

    propertyGallery?: PropertyGallery[] | null;

    mapMarker?: MapMarker | null;

    neighborhood?: Neighborhood | null;

    offerBadge?: OfferBadge | null;

    pinnedDetails?: PinnedDetails | null;

    recentlyViewed?: RecentlyViewed | null;

    featuredMessages?: FeaturedMessages[] | null;

    supportingMessages?: string[] | null;

    shortList?: ShortList | null;

    highlightedPropertyDetails: string[];

    dataAttributes?: DataAttributes | null;

    listingFooter?: ListingFooter | null;
  } & CommonPropertyCardFields.Fragment;

  export type Availability = {
    __typename?: 'PropertyAvailability';

    available: boolean;

    text?: string | null;

    theme?: Theme | null;
  };

  export type OfferSummary = {
    __typename?: 'OfferSummary';

    messages?: Messages[] | null;
  };

  export type Messages = {
    __typename?: 'OfferSummaryMessage';

    message?: string | null;

    theme?: Theme | null;

    type?: string | null;

    mark?: Mark | null;
  };

  export type Mark = {
    __typename?: 'Mark';

    id: string;
  };

  export type LegalDisclaimer = {
    __typename?: 'PropertyLegalDisclaimer';

    title?: string | null;

    disclaimerContents?: string[] | null;
  };

  export type PropertyGallery = {
    __typename?: 'PropertyImage';

    image: Image;

    subjectId?: number | null;

    fallbackImage?: FallbackImage | null;

    imageId?: string | null;
  };

  export type Image = {
    __typename?: 'Image';

    url: Url;

    description: string;
  };

  export type FallbackImage = {
    __typename?: 'Image';

    url: Url;

    description: string;
  };

  export type MapMarker = {
    __typename?: 'MapMarker';

    icon: MapIconType;

    label: string;

    type?: MarkerType | null;

    latLong: LatLong;
  };

  export type LatLong = {
    __typename?: 'Coordinates';

    latitude: number;

    longitude: number;
  };

  export type Neighborhood = {
    __typename?: 'Region';

    name: string;
  };

  export type OfferBadge = {
    __typename?: 'OfferBadge';

    primary?: Primary | null;

    secondary?: Secondary | null;
  };

  export type Primary = {
    __typename?: 'Badge';

    text?: string | null;

    theme_temp?: Theme | null;

    icon_temp?: IconTemp | null;

    mark?: _Mark | null;
  };

  export type IconTemp = {
    __typename?: 'Icon';

    id: string;

    description: string;
  };

  export type _Mark = {
    __typename?: 'Mark';

    id: string;

    description: string;
  };

  export type Secondary = {
    __typename?: 'Badge';

    text?: string | null;

    theme_temp?: Theme | null;

    icon_temp?: _IconTemp | null;
  };

  export type _IconTemp = {
    __typename?: 'Icon';

    id: string;

    description: string;
  };

  export type PinnedDetails = {
    __typename?: 'PinnedPropertyModel';

    heading: string;
  };

  export type RecentlyViewed = {
    __typename?: 'Icon';

    id: string;

    description: string;
  };

  export type FeaturedMessages = FeaturedMessage.Fragment;

  export type ShortList = {
    __typename?: 'ShortList';

    favorited: boolean;

    saveUrl: string;

    removeUrl: string;

    metaData: MetaData;
  };

  export type MetaData = {
    __typename?: 'ShortListMetaData';

    chkIn: string;

    chkOut: string;

    hotelId: string;

    roomConfiguration: string;
  };

  export type DataAttributes = {
    __typename?: 'GraphQLPair';

    key: string;

    value: string;
  };

  export type ListingFooter = {
    __typename?: 'MessagingAction';

    actionDetails?: ActionDetails | null;

    icon?: Icon | null;

    linkUrl: string;

    referrerId?: string | null;

    text?: string | null;
  };

  export type ActionDetails = {
    __typename?: 'ActionDetails';

    name: ActionDetailsType;
  };

  export type Icon = {
    __typename?: 'Icon';

    description: string;

    id: string;
  };
}

export namespace SearchLinkMessage {
  export type Fragment = {
    __typename?: 'LodgingLinkMessage';

    label?: string | null;

    link: Link;

    icon?: Icon | null;
  };

  export type Link = SearchLink.Fragment;

  export type Icon = {
    __typename?: 'Icon';

    id: string;
  };
}

export namespace SearchDialogMessage {
  export type Fragment = {
    __typename?: 'LodgingDialogTriggerMessage';

    dialogTrigger: DialogTrigger;

    icon?: Icon | null;
  };

  export type DialogTrigger = {
    __typename?: 'LodgingDialogTrigger';

    dialogName: string;

    referrerId?: string | null;

    actionDetails?: ActionDetails | null;
  };

  export type ActionDetails = {
    __typename?: 'DialogAction';

    linkUrl: string;

    referrerId?: string | null;

    message?: string | null;

    text?: string | null;
  };

  export type Icon = {
    __typename?: 'Icon';

    id: string;
  };
}

export namespace SearchLink {
  export type Fragment = {
    __typename?: 'LodgingLink';

    url: Url;

    referrerId?: string | null;
  };
}

export namespace CommonPropertyCardFields {
  export type Fragment = {
    __typename?: 'Property';

    id: string;

    name: string;

    propertyImage?: PropertyImage | null;

    offerBadge?: OfferBadge | null;

    price?: Price | null;

    reviews: Reviews;

    destinationInfo: DestinationInfo;

    vipMessaging?: string | null;

    propertyDetailsLink?: PropertyDetailsLink | null;

    sponsoredListing?: SponsoredListing | null;
  };

  export type PropertyImage = {
    __typename?: 'PropertyImage';

    image: Image;

    fallbackImage?: FallbackImage | null;
  };

  export type Image = {
    __typename?: 'Image';

    description: string;

    url: Url;
  };

  export type FallbackImage = {
    __typename?: 'Image';

    description: string;

    url: Url;
  };

  export type OfferBadge = {
    __typename?: 'OfferBadge';

    primary?: Primary | null;

    secondary?: Secondary | null;
  };

  export type Primary = {
    __typename?: 'Badge';

    text?: string | null;

    theme_temp?: Theme | null;

    icon_temp?: IconTemp | null;

    mark?: Mark | null;
  };

  export type IconTemp = {
    __typename?: 'Icon';

    id: string;

    description: string;
  };

  export type Mark = {
    __typename?: 'Mark';

    id: string;

    description: string;
  };

  export type Secondary = {
    __typename?: 'Badge';

    text?: string | null;

    theme_temp?: Theme | null;

    icon_temp?: _IconTemp | null;
  };

  export type _IconTemp = {
    __typename?: 'Icon';

    id: string;

    description: string;
  };

  export type Price = {
    __typename?: 'PropertyPrice';

    lead?: Lead | null;

    strikeOutType?: StrikeOutType | null;

    strikeOut?: StrikeOut | null;

    disclaimer?: Disclaimer | null;

    roomNightMessage?: string | null;

    priceMessages?: PriceMessages[] | null;

    marketingFeeDetails?: MarketingFeeDetails | null;

    options?: Options[] | null;
  };

  export type Lead = {
    __typename?: 'Money';

    formatted: string;
  };

  export type StrikeOut = {
    __typename?: 'Money';

    formatted: string;
  };

  export type Disclaimer = {
    __typename?: 'LodgingPlainMessage';

    value: string;
  };

  export type PriceMessages = {
    __typename?: 'LodgingPlainMessage';

    value: string;
  };

  export type MarketingFeeDetails = {
    __typename?: 'MarketingFeeDetails';

    tierName: string;

    tierIcon: string;

    marketingFeeMessage: MarketingFeeMessage;
  };

  export type MarketingFeeMessage = {
    __typename?: 'LodgingPlainMessage';

    value: string;
  };

  export type Options = {
    __typename?: 'PropertyPriceOption';

    leadingCaption?: string | null;

    displayPrice?: DisplayPrice | null;

    strikeOut?: _StrikeOut | null;

    loyaltyPrice?: LoyaltyPrice | null;

    disclaimer?: _Disclaimer | null;
  };

  export type DisplayPrice = {
    __typename?: 'Money';

    formatted: string;
  };

  export type _StrikeOut = {
    __typename?: 'Money';

    formatted: string;
  };

  export type LoyaltyPrice = {
    __typename?: 'LoyaltyPrice';

    amount?: Amount | null;

    totalStrikeOutPoints?: TotalStrikeOutPoints | null;

    unit?: string | null;
  };

  export type Amount = {
    __typename?: 'FormattedNumber';

    formatted: string;
  };

  export type TotalStrikeOutPoints = {
    __typename?: 'FormattedNumber';

    formatted: string;
  };

  export type _Disclaimer = {
    __typename?: 'LodgingPlainMessage';

    value: string;
  };

  export type Reviews = {
    __typename?: 'PropertyReviewsSummary';

    score?: number | null;

    localizedScore?: string | null;

    total?: number | null;

    localizedTotal?: string | null;

    superlative?: string | null;

    localizedSubtitle?: string | null;

    localizedSubtitleA11y?: LocalizedSubtitleA11y | null;

    mark?: _Mark | null;
  };

  export type LocalizedSubtitleA11y = {
    __typename?: 'LodgingEnrichedMessage';

    accessibilityLabel?: string | null;

    value: string;
  };

  export type _Mark = {
    __typename?: 'LodgingMark';

    id: string;

    description: string;
  };

  export type DestinationInfo = {
    __typename?: 'PropertyDestinationInfo';

    distanceFromMessaging?: string | null;
  };

  export type PropertyDetailsLink = {
    __typename?: 'LodgingLink';

    uri: Uri;

    clientSideAnalytics?: ClientSideAnalytics | null;
  };

  export type Uri = {
    __typename?: 'HttpURI';

    value: string;

    relativePath: string;
  };

  export type ClientSideAnalytics = {
    __typename?: 'ClientSideAnalytics';

    referrerId: string;

    linkName: string;
  };

  export type SponsoredListing = {
    __typename?: 'SponsoredListing';

    id?: string | null;

    clickRedirectTrackingUrl?: Url | null;

    clickTrackingUrl?: Url | null;

    details?: string | null;

    detailsHeadline?: string | null;

    hotelImage?: string | null;

    impressionTrackingUrl?: Url | null;

    trackingData?: string | null;

    brand?: string | null;

    clickRedirectLinkoffTrackingUrl?: Url | null;

    logo?: string | null;

    lotagline?: string | null;

    rating?: string | null;

    slots?: string | null;

    vanityUrl?: Url | null;

    rank?: string | null;

    position?: string | null;
  };
}

export namespace CommonDateFields {
  export type Fragment = {
    __typename?: 'Date';

    year: number;

    month: number;

    day: number;
  };
}

export namespace CommonDateTimeFields {
  export type Fragment = {
    __typename?: 'DateTime';

    year: number;

    month: number;

    day: number;

    hour: number;

    minute: number;

    second: number;
  };
}

export namespace PointsEducationFragment {
  export type Fragment = {
    __typename?: 'LoyaltyPointsEducation';

    description?: string | null;

    programFeatures: ProgramFeatures[];

    heroImage?: HeroImage | null;
  };

  export type ProgramFeatures = {
    __typename?: 'LoyaltyEducationSection';

    description?: string | null;

    perks?: Perks | null;

    title?: string | null;
  };

  export type Perks = PerksFragment.Fragment;

  export type HeroImage = {
    __typename?: 'Image';

    url: Url;

    description: string;
  };
}

export namespace ProgramEducationFragment {
  export type Fragment = {
    __typename?: 'LoyaltyProgramEducation';

    joinProgramText?: string | null;

    perks: Perks;
  };

  export type Perks = PerksFragment.Fragment;
}

export namespace PerksFragment {
  export type Fragment = {
    __typename?: 'LoyaltyEducationPerks';

    descriptions: string[];

    icon?: string | null;
  };
}

export namespace FeaturedMessage {
  export type Fragment = {
    __typename?: 'LodgingEnrichedMessage';

    icon?: Icon | null;

    value: string;
  };

  export type Icon = {
    __typename?: 'Icon';

    id: string;

    description: string;

    size?: IconSize | null;
  };
}

export namespace LodgingEnrichedMessage {
  export type Fragment = {
    __typename?: 'LodgingEnrichedMessage';

    icon?: Icon | null;

    label?: string | null;

    mark?: Mark | null;

    theme?: LodgingMessageTheme | null;

    subText?: string | null;

    value: string;
  };

  export type Icon = {
    __typename?: 'Icon';

    id: string;

    description: string;

    size?: IconSize | null;
  };

  export type Mark = {
    __typename?: 'LodgingMark';

    id: string;

    description: string;
  };
}

export namespace AlternateDatesFragment {
  export type Fragment = {
    __typename?: 'AlternateDatesCard';

    header?: Header | null;

    options: Options[];
  };

  export type Header = {
    __typename?: 'LodgingHeader';

    text?: string | null;

    subText?: string | null;
  };

  export type Options = AlternateDateOptionFragment.Fragment;
}

export namespace PropertyUnitDetailsDialog {
  export type Fragment = {
    __typename?: 'PropertyUnitDetailsDialog';

    content: Content;

    trigger: Trigger;

    toolbar?: Toolbar | null;
  };

  export type Content = {
    __typename?: 'PropertyUnitDetails';

    ratePlanTitle?: RatePlanTitle | null;

    details?: Details | null;
  };

  export type RatePlanTitle = {
    __typename?: 'LodgingHeader';

    text?: string | null;
  };

  export type Details = {
    __typename?: 'PropertyInfoSection';

    header?: Header | null;

    contents: Contents[];
  };

  export type Header = {
    __typename?: 'LodgingHeader';

    text?: string | null;

    subText?: string | null;
  };

  export type Contents = {
    __typename?: 'PropertyInfoContent';

    heading?: string | null;

    items: Items[];
  };

  export type Items = {
    __typename?: 'PropertyInfoItem';

    text: string;
  };

  export type Trigger = {
    __typename?: 'LodgingDialogTriggerMessage';

    value: string;

    clientSideAnalytics?: ClientSideAnalytics | null;

    dialogTrigger: DialogTrigger;
  };

  export type ClientSideAnalytics = {
    __typename?: 'ClientSideAnalytics';

    referrerId: string;

    linkName: string;
  };

  export type DialogTrigger = {
    __typename?: 'LodgingDialogTrigger';

    clientSideAnalytics?: _ClientSideAnalytics | null;
  };

  export type _ClientSideAnalytics = {
    __typename?: 'ClientSideAnalytics';

    referrerId: string;
  };

  export type Toolbar = {
    __typename?: 'LodgingDialogToolbar';

    title?: string | null;

    icon?: Icon | null;

    clientSideAnalytics?: __ClientSideAnalytics | null;
  };

  export type Icon = {
    __typename?: 'Icon';

    description: string;
  };

  export type __ClientSideAnalytics = {
    __typename?: 'ClientSideAnalytics';

    referrerId: string;

    linkName: string;
  };
}

export namespace MessageFragment {
  export type Fragment = {
    __typename?: 'MessageResult';

    type?: MessageType | null;

    title?: Title | null;

    subtitle?: Subtitle | null;

    action?: Action | null;
  };

  export type Title = TitleFragment.Fragment;

  export type Subtitle = TitleFragment.Fragment;

  export type Action = {
    __typename?: 'MessagingResultAction';

    primary?: Primary | null;

    secondary?: Secondary | null;
  };

  export type Primary = ActionFragment.Fragment;

  export type Secondary = ActionFragment.Fragment;
}

export namespace TitleFragment {
  export type Fragment = {
    __typename?: 'MessagingResultTitle';

    text?: string | null;

    theme?: Theme | null;

    icon?: Icon | null;

    mark?: Mark | null;

    illustration?: Illustration | null;
  };

  export type Icon = IconFragment.Fragment;

  export type Mark = {
    __typename?: 'LodgingMark';

    id: string;

    description: string;
  };

  export type Illustration = {
    __typename?: 'LodgingIllustration';

    assetUri?: AssetUri | null;

    description?: string | null;
  };

  export type AssetUri = {
    __typename?: 'HttpURI';

    value: string;
  };
}

export namespace ActionFragment {
  export type Fragment = {
    __typename?: 'MessagingAction';

    linkUrl: string;

    text?: string | null;

    referrerId?: string | null;

    actionDetails?: ActionDetails | null;

    icon?: Icon | null;
  };

  export type ActionDetails = {
    __typename?: 'ActionDetails';

    name: ActionDetailsType;

    details?: string | null;

    title?: string | null;

    accessibilityLabel?: string | null;
  };

  export type Icon = {
    __typename?: 'Icon';

    id: string;
  };
}

export namespace UnitFragment {
  export type Fragment = {
    __typename?: 'PropertyUnit';

    bookingUrl?: string | null;

    bedOptions: BedOptions[];

    description?: string | null;

    id: string;

    name?: string | null;

    header?: Header | null;

    size?: string | null;

    detailsDialog?: DetailsDialog | null;

    ratePlans: RatePlans[];

    unavailableRatePlans: UnavailableRatePlans[];

    ratePlansExpando: RatePlansExpando;

    features: Features[];

    cancellationPolicy?: CancellationPolicy | null;

    rateCategorization?: RateCategorization | null;

    maxOccupancy?: MaxOccupancy | null;

    spaceDetails?: SpaceDetails | null;

    roomAmenities?: RoomAmenities | null;

    unitGallery?: UnitGallery | null;

    availabilityCallToAction?: AvailabilityCallToAction | null;
  };

  export type BedOptions = {
    __typename?: 'BedOptions';

    name: string;

    icon: string;
  };

  export type Header = {
    __typename?: 'LodgingHeader';

    icon?: Icon | null;

    text?: string | null;

    subText?: string | null;
  };

  export type Icon = IconFragment.Fragment;

  export type DetailsDialog = PropertyUnitDetailsDialog.Fragment;

  export type RatePlans = RatePlanFragment.Fragment;

  export type UnavailableRatePlans = RatePlanFragment.Fragment;

  export type RatePlansExpando = {
    __typename?: 'RatePlansExpando';

    expandButton: ExpandButton;
  };

  export type ExpandButton = {
    __typename?: 'LodgingButton';

    text: string;
  };

  export type Features = {
    __typename?: 'PropertyInfoItem';

    text: string;

    moreInfo?: string | null;

    icon?: _Icon | null;
  };

  export type _Icon = IconFragment.Fragment;

  export type CancellationPolicy = CancellationPolicyFragment.Fragment;

  export type RateCategorization = {
    __typename?: 'RateCategorization';

    paymentPolicyTitle?: string | null;

    customizeStayTitle?: string | null;

    options: Options[];
  } & CancellationPolicyDialogFragment.Fragment;

  export type Options = {
    __typename?: 'RatePlanOption';

    policyOption?: PolicyOption | null;

    addOnOptions: AddOnOptions[];
  };

  export type PolicyOption = {
    __typename?: 'PolicyOption';

    id: number;

    description: string;

    subText?: string | null;

    price: string;
  };

  export type AddOnOptions = {
    __typename?: 'AmenityOption';

    description: string;

    subText?: string | null;

    price: string;

    enabled: boolean;

    ratePlan?: string | null;

    moreInfoDialog?: MoreInfoDialog | null;
  };

  export type MoreInfoDialog = LodgingPlainFullscreenDialogFragment.Fragment;

  export type MaxOccupancy = {
    __typename?: 'UnitOccupancy';

    people: number;

    adults: number;

    children: number;

    description?: string | null;
  };

  export type SpaceDetails = {
    __typename?: 'SpaceDetails';

    header: _Header;

    floorPlan?: FloorPlan | null;

    spaces?: Spaces[] | null;

    summary?: string[] | null;
  };

  export type _Header = {
    __typename?: 'LodgingHeader';

    text?: string | null;

    subText?: string | null;
  };

  export type FloorPlan = {
    __typename?: 'FloorPlanDialog';

    images: Images[];

    toolbar?: Toolbar | null;

    trigger: Trigger;
  };

  export type Images = {
    __typename?: 'PropertyImage';

    alt?: string | null;

    image: Image;

    subjectId?: number | null;
  };

  export type Image = {
    __typename?: 'Image';

    description: string;

    url: Url;
  };

  export type Toolbar = LodgingDialogToolbarFragment.Fragment;

  export type Trigger = LodgingDialogTriggerMessageFragment.Fragment;

  export type Spaces = {
    __typename?: 'Spaces';

    name: string;

    description?: string[] | null;

    icons?: Icons[] | null;
  };

  export type Icons = IconFragment.Fragment;

  export type RoomAmenities = {
    __typename?: 'PropertyContentSection';

    header?: __Header | null;

    bodySubSections: BodySubSections[];
  };

  export type __Header = {
    __typename?: 'LodgingHeader';

    text?: string | null;
  };

  export type BodySubSections = {
    __typename?: 'PropertyContentSubSection';

    contents: Contents[];
  };

  export type Contents = {
    __typename?: 'PropertyContent';

    header?: ___Header | null;

    items: Items[];
  };

  export type ___Header = {
    __typename?: 'LodgingHeader';

    text?: string | null;

    icon?: __Icon | null;
  };

  export type __Icon = {
    __typename?: 'Icon';

    id: string;
  };

  export type Items = PropertyContentItemMarkupInlineFragment;

  export type PropertyContentItemMarkupInlineFragment = {
    __typename?: 'PropertyContentItemMarkup';

    content: Content;
  };

  export type Content = {
    __typename?: 'MarkupText';

    text: string;
  };

  export type UnitGallery = {
    __typename?: 'PropertyImageGallery';

    images: _Images[];

    label?: string | null;
  };

  export type _Images = {
    __typename?: 'PropertyImage';

    alt?: string | null;

    image: _Image;

    thumbnail?: Thumbnail | null;

    fallbackImage?: FallbackImage | null;

    subjectId?: number | null;
  };

  export type _Image = {
    __typename?: 'Image';

    description: string;

    url: Url;
  };

  export type Thumbnail = {
    __typename?: 'Image';

    description: string;

    url: Url;
  };

  export type FallbackImage = {
    __typename?: 'Image';

    description: string;

    url: Url;
  };

  export type AvailabilityCallToAction = LodgingPlainMessageInlineFragment | LodgingButtonInlineFragment;

  export type LodgingPlainMessageInlineFragment = {
    __typename?: 'LodgingPlainMessage';

    value: string;
  };

  export type LodgingButtonInlineFragment = {
    __typename?: 'LodgingButton';

    text: string;
  };
}

export namespace CancellationPolicyFragment {
  export type Fragment = LodgingPlainDialogFragment.Fragment | LodgingEnrichedMessageFragment.Fragment;
}

export namespace DateFragment {
  export type Fragment = {
    __typename?: 'Date';

    month: number;

    day: number;

    year: number;

    shortDateFormat?: string | null;
  };
}

export namespace RatePlanFragment {
  export type Fragment = {
    __typename?: 'RatePlan';

    id: string;

    name?: string | null;

    description?: string | null;

    loyaltyMessage?: LoyaltyMessage | null;

    headerMessage?: HeaderMessage | null;

    priceDetails: PriceDetails[];

    amenities: Amenities[];

    marketingSection?: MarketingSection | null;

    highlightedMessages?: (HighlightedMessages | null)[] | null;

    marketingChannelMessage?: MarketingChannelMessage | null;

    badge?: Badge | null;

    etpDialogTopMessage?: EtpDialogTopMessage | null;

    paymentPolicy: PaymentPolicy[];

    reserveCallToAction?: ReserveCallToAction | null;
  };

  export type LoyaltyMessage = {
    __typename?: 'LodgingEnrichedMessage';

    value: string;

    state?: string | null;

    mark?: Mark | null;

    label?: string | null;
  };

  export type Mark = {
    __typename?: 'LodgingMark';

    id: string;
  };

  export type HeaderMessage = {
    __typename?: 'LodgingEnrichedMessage';

    value: string;

    subText?: string | null;

    theme?: LodgingMessageTheme | null;

    label?: string | null;
  };

  export type PriceDetails = PriceDetailsFragment.Fragment;

  export type Amenities = {
    __typename?: 'RatePlanAmenity';

    id?: number | null;

    additionalInformation?: string | null;

    category?: AmenityCategory | null;

    description?: string | null;

    icon?: Icon | null;
  };

  export type Icon = {
    __typename?: 'Icon';

    id: string;

    description: string;

    size?: IconSize | null;
  };

  export type MarketingSection = MarketingSectionFragment.Fragment;

  export type HighlightedMessages =
    | LodgingEnrichedMessageFragment.Fragment
    | LodgingPlainMessageFragment.Fragment
    | LodgingPlainDialogFragment.Fragment;

  export type MarketingChannelMessage = {
    __typename?: 'LodgingEnrichedMessage';

    value: string;

    mark?: _Mark | null;
  };

  export type _Mark = {
    __typename?: 'LodgingMark';

    id: string;
  };

  export type Badge = {
    __typename?: 'Badge';

    text?: string | null;

    theme_temp?: Theme | null;

    icon_temp?: IconTemp | null;
  };

  export type IconTemp = {
    __typename?: 'Icon';

    id: string;

    description: string;

    size?: IconSize | null;
  };

  export type EtpDialogTopMessage = MessageFragment.Fragment;

  export type PaymentPolicy = PaymentPolicyFragment.Fragment;

  export type ReserveCallToAction = EtpDialogInlineFragment | LodgingFormInlineFragment;

  export type EtpDialogInlineFragment = {
    __typename?: 'EtpDialog';

    trigger: Trigger;

    toolbar: Toolbar;
  };

  export type Trigger = {
    __typename?: 'LodgingDialogTriggerMessage';

    value: string;
  };

  export type Toolbar = {
    __typename?: 'LodgingDialogToolbar';

    icon?: _Icon | null;

    title?: string | null;
  };

  export type _Icon = {
    __typename?: 'Icon';

    description: string;
  };

  export type LodgingFormInlineFragment = {
    __typename?: 'LodgingForm';

    action: string;

    inputs?: Inputs[] | null;

    method: LodgingFormMethod;

    submit: Submit;
  };

  export type Inputs = LodgingTextInputInlineFragment;

  export type LodgingTextInputInlineFragment = {
    __typename?: 'LodgingTextInput';

    name?: string | null;

    type?: LodgingInputType | null;

    value?: string | null;
  };

  export type Submit = {
    __typename?: 'LodgingButton';

    text: string;
  };
}

export namespace PriceDetailsFragment {
  export type Fragment = {
    __typename?: 'Offer';

    optionTitle?: OptionTitle | null;

    availability?: Availability | null;

    price?: Price | null;

    cancellationPolicy?: CancellationPolicy | null;

    priceBreakDownSummary?: PriceBreakDownSummary | null;

    pointsApplied?: string | null;

    dataAttributes?: DataAttributes | null;

    feeMessages?: FeeMessages[] | null;

    loyaltyMessage?: LoyaltyMessage | null;

    offerBookButton?: OfferBookButton | null;

    paymentModel?: PropertyPaymentModel | null;

    noCreditCard: boolean;

    installmentPayable: boolean;

    totalPriceMessage?: string | null;

    deposit?: Deposit | null;

    hotelCollect?: boolean | null;

    etpModalPolicies?: string[] | null;

    propertyNaturalKeys: PropertyNaturalKeys[];
  };

  export type OptionTitle = {
    __typename?: 'LodgingHeader';

    text?: string | null;
  };

  export type Availability = {
    __typename?: 'PropertyAvailability';

    available: boolean;

    text?: string | null;

    theme?: Theme | null;

    scarcityMessage?: string | null;
  };

  export type Price = {
    __typename?: 'PropertyPrice';

    options?: Options[] | null;

    priceMessaging?: PriceMessaging[] | null;

    lead?: Lead | null;

    disclaimer?: Disclaimer | null;

    roomNightMessage?: string | null;

    strikeOut?: StrikeOut | null;

    strikeOutType?: StrikeOutType | null;

    marketingFeeDetails?: MarketingFeeDetails | null;

    multiItemPriceToken?: string | null;
  };

  export type Options = OptionFragment.Fragment;

  export type PriceMessaging = {
    __typename?: 'LodgingEnrichedMessage';

    value: string;

    theme?: LodgingMessageTheme | null;
  };

  export type Lead = {
    __typename?: 'Money';

    formatted: string;
  };

  export type Disclaimer = {
    __typename?: 'LodgingPlainMessage';

    value: string;
  };

  export type StrikeOut = {
    __typename?: 'Money';

    formatted: string;
  };

  export type MarketingFeeDetails = {
    __typename?: 'MarketingFeeDetails';

    tierName: string;

    tierIcon: string;

    marketingFeeMessage: MarketingFeeMessage;
  };

  export type MarketingFeeMessage = {
    __typename?: 'LodgingPlainMessage';

    value: string;
  };

  export type CancellationPolicy = {
    __typename?: 'PropertyCancellationPolicy';

    type: PropertyCancellationPolicyType;

    text: string;

    cancellationWindow?: CancellationWindow | null;
  };

  export type CancellationWindow = {
    __typename?: 'ZonedDateTime';

    day: number;

    month: number;

    year: number;

    hour: number;

    minute: number;

    second: number;

    timeZoneOffsetSeconds: number;

    fullDateFormat?: string | null;
  };

  export type PriceBreakDownSummary = {
    __typename?: 'PriceSummary';

    priceSummaryHeading?: PriceSummaryHeading | null;

    sections: Sections[];

    disclaimers?: Disclaimers[] | null;
  };

  export type PriceSummaryHeading = LodgingEnrichedMessageFragment.Fragment;

  export type Sections = {
    __typename?: 'PriceSummarySection';

    sectionHeading?: SectionHeading | null;

    items: Items[];

    sectionFooter?: SectionFooter | null;
  };

  export type SectionHeading = LodgingEnrichedMessageFragment.Fragment;

  export type Items = {
    __typename?: 'PriceSummaryLineItem';

    name: Name;

    value: Value;
  };

  export type Name = {
    __typename?: 'PriceSummaryLineItemEntry';

    primaryMessage: PrimaryMessage;

    secondaryMessages?: SecondaryMessages[] | null;
  };

  export type PrimaryMessage = LodgingEnrichedMessageFragment.Fragment;

  export type SecondaryMessages = LodgingEnrichedMessageFragment.Fragment;

  export type Value = {
    __typename?: 'PriceSummaryLineItemEntry';

    primaryMessage: _PrimaryMessage;

    secondaryMessages?: _SecondaryMessages[] | null;
  };

  export type _PrimaryMessage = LodgingEnrichedMessageFragment.Fragment;

  export type _SecondaryMessages = LodgingEnrichedMessageFragment.Fragment;

  export type SectionFooter = {
    __typename?: 'PriceSummaryFooter';

    footerHeading?: FooterHeading | null;

    footerMessages?: FooterMessages[] | null;
  };

  export type FooterHeading = LodgingEnrichedMessageFragment.Fragment;

  export type FooterMessages = LodgingEnrichedMessageFragment.Fragment;

  export type Disclaimers = LodgingEnrichedMessageFragment.Fragment;

  export type DataAttributes = {
    __typename?: 'GraphQLPair';

    key: string;

    value: string;
  };

  export type FeeMessages = {
    __typename?: 'LodgingEnrichedMessage';

    value: string;
  };

  export type LoyaltyMessage = {
    __typename?: 'LodgingEnrichedMessage';

    state?: string | null;

    value: string;
  };

  export type OfferBookButton = {
    __typename?: 'LodgingForm';

    action: string;

    inputs?: Inputs[] | null;

    method: LodgingFormMethod;

    submit: Submit;
  };

  export type Inputs = LodgingTextInput.Fragment;

  export type Submit = ButtonFragment.Fragment;

  export type Deposit = MoneyFragment.Fragment;

  export type PropertyNaturalKeys = PropertyNaturalKeyFragment.Fragment;
}

export namespace PropertyNaturalKeyFragment {
  export type Fragment = {
    __typename?: 'PropertyNaturalKey';

    id: string;

    checkIn: CheckIn;

    checkOut: CheckOut;

    inventoryType: InventoryType;

    noCreditCard?: boolean | null;

    ratePlanId: string;

    ratePlanType?: string | null;

    roomTypeId: string;

    rooms: Rooms[];

    shoppingPath?: ShoppingPathType | null;
  };

  export type CheckIn = DateFragment.Fragment;

  export type CheckOut = DateFragment.Fragment;

  export type Rooms = {
    __typename?: 'PropertyRoom';

    childAges: number[];

    numberOfAdults: number;
  };
}

export namespace ButtonFragment {
  export type Fragment = {
    __typename?: 'LodgingButton';

    text: string;

    analytics?: Analytics | null;
  };

  export type Analytics = {
    __typename?: 'ClientSideAnalytics';

    linkName: string;

    referrerId: string;
  };
}

export namespace IconFragment {
  export type Fragment = {
    __typename?: 'Icon';

    description: string;

    id: string;

    size?: IconSize | null;
  };
}

export namespace MarketingSectionFragment {
  export type Fragment = {
    __typename?: 'MarketingSection';

    title?: Title | null;

    feeDetails: FeeDetails;

    feeDialog: FeeDialog;

    paymentDetails?: PaymentDetails | null;
  };

  export type Title = {
    __typename?: 'LodgingHeader';

    text?: string | null;
  };

  export type FeeDetails = {
    __typename?: 'MarketingFeeDetails';

    formattedFee?: string | null;

    marketingFeeMessage: MarketingFeeMessage;

    mark?: Mark | null;

    tierName: string;

    tierMessage: TierMessage;
  };

  export type MarketingFeeMessage = {
    __typename?: 'LodgingPlainMessage';

    value: string;
  };

  export type Mark = {
    __typename?: 'LodgingMark';

    id: string;
  };

  export type TierMessage = {
    __typename?: 'LodgingEnrichedMessage';

    value: string;

    icon?: Icon | null;

    mark?: _Mark | null;
  };

  export type Icon = {
    __typename?: 'Icon';

    id: string;

    description: string;

    size?: IconSize | null;
  };

  export type _Mark = {
    __typename?: 'LodgingMark';

    id: string;
  };

  export type FeeDialog = {
    __typename?: 'LodgingPlainDialog';

    title?: string | null;

    content: string[];

    tertiaryUIButton?: TertiaryUiButton | null;

    trigger: Trigger;
  };

  export type TertiaryUiButton = {
    __typename?: 'UITertiaryButton';

    primary?: string | null;
  };

  export type Trigger = {
    __typename?: 'LodgingDialogTriggerMessage';

    value: string;

    mark?: __Mark | null;

    icon?: _Icon | null;

    clientSideAnalytics?: ClientSideAnalytics | null;
  };

  export type __Mark = {
    __typename?: 'Mark';

    id: string;
  };

  export type _Icon = {
    __typename?: 'Icon';

    id: string;

    size?: IconSize | null;
  };

  export type ClientSideAnalytics = {
    __typename?: 'ClientSideAnalytics';

    linkName: string;

    referrerId: string;
  };

  export type PaymentDetails = {
    __typename?: 'LodgingEnrichedMessage';

    icon?: __Icon | null;

    value: string;
  };

  export type __Icon = {
    __typename?: 'Icon';

    id: string;
  };
}

export namespace LodgingTextInput {
  export type Fragment = {
    __typename?: 'LodgingTextInput';

    name?: string | null;

    type?: LodgingInputType | null;

    value?: string | null;
  };
}

export namespace PaymentPolicyFragment {
  export type Fragment = {
    __typename?: 'PropertyPaymentPolicyInfo';

    paymentType: PropertyPaymentType;

    heading: string;

    descriptions: Descriptions[];
  };

  export type Descriptions = {
    __typename?: 'PropertyInfoContent';

    heading?: string | null;

    items: Items[];
  };

  export type Items = {
    __typename?: 'PropertyInfoItem';

    text: string;
  };
}

export namespace OptionFragment {
  export type Fragment = {
    __typename?: 'PropertyPriceOption';

    disclaimer?: Disclaimer | null;

    priceDisclaimer?: PriceDisclaimer | null;

    displayPrice?: DisplayPrice | null;

    leadingCaption?: string | null;

    loyaltyPrice?: LoyaltyPrice | null;

    strikeOut?: StrikeOut | null;

    accessibilityLabel?: string | null;
  };

  export type Disclaimer = LodgingPlainMessageFragment.Fragment;

  export type PriceDisclaimer = LodgingPlainDialogFragment.Fragment;

  export type DisplayPrice = MoneyFragment.Fragment;

  export type LoyaltyPrice = {
    __typename?: 'LoyaltyPrice';

    amount?: Amount | null;

    totalStrikeOutPoints?: TotalStrikeOutPoints | null;

    unit?: string | null;
  };

  export type Amount = {
    __typename?: 'FormattedNumber';

    formatted: string;

    raw: number;
  };

  export type TotalStrikeOutPoints = {
    __typename?: 'FormattedNumber';

    formatted: string;
  };

  export type StrikeOut = MoneyFragment.Fragment;
}

export namespace LodgingEnrichedMessageFragment {
  export type Fragment = {
    __typename?: 'LodgingEnrichedMessage';

    icon?: Icon | null;

    label?: string | null;

    mark?: Mark | null;

    theme?: LodgingMessageTheme | null;

    subText?: string | null;

    value: string;
  };

  export type Icon = {
    __typename?: 'Icon';

    id: string;

    description: string;

    size?: IconSize | null;
  };

  export type Mark = {
    __typename?: 'LodgingMark';

    id: string;

    description: string;
  };
}

export namespace LodgingPlainMessageFragment {
  export type Fragment = {
    __typename?: 'LodgingPlainMessage';

    value: string;
  };
}

export namespace LodgingPlainDialogFragment {
  export type Fragment = {
    __typename?: 'LodgingPlainDialog';

    content: string[];

    primaryButton?: PrimaryButton | null;

    secondaryButton?: SecondaryButton | null;

    tertiaryButton?: TertiaryButton | null;

    primaryUIButton?: PrimaryUiButton | null;

    secondaryUIButton?: SecondaryUiButton | null;

    title?: string | null;

    toolbar?: Toolbar | null;

    trigger: Trigger;
  };

  export type PrimaryButton = ButtonFragment.Fragment;

  export type SecondaryButton = ButtonFragment.Fragment;

  export type TertiaryButton = ButtonFragment.Fragment;

  export type PrimaryUiButton = UiPrimaryButtonFragment.Fragment;

  export type SecondaryUiButton = {
    __typename?: 'UISecondaryButton';

    primary?: string | null;
  };

  export type Toolbar = LodgingDialogToolbarFragment.Fragment;

  export type Trigger = LodgingDialogTriggerMessageFragment.Fragment;
}

export namespace UiPrimaryButtonFragment {
  export type Fragment = {
    __typename?: 'UIPrimaryButton';

    action?: Action | null;

    primary?: string | null;
  };

  export type Action = {
    __typename?: UiLinkActionInlineFragment['__typename'];

    analytics: Analytics;
  } & UiLinkActionInlineFragment;

  export type Analytics = {
    __typename?: 'ClientSideAnalytics';

    linkName: string;

    referrerId: string;
  };

  export type UiLinkActionInlineFragment = {
    __typename?: 'UILinkAction';

    resource: Resource;
  };

  export type Resource = {
    __typename?: 'URI';

    value: string;
  };
}

export namespace LodgingPlainFullscreenDialogFragment {
  export type Fragment = {
    __typename?: 'LodgingPlainDialog';

    content: string[];

    trigger: Trigger;

    toolbar?: Toolbar | null;
  };

  export type Trigger = {
    __typename?: 'LodgingDialogTriggerMessage';

    clientSideAnalytics?: ClientSideAnalytics | null;

    icon?: Icon | null;

    theme?: LodgingMessageTheme | null;

    value: string;
  };

  export type ClientSideAnalytics = {
    __typename?: 'ClientSideAnalytics';

    linkName: string;

    referrerId: string;
  };

  export type Icon = {
    __typename?: 'Icon';

    description: string;

    id: string;
  };

  export type Toolbar = {
    __typename?: 'LodgingDialogToolbar';

    title?: string | null;

    icon?: _Icon | null;

    clientSideAnalytics?: _ClientSideAnalytics | null;
  };

  export type _Icon = {
    __typename?: 'Icon';

    description: string;
  };

  export type _ClientSideAnalytics = {
    __typename?: 'ClientSideAnalytics';

    linkName: string;

    referrerId: string;
  };
}

export namespace LodgingDialogToolbarFragment {
  export type Fragment = {
    __typename?: 'LodgingDialogToolbar';

    icon?: Icon | null;

    title?: string | null;
  };

  export type Icon = IconFragment.Fragment;
}

export namespace LodgingDialogTriggerMessageFragment {
  export type Fragment = {
    __typename?: 'LodgingDialogTriggerMessage';

    clientSideAnalytics?: ClientSideAnalytics | null;

    icon?: Icon | null;

    theme?: LodgingMessageTheme | null;

    value: string;

    secondaryValue?: string | null;
  };

  export type ClientSideAnalytics = ClientSideAnalyticsFragment.Fragment;

  export type Icon = IconFragment.Fragment;
}

export namespace ClientSideAnalyticsFragment {
  export type Fragment = {
    __typename?: 'ClientSideAnalytics';

    linkName: string;

    referrerId: string;
  };
}

export namespace MoneyFragment {
  export type Fragment = {
    __typename?: 'Money';

    amount: number;

    currencyInfo?: CurrencyInfo | null;

    formatted: string;
  };

  export type CurrencyInfo = CurrencyFragment.Fragment;
}

export namespace CurrencyFragment {
  export type Fragment = {
    __typename?: 'Currency';

    code: string;

    name: string;

    symbol: string;
  };
}

export namespace AlternateDateOptionFragment {
  export type Fragment = {
    __typename?: 'AlternateDateOption';

    dates: Dates;

    price?: Price | null;
  };

  export type Dates = {
    __typename?: 'LodgingLinkMessage';

    link: Link;

    value: string;
  };

  export type Link = {
    __typename?: 'LodgingLink';

    uri: Uri;

    referrerId?: string | null;
  };

  export type Uri = {
    __typename?: 'HttpURI';

    relativePath: string;
  };

  export type Price = {
    __typename?: 'PropertyPriceOption';

    displayPrice?: DisplayPrice | null;
  };

  export type DisplayPrice = {
    __typename?: 'Money';

    formatted: string;
  };
}

export namespace TripSummaryFragment {
  export type Fragment = {
    __typename?: 'TripSummaryContent';

    header: Header;

    summary: Summary[];

    price: Price;
  };

  export type Header = {
    __typename?: 'LodgingHeader';

    text?: string | null;
  };

  export type Summary = {
    __typename?: 'LodgingEnrichedMessage';

    value: string;
  };

  export type Price = {
    __typename?: 'PropertyPrice';

    options?: Options[] | null;

    priceMessaging?: PriceMessaging[] | null;
  };

  export type Options = {
    __typename?: 'PropertyPriceOption';

    displayPrice?: DisplayPrice | null;

    strikeOut?: StrikeOut | null;

    accessibilityLabel?: string | null;
  };

  export type DisplayPrice = {
    __typename?: 'Money';

    formatted: string;
  };

  export type StrikeOut = {
    __typename?: 'Money';

    formatted: string;
  };

  export type PriceMessaging = {
    __typename?: 'LodgingEnrichedMessage';

    value: string;
  };
}

export namespace CancellationPolicyDialogFragment {
  export type Fragment = {
    __typename?: 'RateCategorization';

    cancellationPolicyDialog?: CancellationPolicyDialog | null;
  };

  export type CancellationPolicyDialog = {
    __typename?: 'LodgingCancellationPolicyDialog';

    content: Content[];

    toolbar?: Toolbar | null;

    trigger: Trigger;
  };

  export type Content = {
    __typename?: 'CancellationPolicyDialogContentEntry';

    entryContent: string[];

    entryTitle: EntryTitle;
  };

  export type EntryTitle = {
    __typename?: 'LodgingHeader';

    text?: string | null;
  };

  export type Toolbar = {
    __typename?: 'LodgingDialogToolbar';

    title?: string | null;

    icon?: Icon | null;

    clientSideAnalytics?: ClientSideAnalytics | null;
  };

  export type Icon = {
    __typename?: 'Icon';

    description: string;
  };

  export type ClientSideAnalytics = {
    __typename?: 'ClientSideAnalytics';

    linkName: string;

    referrerId: string;
  };

  export type Trigger = {
    __typename?: 'LodgingDialogTriggerMessage';

    value: string;

    icon?: _Icon | null;

    clientSideAnalytics?: _ClientSideAnalytics | null;
  };

  export type _Icon = {
    __typename?: 'Icon';

    id: string;

    description: string;
  };

  export type _ClientSideAnalytics = {
    __typename?: 'ClientSideAnalytics';

    linkName: string;

    referrerId: string;
  };
}

export namespace SingleOfferFragment {
  export type Fragment = {
    __typename?: 'SingleUnitOfferDetails';

    availabilityCallToAction?: AvailabilityCallToAction | null;

    displayPrice?: DisplayPrice | null;

    id: string;

    ratePlans?: (RatePlans | null)[] | null;

    totalPrice?: TotalPrice | null;
  };

  export type AvailabilityCallToAction = LodgingPlainMessageInlineFragment | LodgingButtonInlineFragment;

  export type LodgingPlainMessageInlineFragment = {
    __typename?: 'LodgingPlainMessage';

    value: string;
  };

  export type LodgingButtonInlineFragment = {
    __typename?: 'LodgingButton';

    text: string;
  };

  export type DisplayPrice = {
    __typename?: 'DisplayPriceSummaryItem';

    leadPrice?: LeadPrice | null;

    priceLabel?: PriceLabel | null;

    priceMessages?: PriceMessages[] | null;
  };

  export type LeadPrice = LodgingEnrichedMessageFragment.Fragment;

  export type PriceLabel = LodgingEnrichedMessageFragment.Fragment;

  export type PriceMessages = LodgingEnrichedMessageFragment.Fragment;

  export type RatePlans = RatePlanFragment.Fragment;

  export type TotalPrice = {
    __typename?: 'TotalPriceSummary';

    amount?: Amount | null;

    label?: Label | null;
  };

  export type Amount = LodgingEnrichedMessageFragment.Fragment;

  export type Label = LodgingEnrichedMessageFragment.Fragment;
}
